<template>
  <div :class="[pageClass, 'pa-6 d-flex flex-column gap-6']" data-testid="gl-breakdown">
    <!-- Breadcrumbs block -->
    <Breadcrumbs
      :glCodeText="glCodeText"
      :glCodeInfo="glCodeInfo"
      :activeCommentary="activeCommentary"
      :getStatusLabel="getStatusLabel"
      :isRefreshing="isReportingUnitdataloading"
      :showRefresh="true"
      :conversationOptions="breadcrumbsConversationOptions"
      :activityLogOptions="breadcrumbsActivityLogOptions"
      :requestCommentaryOptions="breadcrumbsRequestCommentaryOptions"
      :reportingType="reportingType"
      :isSodEnabled="isSodEnabled"
      :ruRoleOptions="ruRoleOptions"
      :selectedRuRole="selectedRuRole"
      :alluserassigned="alluserassigned"
      :ispreparer="ispreparer"
      :isapprover="isapprover"
      :isregionalapprover="isregionalapprover"
      :ismanager="ismanager"
      :isviewonly="isviewonly"
      :isActionInProgress="isActionInProgress"
      @back="handleBack"
      @refresh="handleRefresh"
      @mark-conversation-read="handleMarkConversationRead"
      @update:selected-ru-role="handleRoleChange"
      @request-commentary="handleBreadcrumbsRequestCommentary"
    />

    <div :class="[contentClass, 'd-flex flex-column gap-6']">
      <!-- Summary Section -->
      <v-card
        class="summary-card d-flex flex-column gap-3"
        elevation="1"
        data-testid="gl-breakdown__summary-card"
      >
        <div
          class="summary-card__header"
          role="button"
          tabindex="0"
          :aria-expanded="isSummaryExpanded.toString()"
          aria-controls="gl-breakdown__summary-content"
          data-testid="gl-breakdown__summary-toggle"
          @click="toggleSummaryAccordion"
          @keyup.enter.prevent="toggleSummaryAccordion"
          @keyup.space.prevent="toggleSummaryAccordion"
        >
          <h4 class="summary-card__title">Variance analysis summary</h4>
          <v-icon small>{{ isSummaryExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </div>
        <v-expand-transition>
          <div
            v-if="isSummaryExpanded"
            class="summary-card__body d-flex flex-column gap-3"
            id="gl-breakdown__summary-content"
            data-testid="gl-breakdown__summary-content"
          >
            <template v-if="summaryData">
              <v-divider />
              <div :class="summaryGridClass">
                <div class="summary-panel d-flex flex-column gap-3">
                  <h5 class="summary-panel__title">
                    {{ summaryData.actualLabel }} Vs {{ summaryData.proformaLabel }}
                  </h5>
                  <CrossedMaterialityLegend
                    :local-control-crossed="selectedcommentary.var1_cross_control"
                    :local-management-crossed="selectedcommentary.var1_cross_management"
                    :regional-control-crossed="selectedcommentary.var1_cross_control_regional"
                    :regional-management-crossed="selectedcommentary.var1_cross_management_regional"
                  />
                  <SummaryMetrics
                    :actualLabel="summaryData.actualLabel"
                    :compareLabel="summaryData.proformaLabel"
                    :actualAmount="summaryData.actualAmount"
                    :compareAmount="summaryData.proformaAmount"
                    :varianceAmount="summaryData.proformaVarianceAmount"
                    :variancePercent="summaryData.proformaVariancePercent"
                    :formatCurrency="formatCurrency"
                    :formatPercent="formatPercent"
                    :varianceClass="varianceClass"
                  />
                </div>

                <div class="summary-panel d-flex flex-column gap-3">
                  <h5 class="summary-panel__title">
                    {{ summaryData.actualLabel }} Vs {{ summaryData.forecastLabel }}
                  </h5>
                  <CrossedMaterialityLegend
                    :local-control-crossed="selectedcommentary.var2_cross_control"
                    :local-management-crossed="selectedcommentary.var2_cross_management"
                    :regional-control-crossed="selectedcommentary.var2_cross_control_regional"
                    :regional-management-crossed="selectedcommentary.var2_cross_management_regional"
                  />
                  <SummaryMetrics
                    :actualLabel="summaryData.actualLabel"
                    :compareLabel="summaryData.forecastLabel"
                    :actualAmount="summaryData.actualAmount"
                    :compareAmount="summaryData.forecastAmount"
                    :varianceAmount="summaryData.forecastVarianceAmount"
                    :variancePercent="summaryData.forecastVariancePercent"
                    :formatCurrency="formatCurrency"
                    :formatPercent="formatPercent"
                    :varianceClass="varianceClass"
                  />
                </div>
              </div>
            </template>
          </div>
        </v-expand-transition>
      </v-card>

        <!-- Commentary AI Section -->
        <!-- <GenAICommentarySection
          :isEnabled="$store.state.aiEnabled && commentaryGenAiBtntab"
          :valueProforma.sync="aiProforma"
          :valueForecast.sync="aiForecast"
          :loadingProforma="aiLoadingProforma"
          :loadingForecast="aiLoadingForecast"
          :isTyping="isTyping"
          :isThresholdExceeded="isThresholdExceedCommentary"
          proformaLabel="Local Commentary (Vs Proforma)"
          forecastLabel="Local Commentary (Vs Forecast)"
          @generate-ai="handleGenerateAISection"
        /> -->


      <!-- Tab Navigation -->
      <v-card elevation="1" class="gl-breakdown-card" data-testid="gl-breakdown-card">
        <div :class="inlineContentClasses" data-testid="gl-breakdown__commentary-tabs">
          <template v-if="inlineShowInternalTabs">
            <v-tabs
              v-model="slTab"
              background-color="transparent"
              class="gl-breakdown__tabs"
              data-testid="gl-breakdown__tabs"
              height="40"
            >
              <v-tab
                v-for="tab in tabItems"
                :key="tab.key"
                :class="tab.headerClass"
                :data-testid="tab.testId"
              >
                {{ tab.label }}
              </v-tab>
            </v-tabs>
            <v-divider></v-divider>
          </template>

          <v-tabs-items v-model="slTab" data-testid="gl-breakdown__tab-items" class="gl-breakdown__tab-items mt-3">
            <v-tab-item
              v-for="(tab, index) in tabItems"
              :key="tab.key"
              :eager="tab.eager"
              :data-testid="'gl-breakdown__tab-content-' + tab.key"
            >
              <!-- Commentary Tab Content -->
              <template v-if="tab.key === 'commentary'">
              <template v-if="isReportingUnitdataloading">
                <div class="sl-commentary-shimmer">
                  <v-skeleton-loader type="heading" class="mb-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text@3" class="mb-4"></v-skeleton-loader>
                  <v-skeleton-loader type="paragraph" class="mb-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text@2" class="mb-4"></v-skeleton-loader>
                  <div class="d-flex gap-3 mb-4">
                    <v-skeleton-loader type="button" width="120"></v-skeleton-loader>
                    <v-skeleton-loader type="button" width="120"></v-skeleton-loader>
                  </div>
                  <v-skeleton-loader type="text@4"></v-skeleton-loader>
                </div>
              </template>
              <template v-else>
                <div class="sl-commentary-card position-relative" data-testid="gl-breakdown__commentary-card">
                  <!-- Action overlay on commentary card -->
                  <v-overlay
                    :value="isActionInProgress"
                    absolute
                    z-index="2"
                    opacity="0.2"
                    color="#fff"
                    data-testid="gl-breakdown__action-overlay"
                  >
                    <div class="d-flex flex-column align-center justify-center">
                      <v-progress-circular
                        indeterminate
                        size="48"
                        width="4"
                        color="primary"
                        data-testid="gl-breakdown__action-loader"
                      ></v-progress-circular>
                      <span class="mt-3 text-body-1 font-weight-medium primary--text">Processing...</span>
                    </div>
                  </v-overlay>
                  <CommentaryMainTab
                    context-type="glbreakdown"
                    :bulksubmit="bulksubmit"
                    :bulktype="bulktype"
                    :selectedcommentary="selectedcommentary"
                    :multiselectdata="multiselectdata"
                    :cycletype="cycletype"
                    :commentary_local_key_label="commentary_local_key_label"
                    :commentary_regional_key_label="commentary_regional_key_label"
                    :workflowtext="workflowtext"
                    :workflows="workflows"
                    :tablecolors="tablecolors"
                    :ispreparer="ispreparer"
                    :isapprover="isapprover"
                    :isregionalapprover="isregionalapprover"
                    :cyclestage="cyclestage"
                    :commentarySubmitDialogueViewMode="commentarySubmitDialogueViewMode"
                    :localCommentaryGenAiBtntab="commentaryGenAiBtntab"
                    :isRegionalCommentaryAutomationEnabled="isRegionalCommentaryAutomationEnabled"
                    :isGlMandatoryRequestFlag="isGlMandatoryRequestFlag"
                    :replaceExistingCommentFlag="replaceExistingCommentFlag"
                    :lastActionsOnGL="lastActionsOnGL"
                    :isTyping="isTyping"
                    :loadingtext1="loadingtext1"
                    :loadingtext2="loadingtext2"
                    :isThresholdExceedLocalCommentary="isThresholdExceedLocalCommentary"
                    :bulkcommentall="bulkcommentall"
                    :bulkcommentreplace="bulkcommentreplace"
                    :requestcommentarylocalcontrol="requestcommentarylocalcontrol"
                    :requestcommentarylocalmanagement="requestcommentarylocalmanagement"
                    :requestcommentaryregionalcontrol="requestcommentaryregionalcontrol"
                    :requestcommentaryregionalmanagement="requestcommentaryregionalmanagement"
                    :requestcommentarylocalcontrolvsProforma="requestcommentarylocalcontrolvsProforma"
                    :requestcommentarylocalcontrolvsForecast="requestcommentarylocalcontrolvsForecast"
                    :requestcommentarylocalmanagementvsProforma="requestcommentarylocalmanagementvsProforma"
                    :requestcommentarylocalmanagementvsForecast="requestcommentarylocalmanagementvsForecast"
                    :requestcommentaryregionalcontrolvsProforma="requestcommentaryregionalcontrolvsProforma"
                    :requestcommentaryregionalmanagementvsProforma="requestcommentaryregionalmanagementvsProforma"
                    :requestcommentaryregionalcontrolvsForecast="requestcommentaryregionalcontrolvsForecast"
                    :requestcommentaryregionalmanagementvsForecast="requestcommentaryregionalmanagementvsForecast"
                    :attachmentfile="attachmentfile"
                    :attachmentfileloading="attachmentfileloading"
                    :attachmentfilepercentage="attachmentfilepercentage"
                    :isLocalCommentaryCollapsed="isLocalCommentaryCollapsed"
                    :isLocalCommentaryReasonCollapsed="isLocalCommentaryReasonCollapsed"
                    :validationErrorField="validationErrorField"
                    :actualLabel="actualLabel"
                    :proformaLabel="proformaLabel"
                    :forecastLabel="forecastLabel"
                    :saveRegionalReasonLoading="saveRegionalReasonLoading"
                    :saveLocalReasonLoading="saveLocalReasonLoading"
                    :saveLocalCommentaryLoading="saveLoading"
                    :saveLocalCommentaryField="saveLocalCommentaryField"
                    :saveRegionalCommentaryLoading="saveLoading"
                    :saveRegionalCommentaryField="saveRegionalCommentaryField"
                    :commentaryBaselines="commentaryBaselines"
                    :commentaryBaselinesReady="commentaryBaselinesReady"
                    @update:bulkcommentall="forward('update:bulkcommentall', $event)"
                    @update:bulkcommentreplace="forward('update:bulkcommentreplace', $event)"
                    @update:requestcommentarylocalcontrol="forward('update:requestcommentarylocalcontrol', $event)"
                    @update:requestcommentarylocalmanagement="forward('update:requestcommentarylocalmanagement', $event)"
                    @update:requestcommentaryregionalcontrol="forward('update:requestcommentaryregionalcontrol', $event)"
                    @update:requestcommentaryregionalmanagement="forward('update:requestcommentaryregionalmanagement', $event)"
                    @update:requestcommentarylocalcontrolvsProforma="forward('update:requestcommentarylocalcontrolvsProforma', $event)"
                    @update:requestcommentarylocalcontrolvsForecast="forward('update:requestcommentarylocalcontrolvsForecast', $event)"
                    @update:requestcommentarylocalmanagementvsProforma="forward('update:requestcommentarylocalmanagementvsProforma', $event)"
                    @update:requestcommentarylocalmanagementvsForecast="forward('update:requestcommentarylocalmanagementvsForecast', $event)"
                    @update:requestcommentaryregionalcontrolvsProforma="forward('update:requestcommentaryregionalcontrolvsProforma', $event)"
                    @update:requestcommentaryregionalmanagementvsProforma="forward('update:requestcommentaryregionalmanagementvsProforma', $event)"
                    @update:requestcommentaryregionalcontrolvsForecast="forward('update:requestcommentaryregionalcontrolvsForecast', $event)"
                    @update:requestcommentaryregionalmanagementvsForecast="forward('update:requestcommentaryregionalmanagementvsForecast', $event)"
                    @update:attachmentfile="forward('update:attachmentfile', $event)"
                    @toggle-local-commentary-collapse="toggleLocalCommentaryCollapse"
                    @toggle-local-commentary-reason-collapse="toggleLocalCommentaryReasonCollapse"
    @generate-ai="handleGenerateAI"
    @attachment-change="handleAttachmentChange"
    @save-regional-reason="saveRegionalApprovalReason"
    @save-local-reason="saveLocalApprovalReason"
    @save-local-commentary="saveCommentary"
    @save-regional-commentary="saveRegionalCommentary"
    @commentary-display-ready="captureCommentaryBaselines"
  />
                  
                  <!-- Action Buttons for SL Breakup Commentary Tab -->
                  <div 
                    v-if="commentarySubmitDialogueViewMode !== true && selectedcommentary && selectedcommentary._id" 
                    class="d-flex align-center justify-end gap-2 mt-4 pt-4 border-top"
                    data-testid="gl-breakdown__commentary-actions"
                  >
                    <!-- SOD Warning Messages -->

                    <div
                      v-if="isSodEnabled && selectedcommentary.__myaction === 'localapprove' && selectedcommentary.localsubmitby === userid"
                      class="error--text mr-auto"
                    >
                      {{ $nova.labelsName('cycle_page', 'commentary_local_preparer_label', 'Local Preparer') }} and the
                      {{ $nova.labelsName('cycle_page', 'commentary_local_approver_label', 'Local Approver') }} cannot be same person.
                    </div>
                    <div
                      v-else-if="
                        isSodEnabled &&
                        (selectedcommentary.__myaction === 'regionalapprove' || isregionalapprover) &&
                        selectedcommentary.regionalsubmitby === userid
                      "
                      class="error--text mr-auto"
                    >
                      Regional Preparer and the
                      {{ $nova.labelsName('cycle_page', 'commentary_regional_approver_label', 'Regional Approver') }} cannot be same person.
                    </div>
                    <v-spacer v-else></v-spacer>

                    <!-- Approve/Reject Buttons (for Approvers) -->
                    <template
                      v-if="
                        selectedcommentary.__myaction === 'localapprove' ||
                        selectedcommentary.__myaction === 'regionalapprove' ||
                        (isregionalapprover && selectedcommentary.stage_local === 2 && selectedcommentary.stage_regional === 1) ||
                        (isapprover && bulksubmit) ||
                        toggleview === 3
                      "
                    >
                      <v-btn
                        v-if="isRegionalCommentaryAutomationEnabled && isapprover"
                        class="mr-1"
                        @click="approveCommentary"
                        color="primary"
                        data-testid="gl-breakdown__approve-submit-btn"
                        :loading="approveLoading"
                      >
                        <span>{{ $nova.labelsName('cycle_page', 'commentary_approve_submit_label', 'Approve and Submit') }}</span>
                      </v-btn>
                      <v-btn 
                        v-else 
                        class="mr-1" 
                        @click="approveCommentary" 
                        color="primary"
                        :loading="approveLoading"
                        data-testid="gl-breakdown__approve-btn"
                      >
                        <span>{{ $nova.labelsName('cycle_page', 'commentary_approve_label', 'Approve') }}</span>
                      </v-btn>
                      <!-- Reject button with target selection menu for regional approvers -->
                      <v-menu 
                        data-testid="gl-breakdown__reject-menu" 
                        offset-y 
                        v-model="rejectCommentaryMenu" 
                        :close-on-content-click="false" 
                        transition="slide-y-transition" 
                        v-if="isregionalapprover"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn 
                            data-testid="gl-breakdown__reject-button-regional" 
                            v-bind="attrs" 
                            v-on="on" 
                            color="error"
                            :loading="rejectLoading"
                          >
                            <v-icon data-testid="gl-breakdown__reject-button-icon" left small>mdi-close-circle-outline</v-icon>
                            <span>{{ $nova.labelsName('cycle_page', 'commentary_reject_label', 'Reject') }}</span>
                            <v-icon data-testid="gl-breakdown__reject-button-chevron" right small>mdi-chevron-down</v-icon>
                          </v-btn>
                        </template>
                        <v-card data-testid="gl-breakdown__reject-menu-card" min-width="200" class="elevation-8 rounded-lg">
                          <div data-testid="gl-breakdown__reject-menu-header" class="pa-3 error lighten-5">
                            <div class="d-flex align-center">
                              <v-icon data-testid="gl-breakdown__reject-menu-header-icon" color="error" class="mr-2">mdi-alert-circle</v-icon>
                              <span data-testid="gl-breakdown__reject-menu-header-title" class="font-weight-bold error--text">Select Rejection Target</span>
                            </div>
                          </div>
                          <v-divider></v-divider>
                          <v-list data-testid="gl-breakdown__reject-target-list" dense class="py-1">
                            <v-list-item 
                              :data-testid="`gl-breakdown__reject-target-item-${index}`"
                              v-for="(target, index) in rejectTargetList" 
                              :key="index"
                              @click="handleRejectWithTarget(target._id)"
                              class="cursor-pointer rejection-target-item mx-2 my-1 rounded"
                            >
                              <v-list-item-icon class="mr-3 my-auto">
                                <v-icon data-testid="gl-breakdown__reject-target-item-icon" color="error lighten-1" small>mdi-account-arrow-left</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title data-testid="gl-breakdown__reject-target-item-name" class="subtitle-2 font-weight-medium">{{ target.name }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-menu>
                      <!-- Simple reject button for non-regional approvers -->
                      <v-btn 
                        data-testid="gl-breakdown__reject-button-simple" 
                        v-else 
                        @click="rejectCommentary" 
                        color=""
                        class="rejectBtn"
                        :loading="rejectLoading"
                      >
                        <span>{{ $nova.labelsName('cycle_page', 'commentary_reject_label', 'Reject') }}</span>
                      </v-btn>
                    </template>

                    <!-- Save/Submit Buttons (for Preparers) -->
                    <template
                      v-if="
                        selectedcommentary.__myaction === 'localadd' ||
                        (isRegionalPreparer && selectedcommentary.__myaction === 'regionaladd') ||
                        selectedcommentary.__myaction === 'localvoluntary' ||
                        (isRegionalPreparer && selectedcommentary.__myaction === 'regionalvoluntary') ||
                        (ispreparer && bulksubmit)
                      "
                    >
                      <v-btn
                        v-if="bulksubmit && ispreparer && slTab === 0"
                        @click="saveCommentary"
                        class="mr-1 secondaryBtn"
                        :loading="saveLoading"
                        :disabled="!workflows.lcp && !workflows.lmp && !workflows.lcf && !workflows.lmf"
                        data-testid="gl-breakdown__save-btn"
                      >
                        <span>Save</span>
                      </v-btn>
                      <v-btn
                        v-if="slTab === 0"
                        @click="addCommentary"
                        color="primary"
                        :loading="submitLoading"
                        :disabled="
                          (isapprover && !workflows.rcp && !workflows.rmp && !workflows.rcf && !workflows.rmf) ||
                          (ispreparer && !workflows.lcp && !workflows.lmp && !workflows.lcf && !workflows.lmf)
                        "
                        data-testid="gl-breakdown__submit-btn"
                      >
                        <span>Submit</span>
                      </v-btn>
                    </template>
                  </div>
                 
                </div>
              </template>
              </template>

              <!-- Trendline Tab Content -->
              <template v-else-if="tab.key === 'trendline'">
              <template v-if="isReportingUnitdataloading">
                <div class="sl-commentary-shimmer">
                  <v-skeleton-loader type="heading" class="mb-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text@3" class="mb-4"></v-skeleton-loader>
                  <v-skeleton-loader type="paragraph" class="mb-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text@2" class="mb-4"></v-skeleton-loader>
                  <div class="d-flex gap-3 mb-4">
                    <v-skeleton-loader type="button" width="120"></v-skeleton-loader>
                    <v-skeleton-loader type="button" width="120"></v-skeleton-loader>
                  </div>
                  <v-skeleton-loader type="text@4"></v-skeleton-loader>
                </div>
              </template>
              <template v-else>
                <div class="sl-commentary-card" data-testid="gl-breakdown__commentary-trendline-card">
                  <CommentaryTrendlineTab
                    v-bind="commentaryTrendlineTabProps"
                    data-testid="gl-breakdown__commentary-trendline"
                    :actualLabel="actualLabel"
                    :proformaLabel="proformaLabel"
                    :forecastLabel="forecastLabel"

                  />
                </div>
              </template>
              </template>

              <!-- Evidence Tab Content -->
              <template v-else-if="tab.key === 'evidence'">
              <div class="pa-4">
                <template v-if="isReportingUnitdataloading">
                  <div class="sl-evidence-shimmer">
                    <v-skeleton-loader type="heading" class="mb-4"></v-skeleton-loader>
                    <v-skeleton-loader type="image" height="200" class="mb-4"></v-skeleton-loader>
                    <v-skeleton-loader type="text@2"></v-skeleton-loader>
                  </div>
                </template>
                <template v-else>
                  <div class="sl-evidence-card" data-testid="gl-breakdown__evidence-card">
                    <!-- Evidence Component with file upload functionality -->
                    <Evidence
                      v-if="selectedcommentary._id && (workflows.lcp || workflows.lcf || workflows.lmp || workflows.lmf)"
                      :commentary-id="selectedcommentary._id"
                      :cycletype="cycletype"
                      :reporting-type="reportingType || ''"
                      :uploads="selectedcommentary.uploads || []"
                      :upload-details="selectedcommentary.upload_details || []"
                      :legacy-upload-id="selectedcommentary.upload || ''"
                      :view-mode="!(selectedcommentary.__myaction === 'localadd' ||
                        selectedcommentary.__myaction === 'localapprove' ||
                        selectedcommentary.__myaction === 'regionaladd' ||
                        selectedcommentary.__myaction === 'localvoluntary' ||
                        selectedcommentary.__myaction === 'regionalvoluntary' ||
                        (ispreparer && bulksubmit))"
                      :disable-download="selectedcommentary.__myaction === (ispreparer && bulksubmit) || (isapprover && bulksubmit)"
                      :user-id="currentUserId"
                      :user-role="currentUserRole"
                      :user-name="$store.state.user?.name || ''"
                      :user-email="$store.state.user?.email || ''"
                      @upload-success="handleEvidenceUploadSuccess"
                      data-testid="gl-breakdown__evidence"
                    />
                    <!-- No access state -->
                    <div
                      v-else-if="!workflows.lcp && !workflows.lcf && !workflows.lmp && !workflows.lmf"
                      class="text-center py-8"
                      data-testid="gl-breakdown__evidence-no-access"
                    >
                      <v-icon size="64" color="grey lighten-1">mdi-lock-outline</v-icon>
                      <p class="text-body-2 grey--text mt-3">No workflow access to upload evidence</p>
                    </div>
                  </div>
                </template>
              </div>
              </template>

              <!-- Drilldown Tab Content -->
              <template v-else-if="tab.key === 'drilldown'">
                <!-- SLBreakup handles all SL data loading and operations independently -->
                <!-- Only render when drilldown tab is active to prevent API call on page load -->
                <SLBreakup 
                  v-if="currentTabKey === 'drilldown'"
                  ref="slBreakupRef"
                  :type="currentType" 
                  :actualLabel="actualLabel" 
                  :proformaLabel="proformaLabel" 
                  :forecastLabel="forecastLabel"
                  @refresh-gl-details="loadGLDetails(true)"
                  data-testid="gl-breakdown__sl-breakup"
                />
              </template>

              <!-- Summary Tab Content -->
              <template v-else-if="tab.key === 'summary'">
              <template v-if="isReportingUnitdataloading">
                <div class="sl-commentary-shimmer">
                  <v-skeleton-loader type="heading" class="mb-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text@3" class="mb-4"></v-skeleton-loader>
                  <v-skeleton-loader type="paragraph" class="mb-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text@2" class="mb-4"></v-skeleton-loader>
                  <div class="d-flex gap-3 mb-4">
                    <v-skeleton-loader type="button" width="120"></v-skeleton-loader>
                    <v-skeleton-loader type="button" width="120"></v-skeleton-loader>
                  </div>
                  <v-skeleton-loader type="text@4"></v-skeleton-loader>
                </div>
              </template>
              <template v-else>
                <div class="sl-commentary-card" data-testid="gl-breakdown__commentary-summary-card">
                  <CommentarySummaryTab
                    v-bind="commentarySummaryTabProps"
                    v-on="commentarySummaryTabListeners"
                    data-testid="gl-breakdown__commentary-summary"
                  />
                </div>
              </template>
              </template>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-card>

      </div>

    <!-- Request Commentary Dialog -->
    <request-commentary-dialog
      v-if="requestcommentarydialog"
      v-model="requestcommentarydialog"
      :heading="bulksubmit ? 'Bulk Request Commentary' : 'Request Commentary'"
      :width="800"
      :loading="requestcommentaryloading"
      :bulksubmit="bulksubmit"
      :multiselectcount="multiselectdata.length"
      :selectedcommentary="selectedcommentary"
      :isapprover="isapprover"
      :isregionalapprover="isregionalapprover"
      :workflowtext="workflowtext"
      :workflows="workflows"
      :local-controls-label="local_controls_label"
      :local-management-label="local_management_label"
      :regional-controls-label="regional_controls_label"
      :regional-management-label="regional_management_label"
      :proforma-label="proformaLabel"
      :forecast-label="forecastLabel"
      :requestcommentarylocalcontrolvsProforma="requestcommentarylocalcontrolvsProforma"
      :requestcommentarylocalmanagementvsProforma="requestcommentarylocalmanagementvsProforma"
      :requestcommentarylocalcontrolvsForecast="requestcommentarylocalcontrolvsForecast"
      :requestcommentarylocalmanagementvsForecast="requestcommentarylocalmanagementvsForecast"
      :requestcommentaryregionalcontrolvsProforma="requestcommentaryregionalcontrolvsProforma"
      :requestcommentaryregionalmanagementvsProforma="requestcommentaryregionalmanagementvsProforma"
      :requestcommentaryregionalcontrolvsForecast="requestcommentaryregionalcontrolvsForecast"
      :requestcommentaryregionalmanagementvsForecast="requestcommentaryregionalmanagementvsForecast"
      @request="requestCommentary"
      @update:requestcommentarylocalcontrolvsProforma="val => (requestcommentarylocalcontrolvsProforma = val)"
      @update:requestcommentarylocalmanagementvsProforma="val => (requestcommentarylocalmanagementvsProforma = val)"
      @update:requestcommentarylocalcontrolvsForecast="val => (requestcommentarylocalcontrolvsForecast = val)"
      @update:requestcommentarylocalmanagementvsForecast="val => (requestcommentarylocalmanagementvsForecast = val)"
      @update:requestcommentaryregionalcontrolvsProforma="val => (requestcommentaryregionalcontrolvsProforma = val)"
      @update:requestcommentaryregionalmanagementvsProforma="val => (requestcommentaryregionalmanagementvsProforma = val)"
      @update:requestcommentaryregionalcontrolvsForecast="val => (requestcommentaryregionalcontrolvsForecast = val)"
      @update:requestcommentaryregionalmanagementvsForecast="val => (requestcommentaryregionalmanagementvsForecast = val)"
    />
    <GlTabWarningDialog
      v-model="unsavedCommentaryDialog"
      :message="unsavedCommentaryMessage"
      :fields="unsavedCommentaryFieldLabels"
      data-testid="gl-breakdown__unsaved-commentary-warning"
      @confirm="confirmUnsavedCommentaryNavigation"
      @cancel="cancelUnsavedCommentaryNavigation"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import CrossedMaterialityLegend from '../components/CrossedMaterialityLegend.vue';
import SummaryMetrics from '../components/SummaryMetrics.vue';
import Breadcrumbs from '../components/Breadcrumbs.vue';
import CommentaryMainTab from '../components/commentary/CommentaryMainTab.vue';
import CommentaryTrendlineTab from '../components/commentary/CommentaryTrendlineTab.vue';
import CommentarySummaryTab from '../components/commentary/CommentarySummaryTab.vue';
import Evidence from '../components/Evidence.vue';
import SLBreakup from './SLBreakup.vue';
import RequestCommentaryDialog from '../modals/RequestCommentaryDialog.vue';
import GlTabWarningDialog from '../components/GlTabWarningDialog.vue';
import { getAvailableRoles } from '../utils/helper';
import helpers from '../utils/helpers';
import { ROLES, ROLE_LABEL_MAPPING, VIEW_ONLY, ANALYSIS_API_BASE, SL_CONTEXT_STORAGE_KEY, STAGES, REQUEST_COMMENTARY_ELIGIBLE_STAGES, SL_COMMENTARY } from '../utils/constants';

export default {
  name: 'GLBreakdown',
  components: {
    CrossedMaterialityLegend,
    SummaryMetrics,
    Breadcrumbs,
    CommentaryMainTab,
    CommentaryTrendlineTab,
    CommentarySummaryTab,
    Evidence,
    SLBreakup,
    RequestCommentaryDialog,
    GlTabWarningDialog,
  },
  props: {
    type: {
      type: String,
      required: false,
      default: '',
      validator: (value) => value === '' || ['revenue', 'netsales'].includes(value)
    },
  },
      // 5. Currently selected commentary row within GLBreakdown (sanitized for readability)
  data() {
    return {
      // Tab index for GLBreakdown main tabs
      slTab: 0,
      validationErrorField: '', // Track field validation error for UI feedback
      // Accordion state for summary card
      isSummaryExpanded: true,
      // ===== Core Data (mirroring helpers.js loadData) =====
      loading: false,
      isReportingUnitdataloading: true, // Start with loading true so shimmer shows immediately
      isReportingUnitClicked: true,
      
      // Commentary data arrays
      commentarydata: [],
      commentarydatajson: {},
      commentarydatajsonById: {},
      commentarydatajsonByGLCode: {},
      slDataList: {},
      commentaryrudata: {},
      commentarycycledata: {},
      
      // Cycle and RU data
      year: '',
      period: '',
      reportingunit: '',
      // ===== View State =====
      toggleview: 0,
      toggletableview: 0,
      isCommentaryView: false,
      revenueDrilldownDialogVisible: false,
      revenueDrilldownRow: null,
      cycletypeReadview: 'Proforma',
      cycletype: 'Actual',
      cyclestage: 0,
      
      // ===== Pagination =====
      page: 1,
      pageSize: 200,
      
      // ===== User Roles =====
      ispreparer: false,
      isapprover: false,
      isregionalapprover: false,
      ismanager: false,
      isviewonly: false,
      
      // ===== SOD =====
      isSodEnabled: true,
      ruRoleOptions: [],
      selectedRuRole: null,
      alluserassigned: true,
      
      // ===== SL Enabled Flag =====
      // When user navigates from Base.vue as approver/regional approver, SL operations are disabled
      slEnabled: true,
      // Flag to track if drilldown data has been loaded (lazy load on tab click)
      drilldownDataLoaded: false,
      
      // ===== Reporting Type =====
      // 'bs' for Balance Sheet, 'pl' for P&L, 'both' for both - defaults to 'pl'
      reportingType: 'pl',
      
      // ===== Workflows =====
      workflows: {
        lcp: false, lmp: false, rcp: false, rmp: false,
        lcf: false, lmf: false, rcf: false, rmf: false,
        islocalenabled: false, isregionalenabled: false,
        islocalproformaenabled: false, islocalforecastenabled: false,
        isregionalproformaenabled: false, isregionalforecastenabled: false,
        isworkflowsenabled: false
      },
      workflowtext: [],
      workflowsDisabledMessage: 'workflow disabled',
      ispendinglocalruapproval: false,
      ispendingregionalruapproval: false,
      
      // ===== Labels =====
      commentary_local_key_label: 'Local',
      commentary_regional_key_label: 'Regional',
      local_controls_label: 'Local Controls',
      local_management_label: 'Local Management',
      regional_controls_label: 'Regional Controls',
      regional_management_label: 'Regional Management',
      
      // ===== Filters =====
      // Initialize with all filter values to show all data by default
      // Filter values: 0=Local Commentary Awaited, 1=Local Commentary Awaiting Approval, -1=Local Commentary Rejected,
      // 5=Regional Commentary Awaited, 6=Regional Commentary Awaiting Approval, -2=Regional Commentary Rejected,
      // 7=Approved Commentary, 4=Immaterial Variance, 3=Nil Values, 9=Not in Scope
      selectedfilter: [0, 1, -1, 5, 6, -2, 7, 4, 3, 9],
      customfilter: [],
      customfilterstoggle: false,
      customfiltersdialog: false,
      
      // ===== Expansion State =====
      expandedIds: new Set(),
      isAllExpanded: false,
      
      // ===== SL Grouped/Ungrouped View State =====
      slViewMode: 'grouped', // 'grouped' or 'ungrouped'
      slExpandedGroups: [], // Array of expanded group IDs for grouped view
      slGroupedView: 0, // 0 = Grouped, 1 = Ungrouped (separate from toggletableview)
      
      // ===== Multi-select =====
      multiselectdata: [],
      
      // ===== Dialogs =====
      commantorydialog: false,
      workflowsdialog: false,
      statushelpdialog: false,
      requestcommentarydialog: false,
      requestcommentaryloading: false,
      userlistdialog: false,
      previouscyclelistdialog: false,
      previouscyclelistloading: false,
      previouscyclelist: [],
      previouscycledatadialog: false,
      previouscycledataloading: false,
      previouscycledata: [],
      previouscyclemetadata: {},
      previouscycledatatoupload: [],
      prevcommentaryselect: [],
      activitylogdialog: false,
      activitylogloading: false,
      activitylogdata: [],
      searchcustom: '',
      bulksubmitdialog: false,
      bulksubmitloading: false,
      bulksubmitfiledata: {},
      bulksubmitfiledatafile: null,
      bulksubmitfiledataerror: false,
      bulksubmitfiledataList: [],
      approverBulkSubmitPop: false,
      approverBulkSubmitLoading: false,
      approverBulkSubmitData: {},
      approverBulkSubmitDataFile: null,
      bulksubmitfiledataerrorisApprover: false,
      approverBulkSubmitFileDataListis: [],
      bulkapprovelocaldialog: false,
      bulkapprovelocalloading: false,
      bulkapprovelocalfiledata: {},
      bulkapprovelocalfiledatafile: null,
      bulkapprovelocalfiledataerror: false,
      multiRoleUsers: new Set(),
      allworkflowstext: [],
      allworkflowskeys: ['Local control proforma', 'Local control forecast', 'Local management proforma', 'Local management forecast',
        'Regional control proforma', 'Regional control forecast', 'Regional management proforma', 'Regional management forecast',
        'Local control proforma bs', 'Local control forecast bs', 'Local management proforma bs', 'Local management forecast bs',
        'Regional control proforma bs', 'Regional control forecast bs', 'Regional management proforma bs', 'Regional management forecast bs'
      ],
      proforma_shortform_label: 'Proforma',
      forcast_shortform_label: 'Forecast',
      bulksubmitcolumns: [],
      bulkUploadCommentaryHeaders: [
        { value: 'ignore', text: '', sortable: false, lock: true },
        { value: 'code', text: 'Client Code', sortable: true, lock: true },
        { value: 'name', text: 'Description', sortable: true, lock: true },
        { value: 'actual_amount', text: 'Actual Amount', sortable: true, lock: true },
        { value: 'proforma_amount', text: 'Proforma Amount', sortable: true, lock: true },
        { value: 'variance_amount1', text: 'Variance Amt (Act vs Pro)', sortable: true, lock: true },
        { value: 'variance_percent1', text: 'Variance % (Act vs Pro)', sortable: true, lock: true },
        { value: 'crosscontrolthresholdvsproforma', text: 'Cross Ctrl (Pro)', sortable: true, lock: true },
        { value: 'crossmanagementthresholdvsproforma', text: 'Cross Mgmt (Pro)', sortable: true, lock: true },
        { value: 'commentary1', text: 'Commentary (Act vs Pro)', sortable: false, lock: true },
        { value: 'forecast_amount', text: 'Forecast Amount', sortable: true, lock: true },
        { value: 'variance_amount2', text: 'Variance Amt (Act vs For)', sortable: true, lock: true },
        { value: 'variance_percent2', text: 'Variance % (Act vs For)', sortable: true, lock: true },
        { value: 'crosscontrolthresholdvsforecast', text: 'Cross Ctrl (For)', sortable: true, lock: true },
        { value: 'crossmanagementthresholdvsforecast', text: 'Cross Mgmt (For)', sortable: true, lock: true },
        { value: 'commentary2', text: 'Commentary (Act vs For)', sortable: false, lock: true },
        { value: 'message', text: 'Message', sortable: false, lock: true },
      ],
      bulkUploadCommentaryisApproverHeaders: [
        { value: 'ignore', text: '', sortable: false, lock: true },
        { value: 'code', text: 'Client Code', sortable: true, lock: true },
        { value: 'name', text: 'Description', sortable: true, lock: true },
        { value: 'actual_amount', text: 'Actual Amount', sortable: true, lock: true },
        { value: 'proforma_amount', text: 'Proforma Amount', sortable: true, lock: true },
        { value: 'variance_amount1', text: 'Variance Amt (Act vs Pro)', sortable: true, lock: true },
        { value: 'variance_percent1', text: 'Variance % (Act vs Pro)', sortable: true, lock: true },
        { value: 'crosslocalctrlvsproforma', text: 'Cross Local Ctrl (Pro)', sortable: true, lock: true },
        { value: 'crosslocalmngtvsproforma', text: 'Cross Local Mngt (Pro)', sortable: true, lock: true },
        { value: 'crossregionalctrlvsproforma', text: 'Cross Regional Ctrl (Pro)', sortable: true, lock: true },
        { value: 'crossregionalmngtvsproforma', text: 'Cross Regional Mngt (Pro)', sortable: true, lock: true },
        { value: 'regionalcommentary1', text: 'Regional Commentary 1', sortable: false, lock: true },
        { value: 'forecast_amount', text: 'Forecast Amount', sortable: true, lock: true },
        { value: 'variance_amount2', text: 'Variance Amt (Act vs For)', sortable: true, lock: true },
        { value: 'variance_percent2', text: 'Variance % (Act vs For)', sortable: true, lock: true },
        { value: 'crosslocalctrlvsforecast', text: 'Cross Local Ctrl (For)', sortable: true, lock: true },
        { value: 'crosslocalmngtvsforecast', text: 'Cross Local Mngt (For)', sortable: true, lock: true },
        { value: 'crossregionalctrlvsforecast', text: 'Cross Regional Ctrl (For)', sortable: true, lock: true },
        { value: 'crossregionalmngtvsforecast', text: 'Cross Regional Mngt (For)', sortable: true, lock: true },
        { value: 'regionalcommentary2', text: 'Regional Commentary 2', sortable: false, lock: true },
        { value: 'message', text: 'Message', sortable: false, lock: true },
      ],
      
      // ===== Commentary Dialog State =====
      commentaryloading: false,
      approveLoading: false,
      rejectLoading: false,
      saveLoading: false,
      saveRegionalReasonLoading: false,
      saveLocalReasonLoading: false,
      saveLocalCommentaryField: '',
      saveRegionalCommentaryField: '',
    commentaryBaselines: {},
    commentaryBaselinesReady: false,
    unsavedCommentaryDialog: false,
      pendingNavigation: null,
      skipUnsavedNavigationCheck: false,
      allowRouteLeave: false, // Flag to bypass beforeRouteLeave guard when user confirms navigation
      submitLoading: false,
      rejectCommentaryMenu: false,
      selectedcommentary: {},
      commentarytype: '',
      commentarySubmitDialogueViewMode: false,
      charttab: 0,
      dialogCharttab: 0, // Separate tab state for commentary dialog
      lastTrendlineFetchSignature: '',
      bulksubmit: false,
      bulktype: '',
      bulkcommentall: false,
      bulkcommentreplace: false,
      isLocalCommentaryCollapsed: false,
      isLocalCommentaryReasonCollapsed: false,
      isGlMandatoryRequestFlag: false,
      replaceExistingCommentFlag: false,
      lastActionsOnGL: {
        localaction: { type: 'none', lastAction: '' },
        regionalaction: { type: 'none', lastAction: '' },
      },
      attachmentfile: null,
      attachmentfileloading: false,
      attachmentfilepercentage: 0,
      
      isRegionalCommentaryAutomationEnabled: false,
      
      // ===== AI State =====
      aiProforma: '',
      aiForecast: '',
      aiLoadingProforma: false,
      aiLoadingForecast: false,
      aiResponseText: '',
      isTyping: false,
      index: 0,
      speed: 0,
      shouldStop: false,
      typingFrame: null,
      loadingtext1: false,
      loadingtext2: false,
      isThresholdExceedLocalCommentary: false,
      isThresholdExceedJVSummarisation: false,
      showSummaryTab: false,
      summaryAiProforma: '',
      summaryAiForecast: '',
      aitext: '',
      commentaryGenAiBtntabValue: false,
      commentaryStatusData: null,
      
      // ===== Request Commentary State =====
      requestcommentarylocalcontrol: false,
      requestcommentarylocalmanagement: false,
      requestcommentaryregionalcontrol: false,
      requestcommentaryregionalmanagement: false,
      requestcommentarylocalcontrolvsProforma: false,
      requestcommentarylocalcontrolvsForecast: false,
      requestcommentarylocalmanagementvsProforma: false,
      requestcommentarylocalmanagementvsForecast: false,
      requestcommentaryregionalcontrolvsProforma: false,
      requestcommentaryregionalmanagementvsProforma: false,
      requestcommentaryregionalcontrolvsForecast: false,
      requestcommentaryregionalmanagementvsForecast: false,
      
      // ===== Config =====
      tablecolors: {
        heading: { a: '#d9f2ff', b: '#ffe9cc' },
        body: { a: 'rgba(0,150,255,0.06)', b: 'rgba(255,140,0,0.06)' }
      },
      cycletypeItem: [
        { text: 'Proforma', value: 'Proforma' },
        { text: 'Forecast', value: 'Forecast' }
      ],
      activitylogconfigcycle: {},
      activitylogconfiggl: {
        a_localbulkadd: { icon: 'mdi-plus-circle', color: 'info' },
        a_localadd: { icon: 'mdi-plus-circle', color: 'info' },
        a_localfileadd: { icon: 'mdi-plus-circle', color: 'info' },
        a_localfileapprove: { icon: 'mdi-check-circle', color: 'info' },
        a_localapprove: { icon: 'mdi-check-circle', color: 'success' },
        a_localbulkapprove: { icon: 'mdi-check-circle', color: 'success' },
        a_localreject: { icon: 'mdi-close-circle', color: 'error' },
        a_localbulkreject: { icon: 'mdi-close-circle', color: 'error' },
        a_localrequest: { icon: 'mdi-comment-plus', color: 'grey' },
        a_regionaladd: { icon: 'mdi-plus-circle-outline', color: 'info' },
        a_regionalapprove: { icon: 'mdi-check-circle-outline', color: 'success' },
        a_regionalreject: { icon: 'mdi-close-circle-outline', color: 'error' },
        a_regionalrequest: { icon: 'mdi-comment-plus-outline', color: 'grey' },
        a_localproformasaved: { icon: 'mdi-content-save', color: 'info' },
        a_localforecastsaved: { icon: 'mdi-content-save', color: 'info' },
        a_regionalproformasaved: { icon: 'mdi-content-save', color: 'info' },
        a_regionalforecastsaved: { icon: 'mdi-content-save', color: 'info' },
        a_regionalreasonsaved: { icon: 'mdi-content-save', color: 'info' },
        a_localreasonsaved: { icon: 'mdi-content-save', color: 'info' },
        f_localbulkadd: { icon: 'mdi-plus-circle', color: 'info' },
        f_localadd: { icon: 'mdi-plus-circle', color: 'info' },
        f_localfileadd: { icon: 'mdi-plus-circle', color: 'info' },
        f_localfileapprove: { icon: 'mdi-check-circle', color: 'info' },
        f_localapprove: { icon: 'mdi-check-circle', color: 'success' },
        f_localbulkapprove: { icon: 'mdi-check-circle', color: 'success' },
        f_localreject: { icon: 'mdi-close-circle', color: 'error' },
        f_localbulkreject: { icon: 'mdi-close-circle', color: 'error' },
        f_localrequest: { icon: 'mdi-comment-plus', color: 'grey' },
        f_regionaladd: { icon: 'mdi-plus-circle-outline', color: 'info' },
        f_regionalapprove: { icon: 'mdi-check-circle-outline', color: 'success' },
        f_regionalreject: { icon: 'mdi-close-circle-outline', color: 'error' },
        f_regionalrequest: { icon: 'mdi-comment-plus-outline', color: 'grey' },
        f_localproformasaved: { icon: 'mdi-content-save', color: 'info' },
        f_localforecastsaved: { icon: 'mdi-content-save', color: 'info' },
        f_regionalproformasaved: { icon: 'mdi-content-save', color: 'info' },
        f_regionalforecastsaved: { icon: 'mdi-content-save', color: 'info' },
        f_regionalreasonsaved: { icon: 'mdi-content-save', color: 'info' },
        f_localreasonsaved: { icon: 'mdi-content-save', color: 'info' },
      },
      
      // ===== Route Params =====
      cycleId: null,
      reportingunitId: null,
      periodId: null,
      yearId: null,
      roleId: null,
      glcodeId: null,

      // ===== helpers.loadData adapter fields =====
      // These alias the GLBreakdown-specific IDs to the names helpers.loadData expects,
      // and must be declared here so Vue 2 makes them reactive from the start.
      selectedreportingunit: '',
      selectedperiod: '',
      selectedrole: '',
      requestType: '',
      commentarydataList: {},
      loadDataRequestToken: 0,
      loadDataAbortController: null,
      // Hierarchical filter dimensions used by helpers.storeFilteredData.
      // GLBreakdown navigates directly into a single RU so these stay as empty strings,
      // but they must be declared so the real storeFilteredData implementation can run
      // without accessing undefined properties.
      selectedyear: '',
      selectednetwork: '',
      selectedregion: '',
      selectedcountry: '',
      // Additional fields written by helpers.loadData that are not sourced from elsewhere
      isRequestinPendingState: false,
      reportingUnitType: '',
      allgls: [],
      commentarysummarydata: {},
      isbulkapprovalcrosscontrolenabled: false,
      isbulkapprovalmanagementcontrolenabled: false,
      
      // ===== PDF Download State =====
      rucyclepdfdownloadloading: false,
      rucyclepdfdownloaddialog: false,
      rucyclepdfdownloadlist: [],
    };
  },
  
  async created() {
    // Check if required store data exists (in case of page reload)
    let storeData = this.SLData;
    if (!this.hasValidSlContext(storeData)) {
      const restoredContext = this.restorePersistedSlContext();
      if (this.hasValidSlContext(restoredContext)) {
        try {
          await this.cacheSlContextAction(restoredContext);
          storeData = restoredContext;
        } catch (error) {
          console.error('[GLBreakdown] Failed to hydrate SL context from storage', error);
        }
      }
    }

    if (!this.hasValidSlContext(storeData)) {
      console.warn('[GLBreakdown] Required store data not found. Redirecting to variance analysis overview.');
      this.$store.commit('sbError', 'Unable to restore GL breakdown context.');
      this.$router.replace({ path: '/varianceanalysis/actualanalysis' });
      return;
    }

    this.selectedcommentary = this.cloneCommentaryItem(storeData.selectedGLCommentary || {});
    if (this.selectedcommentary && Object.keys(this.selectedcommentary).length) {
      this.ensureReadableIdentifiers(this.selectedcommentary);
    }
    if (storeData.selectedCommentaryCycle) {
      this.commentarycycledata = this.cloneCommentaryItem(storeData.selectedCommentaryCycle);
    }

    if (storeData.cycleType || storeData.cycletype) {
      this.cycletype = storeData.cycleType || storeData.cycletype || this.cycletype;
    }
    if (typeof storeData.cycleStage === 'number') {
      this.cyclestage = storeData.cycleStage;
    }
    if (storeData.trendContext) {
      const { year: trendYear, period: trendPeriod, reportingunit: trendRu } = storeData.trendContext;
      if (trendYear) {
        this.year = trendYear;
      }
      if (trendPeriod) {
        this.period = trendPeriod;
      }
      if (trendRu) {
        this.reportingunit = trendRu;
      }
    }
    this.applySummaryStateFromCommentary(storeData.selectedGLCommentary, true);
    
    // Initialize workflow labels
    const localLabel = this.$nova?.labelsName('cycle_page', 'commentary_local_key_label', 'Local') || 'Local';
    const regionalLabel = this.$nova?.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') || 'Regional';
    const proformaLabel = this.$nova?.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma') || 'Proforma';
    const forecastLabel = this.$nova?.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast') || 'Forecast';
    
    this.allworkflowstext = [
      `${localLabel} control ${proformaLabel}`,
      `${localLabel} control ${forecastLabel}`,
      `${localLabel} management ${proformaLabel}`,
      `${localLabel} management ${forecastLabel}`,
      `${regionalLabel} control ${proformaLabel}`,
      `${regionalLabel} control ${forecastLabel}`,
      `${regionalLabel} management ${proformaLabel}`,
      `${regionalLabel} management ${forecastLabel}`
    ];
    
    // Initialize workflow labels properties for components
    this.commentary_local_key_label = localLabel;
    this.commentary_regional_key_label = regionalLabel;
    this.proforma_shortform_label = proformaLabel;
    this.forcast_shortform_label = forecastLabel;

    this.local_controls_label = this.$nova?.labelsName('cycle_page', 'local_control_label', 'Local Control') || 'Local Control';
    this.local_management_label = this.$nova?.labelsName('cycle_page', 'local_management_label', 'Local Management') || 'Local Management';
    this.regional_controls_label = this.$nova?.labelsName('cycle_page', 'regional_control_label', 'Regional Control') || 'Regional Control';
    this.regional_management_label = this.$nova?.labelsName('cycle_page', 'regional_management_label', 'Regional Management') || 'Regional Management';
    
    // Extract route params
    this.cycleId = this.$route.params.cycleId;
    
    // Initialize role flags from SLData (passed from RUDataTable via Vuex)
    // These are the roles the user had when they clicked the row in RUDataTable
    console.log('[GLBreakdown] created() - storeData role flags:', {
      ispreparer: storeData.ispreparer,
      isapprover: storeData.isapprover,
      isregionalapprover: storeData.isregionalapprover,
      slEnabled: storeData.slEnabled,
      isSodEnabled: storeData.isSodEnabled,
      ruRoleOptions: storeData.ruRoleOptions,
      selectedRuRole: storeData.selectedRuRole,
    });
    
    if (storeData.ispreparer !== undefined) {
      this.ispreparer = storeData.ispreparer;
    }
    if (storeData.isapprover !== undefined) {
      this.isapprover = storeData.isapprover;
    }
    if (storeData.isregionalapprover !== undefined) {
      this.isregionalapprover = storeData.isregionalapprover;
    }
    if (storeData.isSodEnabled !== undefined) {
      this.isSodEnabled = storeData.isSodEnabled;
    }
    
    // Initialize ruRoleOptions and selectedRuRole from SLData for role selector persistence
    if (storeData.ruRoleOptions && storeData.ruRoleOptions.length) {
      this.ruRoleOptions = storeData.ruRoleOptions;
    }
    if (storeData.selectedRuRole) {
      this.selectedRuRole = storeData.selectedRuRole;
    }
    
    // Initialize reportingType from SLData - 'bs' for Balance Sheet, 'pl' for P&L, 'both' for both
    // Defaults to 'pl' if not specified
    if (storeData.reportingType) {
      this.reportingType = storeData.reportingType;
    } else {
      this.reportingType = 'pl'; // Default to P&L
    }
    
    // Fallback: If no role flags are set from store, derive from selectedGLCommentary.__myaction
    // This handles cases where the store data doesn't have role flags
    const noRoleSet = !this.ispreparer && !this.isapprover && !this.isregionalapprover;
    if (noRoleSet) {
      const rowAction = storeData.selectedGLCommentary?.__myaction;
      const stageLocal = storeData.selectedGLCommentary?.stage_local;
      const stageRegional = storeData.selectedGLCommentary?.stage_regional;
      console.log('[GLBreakdown] No role flags in store, deriving from row:', {
        __myaction: rowAction,
        stage_local: stageLocal,
        stage_regional: stageRegional,
      });


      
      
      if (rowAction === 'localapprove') {
        this.isapprover = true;
      } else if (rowAction === 'regionalapprove') {
        this.isregionalapprover = true;
      } else if (rowAction === 'regionaladd' || rowAction === 'regionalvoluntary') {
        // regionaladd/regionalvoluntary can be done by local approver
        this.isapprover = true;
      } else if (rowAction === 'localadd' || rowAction === 'localvoluntary') {
        this.ispreparer = true;
      }
    }
    
    // Initialize slEnabled from SLData
    // slEnabled controls whether the Drilldown tab is shown and SL operations are available
    // Default to true if not explicitly set to false in storeData
    if (storeData?.slEnabled !== undefined) {
      this.slEnabled = storeData.slEnabled;
    }
    
    // Initialize isRegionalCommentaryAutomationEnabled from SLData
    // This controls whether "Approve and Submit" button is shown for regional approvers
    if (storeData.isRegionalCommentaryAutomationEnabled !== undefined) {
      this.isRegionalCommentaryAutomationEnabled = storeData.isRegionalCommentaryAutomationEnabled;
    } else if (storeData.auto_regional_commentary_submission_enabled !== undefined) {
      this.isRegionalCommentaryAutomationEnabled = storeData.auto_regional_commentary_submission_enabled;
    }
    
    // Initialize workflows from SLData (passed from RUDataTable/Base.vue via Vuex)
    // If storeData has workflows, use them; otherwise keep defaults
    if (storeData.workflows && Object.keys(storeData.workflows).length > 0) {
      this.workflows = { ...this.workflows, ...storeData.workflows };
    }
      
    this.reportingunitId = storeData.reportingunit || this.$route.params.reportingunitId || this.$route.query.reportingunit;
    this.periodId = storeData.period || this.$route.params.periodId || this.$route.query.period;
    this.yearId = storeData.year || this.$route.params.yearId || this.$route.query.year;
    this.roleId = this.$route.params.roleId || this.$route.query.role;
    this.glcodeId = storeData.glcode || this.$route.params.glcodeId || this.$route.query.glcode;

    // Handle tab query param to open specific tab (e.g., drilldown tab from drill-down button click)
    const tabQuery = this.$route.query.tab;
    if (tabQuery === 'drilldown' && this.slEnabled) {
      // Find the index of the drilldown tab in tabItems
      // tabItems order: [commentary(0), trendline(1), evidence(2), drilldown(3 if slEnabled), summary(4 if shown)]
      this.$nextTick(() => {
        const drilldownIndex = this.tabItems.findIndex(tab => tab.key === 'drilldown');
        if (drilldownIndex >= 0) {
          this.slTab = drilldownIndex;
          console.log('[GLBreakdown] Opening drilldown tab from query param, index:', drilldownIndex);
        }
      });
    }

    // Fetch AI features
    await this.fetchAiFeatures();
    
    // Load GL details and refresh SOD/role state from reporting unit API in parallel
    await Promise.all([
      this.loadGLDetails(),
      this.syncReportingUnitSodStatus(),
    ]);
    this.refreshSelectedCommentaryActions();
    this.setWorkflows();
    
    // Note: SL data loading is handled by the SLBreakup component in the drilldown tab
  },
  
  watch: {
    commantorydialog(val) {
      if (!val) {
        this.bulksubmit = false;
        this.bulktype = '';
        this.commentarytype = '';
        if (this.selectedcommentary && !this.selectedcommentary._id) {
           this.selectedcommentary = {};
        }
      }
    },
    bulksubmit(val) {
      if (val && this.normalizeTabIndex(this.slTab) !== 0) {
        this.slTab = 0;
      }
    },
    inlineShouldRenderSummaryTab(val) {
      if (!val && this.normalizeTabIndex(this.slTab) === 2) {
        this.slTab = 0;
      }
    },
    '$route.params.cycleId': function(newId) {
      if (newId && newId !== this.cycleId) {
        this.cycleId = newId;
        // SLBreakup handles its own data loading via route params
      }
    },
    // Watch for tab query parameter changes to open specific tabs (e.g., drilldown)
    '$route.query.tab': {
      immediate: true,
      handler(tabQuery) {
        if (tabQuery === 'drilldown' && this.slEnabled) {
          this.$nextTick(() => {
            const drilldownIndex = this.tabItems.findIndex(tab => tab.key === 'drilldown');
            if (drilldownIndex >= 0 && this.slTab !== drilldownIndex) {
              this.slTab = drilldownIndex;
              console.log('[GLBreakdown] Opening drilldown tab from query watcher, index:', drilldownIndex);
            }
          });
        }
      }
    },
    type: function() {
      // SLBreakup handles its own data loading when type changes
    },
    selectedRuRole(newVal) {
      if (newVal) {
        this.applyRoleFlags(newVal);
        
        // Note: We do NOT change slEnabled when role changes in GLBreakdown.
        // The drilldown tab should remain visible regardless of selected role.
        // slEnabled is only set once in created() from storeData.slEnabled
        // and controls initial tab visibility, not dynamic tab hiding.
        
        // Reprocess item actions based on new role
        this.reprocessItemActions();
      }
    },
    // Reset page to 1 when filters change - use deep watch for arrays
    selectedfilter: {
      handler() {
        this.page = 1;
      },
      deep: true
    },
    // Reset page to 1 when custom filters toggle changes
    customfilterstoggle() {
      this.page = 1;
    },
    // Keep inline commentary tabs aligned with the selected SL tab
    slTab: {
      immediate: true,
      handler(newVal) {
        const normalized = this.normalizeTabIndex(newVal);
        if (normalized === null) {
          return;
        }

        if (this.slTab !== normalized) {
          this.slTab = normalized;
        }
        if (normalized >= 0 && normalized <= 2 && this.charttab !== normalized) {
          this.charttab = normalized;
        }
        if (normalized === 1) {
          this.$nextTick(() => this.ensureTrendlineDataset());
        }
        // NOTE: Drilldown tab (value 3) lazy loading is now handled by SLBreakup component
      },
    },
    charttab(newVal) {
      const normalized = this.normalizeTabIndex(newVal);
      if (normalized === null) {
        return;
      }

      if (this.charttab !== normalized) {
        this.charttab = normalized;
      }
      if (normalized >= 0 && normalized <= 2 && this.slTab !== normalized) {
        this.slTab = normalized;
      }
      if (normalized === 1 && this.normalizeTabIndex(this.slTab) === 1) {
        this.ensureTrendlineDataset();
      }
    },
    dialogCharttab(newVal) {
      if (newVal === 1) {
        this.ensureDialogTrendlineDataset();
      }
    },
    selectedGLCommentary: {
      handler() {
        this.syncSelectedCommentary();
      },
      deep: false,
    },
    selectedStoreCommentary: {
      handler() {
        this.syncSelectedCommentary();
      },
      deep: false,
    },
    trendContext: {
      immediate: true,
      handler(newContext = {}) {
        this.year = this.normalizeIdentifier(newContext.year);
        this.period = this.normalizeIdentifier(newContext.period);
        this.reportingunit = this.normalizeIdentifier(newContext.reportingunit);
        // Only fetch trendline when tab is visible
        if (this.normalizeTabIndex(this.slTab) === 1) {
          this.ensureTrendlineDataset(true);
        }
      },
    },
    trendlineLogs(newLogs) {
      this.lastActionsOnGL = this.mergeLastActionsFromStageAndLogs(
        this.selectedcommentary,
        newLogs
      );
    },
    /**
     * Watch selectedcommentary for stage changes to update lastActionsOnGL
     * This ensures approval/rejection reasons are displayed when trendline logs haven't loaded yet
     */
    'selectedcommentary.stage_local': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.lastActionsOnGL = this.mergeLastActionsFromStageAndLogs(
          this.selectedcommentary,
          this.trendlineLogs
        );
      }
    },
    'selectedcommentary.stage_regional': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.lastActionsOnGL = this.mergeLastActionsFromStageAndLogs(
          this.selectedcommentary,
          this.trendlineLogs
        );
      }
    },
    trendlineFetchParams: {
      deep: true,
      handler(next) {
        if (!next || !next.contextKey || !next.filter) {
          return;
        }

        const signature = JSON.stringify(next);
        if (signature === this.lastTrendlineFetchSignature) {
          return;
        }

        this.lastTrendlineFetchSignature = signature;
        if (this.normalizeTabIndex(this.slTab) === 1) {
          this.ensureTrendlineDataset();
        }
      },
    },
    slAiLoadingProformaFromStore(value) {
      this.aiLoadingProforma = Boolean(value);
    },
    slAiLoadingForecastFromStore(value) {
      this.aiLoadingForecast = Boolean(value);
    },
    slSummaryLoadingProformaFromStore(value) {
      this.loadingtext1 = Boolean(value);
    },
    slSummaryLoadingForecastFromStore(value) {
      this.loadingtext2 = Boolean(value);
    },
    slAiResponseTextFromStore(newText) {
      if (!newText || typeof newText !== 'string') {
        return;
      }

      const variant = this.slAiGeneratedVariant || '';
      const normalizedVariant = variant.toLowerCase();
      if (normalizedVariant === 'proforma') {
        this.aiProforma = '';
      } else if (normalizedVariant === 'forecast') {
        this.aiForecast = '';
      }

      if (this.typingFrame) {
        cancelAnimationFrame(this.typingFrame);
        this.typingFrame = null;
      }

      this.aiResponseText = newText;
      this.isTyping = true;
      this.index = 0;
      this.shouldStop = false;

      const typeToken = normalizedVariant === 'forecast' ? 'Two' : 'One';
      this.typeEffect(typeToken);
    },
    slSummaryResponseTextFromStore(newText) {
      if (!newText || typeof newText !== 'string') {
        return;
      }

      const variant = (this.slSummaryVariantFromStore || '').toLowerCase();
      if (variant === 'forecast') {
        this.summaryAiForecast = newText;
      } else {
        this.summaryAiProforma = newText;
      }
    },
  },
  
  computed: {
    /**
     * Dynamic label for Actual based on reportingType
     * Returns balance sheet specific label when reportingType is 'bs', otherwise default
     */
    actualLabel() {
      return this.reportingType === 'bs'
        ? this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual')
        : this.$nova.labelsName('cycle_page', 'actual_label', 'Actual');
    },
    /**
     * Dynamic label for Proforma based on reportingType
     * Returns balance sheet specific label when reportingType is 'bs', otherwise default
     */
    proformaLabel() {
      return this.reportingType === 'bs'
        ? this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma')
        : this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma');
    },
    /**
     * Dynamic label for Forecast based on reportingType
     * Returns balance sheet specific label when reportingType is 'bs', otherwise default
     */
    forecastLabel() {
      return this.reportingType === 'bs'
        ? this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast')
        : this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast');
    },
    /**
     * Check if any action operation is in progress (save, submit, approve, reject)
     * Used to show a full-page overlay and disable interactions
     * @returns {boolean} True if any action is in progress
     */
    isActionInProgress() {
      return (
        this.approveLoading ||
        this.rejectLoading ||
        this.saveLoading ||
        this.submitLoading ||
        this.bulksubmitloading ||
        this.approverBulkSubmitLoading ||
        this.bulkapprovelocalloading ||
        this.saveRegionalReasonLoading ||
        this.saveLocalReasonLoading
      );
    },
    
    /**
     * Get current user ID for upload tracking
     * @returns {string} User ID
     */
    currentUserId() {
      return this.$store.state.user?.id || this.$store.state.userid || '';
    },
    
    /**
     * Get current user role for upload tracking
     * @returns {string} Role name (preparer, approver, or regional approver)
     */
    currentUserRole() {
      if (this.isregionalapprover) {
        return 'regional approver';
      } else if (this.isapprover) {
        return 'approver';
      } else if (this.ispreparer) {
        return 'preparer';
      }
      return '';
    },
    
    /**
     * Check if both local commentary fields are empty
     * Save button should only show when commentary1 AND commentary2 are both empty
     * @returns {boolean} True if both commentary fields are empty
     */
    isLocalCommentaryEmpty() {
      // If we have an explicit flag from data load, use it to persist visibility while typing
      if (this.selectedcommentary && typeof this.selectedcommentary.isOriginalEmpty === 'boolean') {
        return this.selectedcommentary.isOriginalEmpty;
      }

      const commentary1 = this.selectedcommentary?.commentary1 || '';
      const commentary2 = this.selectedcommentary?.commentary2 || '';
      // Strip HTML tags and whitespace to check for actual content
      const stripped1 = commentary1.replace(/<[^>]*>/g, '').trim();
      const stripped2 = commentary2.replace(/<[^>]*>/g, '').trim();
      return !stripped1 && !stripped2;
    },
    
    // Derive type from route path if not provided via props
    currentType() {
      // If type prop is provided, use it
      if (this.type && this.type !== '') {
        return this.type;
      }
      // Otherwise derive from route path
      const path = this.$route.path || '';
      if (path.includes('revenuebreakup')) {
        return 'revenue';
      } else if (path.includes('netsalesbreakup')) {
        return 'netsales';
      }
      // Default to revenue if can't determine
      return 'revenue';
    },
    // Type-based computed properties
    isRevenue() {
      return this.currentType === 'revenue';
    },
    isNetSales() {
      return this.currentType === 'netsales';
    },
    
    // Generate CSS classes based on type
    pageClass() {
      return `${this.currentType}-breakup-page`;
    },
    contentClass() {
      return `${this.currentType}-breakup-content`;
    },
    summaryClass() {
      return `${this.currentType}-summary`;
    },
    summaryGridClass() {
      return `${this.currentType}-summary__grid`;
    },

    trendContext() {
      const extractId = (obj, key) => {
        if (!obj || typeof obj !== 'object') {
          return '';
        }
        const detailCandidate = this.normalizeIdentifier(obj[`${key}_detail`]);
        if (detailCandidate) {
          return detailCandidate;
        }
        return this.normalizeIdentifier(obj[key]);
      };

      const sources = [
        this.commentarycycledata,
        this.selectedCommentaryCycle,
        this.selectedGLCommentary,
        this.SLData,
        this.sanitizedTrendlineCommentary,
        this.selectedcommentary,
      ];

      const resolvedYear =
        sources.map((s) => extractId(s, 'year')).find(Boolean) ||
        this.normalizeIdentifier(this.SLData?.year) ||
        this.normalizeIdentifier(this.year) ||
        '';

      const resolvedPeriod =
        sources.map((s) => extractId(s, 'period')).find(Boolean) ||
        this.normalizeIdentifier(this.SLData?.period) ||
        this.normalizeIdentifier(this.periodId) ||
        this.normalizeIdentifier(this.period) ||
        '';

      const resolvedReportingUnit =
        sources.map((s) => extractId(s, 'reportingunit')).find(Boolean) ||
        this.normalizeIdentifier(this.SLData?.reportingunit) ||
        this.normalizeIdentifier(this.reportingunitId) ||
        this.normalizeIdentifier(this.reportingunit) ||
        '';

      return {
        year: resolvedYear,
        period: resolvedPeriod,
        reportingunit: resolvedReportingUnit,
      };
    },

    commentaryStatusChip() {
      if (this.bulksubmit) {
        return null;
      }

      const stage = this.selectedcommentary?.__stage;
      const theme = this.$vuetify.theme.currentTheme || {};
      const colorWithOpacity = (themeKey, fallback = '#9e9e9e') => {
        const baseColor = theme[themeKey] || fallback;
        return this.$nova?.hexToRgbA ? this.$nova.hexToRgbA(baseColor, 0.1) : baseColor;
      };

      const stageMap = {
        [-1]: {
          icon: 'mdi-close-circle',
          iconColor: 'error',
          textKey: 'commentary_filter_local_commentary_awaiting_approval',
          fallbackText: 'Local Commentary rejected',
          textClass: 'error--text',
          background: colorWithOpacity('error'),
        },
        0: {
          icon: 'mdi-timer-sand-full',
          iconColor: 'info',
          textKey: 'commentary_filter_local_commentary_awaited',
          fallbackText: 'Local commentary awaited',
          textClass: 'info--text',
          background: colorWithOpacity('info', '#2196f3'),
        },
        1: {
          icon: 'mdi-timer-sand-full',
          iconColor: 'warning',
          textKey: 'commentary_filter_local_commentary_awaiting_approval',
          fallbackText: 'Local commentary awaiting approval',
          textClass: 'warning--text',
          background: colorWithOpacity('warning', '#fb8c00'),
        },
        [-2]: {
          icon: 'mdi-close-circle-outline',
          iconColor: 'error',
          textKey: 'commentary_filter_regional_commentary_rejected',
          fallbackText: 'Regional commentary rejected',
          textClass: 'error--text',
          background: colorWithOpacity('error'),
        },
        5: {
          icon: 'mdi-timer-sand-empty',
          iconColor: 'info',
          textKey: 'commentary_filter_regional_commentary_awaited',
          fallbackText: 'Regional commentary awaited',
          textClass: 'info--text',
          background: colorWithOpacity('info', '#2196f3'),
        },
        6: {
          icon: 'mdi-timer-sand-empty',
          iconColor: 'warning',
          textKey: 'commentary_filter_regional_commentary_awaiting_approval',
          fallbackText: 'Regional Commentary awaiting approval',
          textClass: 'warning--text',
          background: colorWithOpacity('warning', '#fb8c00'),
        },
        7: {
          icon: 'mdi-check-circle',
          iconColor: 'success',
          text: 'Approved',
          textClass: 'success--text',
          background: colorWithOpacity('success', '#4caf50'),
        },
        3: {
          icon: 'mdi-bookmark-off',
          iconColor: 'grey',
          textKey: 'commentary_filter_nil_value_accounts_label',
          fallbackText: 'Nil value accounts',
          textClass: 'grey--text',
          background: colorWithOpacity('grey'),
        },
        4: {
          icon: 'mdi-cash-remove',
          iconColor: 'grey',
          textKey: 'commentary_filter_immaterial_variance_label',
          fallbackText: 'Immaterial variance',
          textClass: 'grey--text',
          background: colorWithOpacity('grey'),
        },
      };

      const config = stageMap[stage];
      if (!config) {
        return null;
      }

      const text = config.text || this.$nova?.labelsName?.(
        'cycle_page',
        config.textKey,
        config.fallbackText,
      ) || config.fallbackText;

      return {
        stage,
        icon: config.icon,
        iconColor: config.iconColor,
        text,
        textClass: config.textClass,
        background: config.background,
      };
    },

    commentarySaveState() {
      if (this.bulksubmit || this.selectedcommentary?.__myaction !== 'localadd') {
        return '';
      }

      const normalize = (value) => String(value ?? '').trim();
      const savedOne = this.isSubmittedCommentaryField('commentary1') ||
        normalize(this.selectedcommentary.savedcommentary1) === normalize(this.selectedcommentary.commentary1);
      const savedTwo = this.isSubmittedCommentaryField('commentary2') ||
        normalize(this.selectedcommentary.savedcommentary2) === normalize(this.selectedcommentary.commentary2);

      if (savedOne && savedTwo) {
        return 'saved';
      }

      return 'unsaved';
    },

    hasUnsavedLocalReason() {
      if (!this.isapprover || this.isregionalapprover || this.bulksubmit) {
        return false;
      }
      return this.isCommentaryTextDirty(
        this.selectedcommentary?.approvereason,
        this.selectedcommentary?.savedreason,
        this.commentaryBaselines.approvereason
      );
    },

    hasUnsavedLocalCommentary() {
      if (!this.ispreparer || this.bulksubmit) {
        return false;
      }
      const proformaDirty = !this.isSubmittedCommentaryField('commentary1') && this.isCommentaryTextDirty(
        this.selectedcommentary?.commentary1,
        this.selectedcommentary?.savedcommentary1,
        this.commentaryBaselines.commentary1
      );
      const forecastDirty = !this.isSubmittedCommentaryField('commentary2') && this.isCommentaryTextDirty(
        this.selectedcommentary?.commentary2,
        this.selectedcommentary?.savedcommentary2,
        this.commentaryBaselines.commentary2
      );
      return proformaDirty || forecastDirty;
    },

    hasUnsavedRegionalCommentary() {
      if (!this.isRegionalPreparer || this.bulksubmit) {
        return false;
      }
      const proformaDirty = this.isCommentaryTextDirty(
        this.selectedcommentary?.regionalcommentary1,
        this.selectedcommentary?.savedregionalcommentary1,
        this.commentaryBaselines.regionalcommentary1
      );
      const forecastDirty = this.isCommentaryTextDirty(
        this.selectedcommentary?.regionalcommentary2,
        this.selectedcommentary?.savedregionalcommentary2,
        this.commentaryBaselines.regionalcommentary2
      );
      return proformaDirty || forecastDirty;
    },

    isRegionalCommentaryEditMode() {
      const action = this.selectedcommentary?.__myaction;
      return (
        this.isRegionalPreparer &&
        (action === 'regionaladd' || action === 'regionalvoluntary') &&
        this.selectedcommentary?.__stage !== 9
      );
    },

    isRegionalPreparer() {
      return this.isapprover && !this.isregionalapprover;
    },

    hasUnsavedCommentaryChanges() {
      return this.hasUnsavedRegionalReason ||
        this.hasUnsavedLocalReason ||
        this.hasUnsavedLocalCommentary ||
        this.hasUnsavedRegionalCommentary;
    },

    unsavedCommentaryMessage() {
      if (this.hasUnsavedLocalCommentary || this.hasUnsavedRegionalCommentary) {
        return 'Your commentary has not been saved. If you leave now, your changes will be lost. Changes detected in:';
      }
      return 'Your approve/reject reason has not been saved. If you leave now, your changes will be lost. Changes detected in:';
    },

    unsavedCommentaryFieldLabels() {
      const labels = [];
      const localLabel = this.$nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local');
      const regionalLabel = this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional');
      const localApproverLabel = this.$nova.labelsName('cycle_page', 'commentary_local_approver_label', 'Local Approver');
      const regionalApproverLabel = this.$nova.labelsName('cycle_page', 'commentary_regional_approver_label', 'Regional Approver');

      if (this.ispreparer && !this.bulksubmit) {
        if (!this.isSubmittedCommentaryField('commentary1') && this.isCommentaryTextDirty(
          this.selectedcommentary?.commentary1,
          this.selectedcommentary?.savedcommentary1,
          this.commentaryBaselines.commentary1
        )) {
          labels.push(`${localLabel} Commentary (Vs ${this.proformaLabel})`);
        }
        if (!this.isSubmittedCommentaryField('commentary2') && this.isCommentaryTextDirty(
          this.selectedcommentary?.commentary2,
          this.selectedcommentary?.savedcommentary2,
          this.commentaryBaselines.commentary2
        )) {
          labels.push(`${localLabel} Commentary (Vs ${this.forecastLabel})`);
        }
      }

      if (this.isRegionalPreparer && !this.bulksubmit) {
        if (this.isCommentaryTextDirty(
          this.selectedcommentary?.regionalcommentary1,
          this.selectedcommentary?.savedregionalcommentary1,
          this.commentaryBaselines.regionalcommentary1
        )) {
          labels.push(`${regionalLabel} Commentary (Vs ${this.proformaLabel})`);
        }
        if (this.isCommentaryTextDirty(
          this.selectedcommentary?.regionalcommentary2,
          this.selectedcommentary?.savedregionalcommentary2,
          this.commentaryBaselines.regionalcommentary2
        )) {
          labels.push(`${regionalLabel} Commentary (Vs ${this.forecastLabel})`);
        }
      }

      if (this.hasUnsavedLocalReason) {
        labels.push(`${localApproverLabel} Approval/Rejection Reason`);
      }

      if (this.hasUnsavedRegionalReason) {
        labels.push(`${regionalApproverLabel} Approval/Rejection Reason`);
      }

      return labels;
    },

    hasUnsavedRegionalReason() {
      if (!this.isregionalapprover || this.bulksubmit) {
        return false;
      }
      return this.isCommentaryTextDirty(
        this.selectedcommentary?.regionalapprovereason,
        this.selectedcommentary?.savedregionalreason,
        this.commentaryBaselines.regionalapprovereason
      );
    },

    sanitizedTrendlineCommentary() {
      const source = this.selectedcommentary && Object.keys(this.selectedcommentary).length > 0
        ? this.selectedcommentary
        : (this.selectedGLCommentary && Object.keys(this.selectedGLCommentary).length > 0
          ? this.selectedGLCommentary
          : null);
      
      if (!source) return {};
      
      const clone = this.cloneCommentaryItem(source);
      this.ensureReadableIdentifiers(clone);
      return clone;
    },

    // Shared bindings for inline commentary tabs
    commentaryTabsProps() {
      return {
        inline: true,
        forceSummaryTab: true,
        showInternalTabs: true,
        bulksubmit: this.bulksubmit,
        bulktype: this.bulktype,
        bulkcommentall: this.bulkcommentall,
        bulkcommentreplace: this.bulkcommentreplace,
        selectedcommentary: this.selectedcommentary,
        multiselectdata: this.multiselectdata,
        tablecolors: this.tablecolors,
        cycletype: this.cycletype,
        cycletypeReadview: this.cycletypeReadview,
        ispreparer: this.ispreparer,
        isapprover: this.isapprover,
        isregionalapprover: this.isregionalapprover,
        userid: this.userid,
        sodEnabled: this.isSodEnabled,
        workflowtext: this.workflowtext,
        workflows: this.workflows,
        cyclestage: this.cyclestage,
        commentary_local_key_label: this.commentary_local_key_label,
        commentary_regional_key_label: this.commentary_regional_key_label,
        aggregatedLabelText: this.commentary_regional_key_label,
        localCommentaryGenAiBtntab: this.commentaryGenAiBtntab,
        isRegionalCommentaryAutomationEnabled: this.isRegionalCommentaryAutomationEnabled,
        isLocalCommentaryCollapsed: this.isLocalCommentaryCollapsed,
        isLocalCommentaryReasonCollapsed: this.isLocalCommentaryReasonCollapsed,
        isGlMandatoryRequestFlag: this.isGlMandatoryRequestFlag,
        replaceExistingCommentFlag: this.replaceExistingCommentFlag,
        charttab: this.charttab,
        commentarySubmitDialogueViewMode: this.commentarySubmitDialogueViewMode,
        toggleview: this.toggleview,
        trendYear: this.trendContext.year,
        trendPeriod: this.trendContext.period,
        trendReportingUnit: this.trendContext.reportingunit,
        lastActionsOnGL: this.lastActionsOnGL,
        attachmentfile: this.attachmentfile,
        attachmentfileloading: this.attachmentfileloading,
        attachmentfilepercentage: this.attachmentfilepercentage,
        isTyping: this.isTyping,
        loadingtext1: this.loadingtext1,
        loadingtext2: this.loadingtext2,
        isThresholdExceedLocalCommentary: this.isThresholdExceedLocalCommentary,
        isThresholdExceedJVSummarisation: this.isThresholdExceedJVSummarisation,
        showSummaryTab: this.showSummaryTab,
        summaryAiProforma: this.summaryAiProforma,
        summaryAiForecast: this.summaryAiForecast,
        aitext: this.aitext,
        requestcommentarylocalcontrol: this.requestcommentarylocalcontrol,
        requestcommentarylocalmanagement: this.requestcommentarylocalmanagement,
        requestcommentaryregionalcontrol: this.requestcommentaryregionalcontrol,
        requestcommentaryregionalmanagement: this.requestcommentaryregionalmanagement,
        requestcommentarylocalcontrolvsProforma: this.requestcommentarylocalcontrolvsProforma,
        requestcommentarylocalcontrolvsForecast: this.requestcommentarylocalcontrolvsForecast,
        requestcommentarylocalmanagementvsProforma: this.requestcommentarylocalmanagementvsProforma,
        requestcommentarylocalmanagementvsForecast: this.requestcommentarylocalmanagementvsForecast,
        requestcommentaryregionalcontrolvsProforma: this.requestcommentaryregionalcontrolvsProforma,
        requestcommentaryregionalmanagementvsProforma: this.requestcommentaryregionalmanagementvsProforma,
        requestcommentaryregionalcontrolvsForecast: this.requestcommentaryregionalcontrolvsForecast,
        requestcommentaryregionalmanagementvsForecast: this.requestcommentaryregionalmanagementvsForecast,
        trendlineGlContext: this.sanitizedTrendlineCommentary,
      };
    },

    inlineContentClasses() {
      return {
        'commentary-tabs-content': true,
        'commentary-tabs-content--inline': true,
      };
    },

    inlineShowInternalTabs() {
      return Boolean(this.commentaryTabsProps.showInternalTabs !== false);
    },

    inlineShouldRenderSummaryTab() {
      const isActualValid = this.isActualJVCommentaryValidForLocal(this.selectedcommentary);
      const isForecastValid = this.isForecastJVCommentaryValidForLocal(this.selectedcommentary);

      return (
        !this.bulksubmit &&
        this.$store.state.aiEnabled &&
        this.showSummaryTab &&
        (isActualValid || isForecastValid)
      );
    },

    /**
     * Dynamic tab items configuration
     * Order: Commentary, Trendline, Evidence, [Drilldown if slEnabled], [Summary if inlineShouldRenderSummaryTab]
     * @returns {Array<{key: string, label: string, testId: string, eager: boolean, headerClass?: string}>}
     */
    tabItems() {
      const tabs = [
        {
          key: 'commentary',
          label: 'Commentary',
          testId: 'gl-breakdown__tab-commentary',
          eager: true,
          headerClass: ''
        },
        {
          key: 'trendline',
          label: 'Trendline',
          testId: 'gl-breakdown__tab-trendline',
          eager: true,
          headerClass: this.bulksubmit ? 'd-none' : ''
        },
        {
          key: 'evidence',
          label: 'Evidence',
          testId: 'gl-breakdown__tab-evidence',
          eager: true,
          headerClass: ''
        }
      ];

      // Conditionally add Drilldown tab if slEnabled
      if (this.slEnabled) {
        tabs.push({
          key: 'drilldown',
          label: 'Drill-down',
          testId: 'gl-breakdown__tab-drilldown',
          eager: false,
          headerClass: ''
        });
      }

      // Conditionally add Summary tab if inlineShouldRenderSummaryTab
      if (this.inlineShouldRenderSummaryTab) {
        tabs.push({
          key: 'summary',
          label: 'Summary',
          testId: 'gl-breakdown__tab-summary',
          eager: true,
          headerClass: this.bulksubmit ? 'd-none' : ''
        });
      }

      return tabs;
    },

    /**
     * Get the current tab key based on slTab index
     * @returns {string} The key of the currently active tab
     */
    currentTabKey() {
      const currentTab = this.tabItems[this.slTab];
      return currentTab ? currentTab.key : 'commentary';
    },

    commentaryMainTabProps() {
      const base = this.commentaryTabsProps;
      return {
        selectedcommentary: base.selectedcommentary,
      };
    },

    commentaryTrendlineTabProps() {
      const base = this.commentaryTabsProps;
      return {
        bulksubmit: base.bulksubmit,
        charttab: this.normalizeTabIndex(this.slTab) ?? 0,
        cycletype: base.cycletype,
        reportingType: this.reportingType || 'pl',
        actualLabel: this.actualLabel,
        proformaLabel: this.proformaLabel,
        forecastLabel: this.forecastLabel,
        trendYear: base.trendYear,
        trendPeriod: base.trendPeriod,
        trendReportingUnit: base.trendReportingUnit,
        selectedcommentary: base.selectedcommentary,
        toggleview: base.toggleview,
        glContext: base.trendlineGlContext,
      };
    },

    commentarySummaryTabProps() {
      const base = this.commentaryTabsProps;
      return {
        bulksubmit: base.bulksubmit,
        selectedcommentary: base.selectedcommentary,
        tablecolors: base.tablecolors,
        cycletype: base.cycletype,
        bulktype: base.bulktype,
        summaryAiProforma: base.summaryAiProforma,
        summaryAiForecast: base.summaryAiForecast,
        aitext: base.aitext,
        loadingtext1: base.loadingtext1,
        loadingtext2: base.loadingtext2,
        isTyping: base.isTyping,
        isThresholdExceedJVSummarisation: base.isThresholdExceedJVSummarisation,
        showSummaryTab: base.showSummaryTab,
        forceSummaryTab: base.forceSummaryTab,
        ispreparer: base.ispreparer,
      };
    },

    commentaryMainTabListeners() {
      // Use a generic update handler for all update events
      const createUpdateHandler = (propName) => (val) => { this[propName] = val; };
      
      return {
        'update:bulkcommentall': createUpdateHandler('bulkcommentall'),
        'update:bulkcommentreplace': createUpdateHandler('bulkcommentreplace'),
        'update:attachmentfile': createUpdateHandler('attachmentfile'),
        'update:requestcommentarylocalcontrol': createUpdateHandler('requestcommentarylocalcontrol'),
        'update:requestcommentarylocalmanagement': createUpdateHandler('requestcommentarylocalmanagement'),
        'update:requestcommentaryregionalcontrol': createUpdateHandler('requestcommentaryregionalcontrol'),
        'update:requestcommentaryregionalmanagement': createUpdateHandler('requestcommentaryregionalmanagement'),
        'update:requestcommentarylocalcontrolvsProforma': createUpdateHandler('requestcommentarylocalcontrolvsProforma'),
        'update:requestcommentarylocalcontrolvsForecast': createUpdateHandler('requestcommentarylocalcontrolvsForecast'),
        'update:requestcommentarylocalmanagementvsProforma': createUpdateHandler('requestcommentarylocalmanagementvsProforma'),
        'update:requestcommentarylocalmanagementvsForecast': createUpdateHandler('requestcommentarylocalmanagementvsForecast'),
        'update:requestcommentaryregionalcontrolvsProforma': createUpdateHandler('requestcommentaryregionalcontrolvsProforma'),
        'update:requestcommentaryregionalmanagementvsProforma': createUpdateHandler('requestcommentaryregionalmanagementvsProforma'),
        'update:requestcommentaryregionalcontrolvsForecast': createUpdateHandler('requestcommentaryregionalcontrolvsForecast'),
        'update:requestcommentaryregionalmanagementvsForecast': createUpdateHandler('requestcommentaryregionalmanagementvsForecast'),
        'toggle-local-commentary-collapse': this.toggleLocalCommentaryCollapse,
        'toggle-local-commentary-reason-collapse': this.toggleLocalCommentaryReasonCollapse,
        'generate-ai': this.handleGenerateAI,
        'attachment-change': this.handleAttachmentChange,
      };
    },

    commentarySummaryTabListeners() {
      const createUpdateHandler = (propName) => (val) => { this[propName] = val; };
      
      return {
        'update:summaryAiProforma': createUpdateHandler('summaryAiProforma'),
        'update:summaryAiForecast': createUpdateHandler('summaryAiForecast'),
        'update:aitext': createUpdateHandler('aitext'),
        'generate-ai-summary': this.handleGenerateAISummary,
      };
    },
    
    // User ID from store
    userid() {
      return this.$store.state.user?.id || this.$store.state.userid || '';
    },
    
    // Reject target options for regional approvers (localized)
    rejectTargetList() {
      return helpers.getRejectTargetList(this.workflows, this.$nova.labelsName);
    },
    
    // Filtered commentary data based on filters
    filteredcommentarydata() {
      if (!this.commentarydata?.length) return [];
      
      const { selectedfilter: currentFilters, customfilterstoggle: customFilterActive, 
              customfilter: customFilterList, slGroupedView, expandedIds } = this;
      const isUngrouped = slGroupedView === 1;
      
      return this.commentarydata.reduce((filtered, el, i) => {
        // Set index and key
        el.__key = i;
        el.__index = i;
        
        // Ensure __stage is set
        el.__stage = el.__stage ?? this.getStageFromItem(el);
        
        // Get the filter flag
        const [shouldIgnore] = this.getFilterFlag(el, currentFilters, customFilterActive, customFilterList);
        
        if (shouldIgnore) return filtered;
        
        // Skip headers entirely in ungrouped view
        if (isUngrouped && el.__type === 'header') return filtered;

        // In grouped view, skip child rows whose parent is collapsed
        const isChildRow = el.__type === 'child' || el.level > 0;
        if (!isUngrouped && isChildRow) {
          const parentCode = el.__parent || el.parentcode || el.parent_code;
          const normalizedParent = parentCode ? String(parentCode) : '';
          if (normalizedParent && normalizedParent !== 'primary' && normalizedParent !== 'NA' && !expandedIds.has(normalizedParent)) {
            return filtered;
          }
        }
        
        filtered.push(el);
        return filtered;
      }, []);
    },
    
    // Paged items for pagination
    pagedItems() {
      const start = (this.page - 1) * this.pageSize;
      return this.filteredcommentarydata.slice(start, start + this.pageSize);
    },
    
    // Total page count
    pagecount() {
      return Math.ceil(this.filteredcommentarydata.length / this.pageSize) || 1;
    },
    
    // Check if filters are actually filtering out items (not just showing all)
    // Returns true when items have been filtered out due to filter selection
    isFilterSet() {
      return this.customfilterstoggle || 
             this.filteredcommentarydata.length < this.commentarydata.length;
    },
    
    // GL Code text for breadcrumbs
    glCodeText() {
      const ruData = this.commentaryrudata?.name 
        ? this.commentaryrudata 
        : this.commentarycycledata?.reportingunit_detail;
      
      return ruData 
        ? `${ruData.code || ''} - ${ruData.name || ''}` 
        : 'Actual Cycle';
    },
    
    // Active commentary for summary
    activeCommentary() {
      if (this.selectedcommentary && Object.keys(this.selectedcommentary).length > 0) {
        return this.selectedcommentary;
      }

      if (this.selectedGLCommentary && Object.keys(this.selectedGLCommentary).length > 0) {
        return this.selectedGLCommentary;
      }

      const { contextKey } = this.trendlineFetchParams;
      if (contextKey) {
        const entry = this.trendlineDataByKey(contextKey);
        if (entry && typeof entry === 'object') {
          return entry;
        }
      }

      return {};
    },
    
    // Summary data computed
  summaryData() {
      const source = this.selectedGLCommentary;
      if (!source) {
        return null;
      }

      const glCode = source.glcode_detail?.code || source.glcode || source.gl_code || source.cl_code || source._id || '';
      const description = source.glcode_detail?.name || source.description || source.gl_description || source.glcode_detail?.description || '';
      const displayCode = glCode
        ? (description ? `${glCode} - ${description}` : glCode)
        : (description || '');

      const actualLabel = source.amount1heading || this.actualLabel;
      const proformaLabel = source.amount2heading || this.proformaLabel;
      const forecastLabel = source.amount3heading || this.forecastLabel;

      return {
        displayCode: displayCode || 'GL Details',
        description,
        cycleLabel: this.selectedCommentaryCycle?.cycle_name || this.selectedCommentaryCycle?.label || '',
        actualLabel,
        proformaLabel,
        forecastLabel,
        actualAmount: source.amount1,
        proformaAmount: source.amount2,
        forecastAmount: source.amount3,
        proformaVarianceAmount: source.varianceamount1,
        proformaVariancePercent: source.variancepercent1,
        forecastVarianceAmount: source.varianceamount2,
        forecastVariancePercent: source.variancepercent2,
        localCommentary: source.commentary1,
        forecastCommentary: source.commentary2,
      };
    },

    
    // Gen AI computed properties
    commentaryGenAiBtntab() {
      return this.commentaryGenAiBtntabValue;
    },
    isThresholdExceedCommentary() {
      const status = this.commentaryStatusData;
      if (!status) return false;
      return status.isExceed || false;
    },
    
    // Bulk approve local items
    bulkApproveLocalItems() {
      return this.bulkapprovelocalfiledata && Object.keys(this.bulkapprovelocalfiledata).length > 0
        ? Object.values(this.bulkapprovelocalfiledata)
        : [];
    },
    
    // Check if bulk submit is disabled
    isBulkSubmitDisabled() {
      return this.bulksubmitfiledataerrorisApprover || 
             !this.approverBulkSubmitData || 
             Object.keys(this.approverBulkSubmitData).length === 0;
    },
    
    /**
     * Check if preparer has any items available for bulk local commentary submission
     * Preparer can only add local commentary when stage is in [-1, 0, 1, 9]
     * If all items are in regional stages (5, 6, 7, etc.), hide bulk submit button
     */
    hasPreparerActionableItems() {
      if (!this.commentarydata?.length) return false;
      
      const preparerActionableStages = this.workflows.islocalenabled 
        ? [-1, 0, 1, 9, 3, 4, 8] 
        : [-1, 0, 1, 9];
      
      return this.commentarydata.some(item => preparerActionableStages.includes(item.__stage));
    },
    
    ...mapState('varianceanalysis', {
      SLData: state => state.SLData
    }),
    ...mapGetters('varianceanalysis', {
      trendlineLogsByKey: 'getTrendlineLogs',
      trendlineDataByKey: 'getTrendlineData',
      trendlineLoadingFlag: 'getTrendlineLoading',
      trendlineActiveContextKey: 'getTrendlineActiveKey',
      slAiResponseTextFromStore: 'getSlAiResponseText',
      slAiLoadingProformaFromStore: 'getSlAiLoadingProforma',
      slAiLoadingForecastFromStore: 'getSlAiLoadingForecast',
      slAiGeneratedVariant: 'getSlLastGeneratedVariant',
      slSummaryResponseTextFromStore: 'getSlSummaryResponseText',
      slSummaryLoadingProformaFromStore: 'getSlSummaryLoadingProforma',
      slSummaryLoadingForecastFromStore: 'getSlSummaryLoadingForecast',
      slSummaryVariantFromStore: 'getSlLastSummaryVariant',
      slCommentaryLastAction: 'getSlCommentaryLastAction',
    }),
    trendlineLogsKey() {
      const commentary = this.selectedcommentary || {};
      const commentaryId = commentary._id || commentary.id || '';
      if (!commentaryId) {
        return '';
      }
      const cycleType = this.normalizeCycleType(this.cycletype) || 'Actual';
      return `${commentaryId}__${cycleType}`;
    },
    trendlineLogs() {
      if (!this.trendlineLogsKey) {
        return [];
      }
      const logs = this.trendlineLogsByKey(this.trendlineLogsKey);
      return Array.isArray(logs) ? logs : [];
    },
    trendlineFetchParams() {
      const context = this.sanitizedTrendlineCommentary || {};
      const derivedContext = this.trendContext || {};

      const glcode = this.normalizeIdentifier([
        context.glcode_detail?._id,
        context.glcodeId,
        context.glcode,
        context.glcode_internal,
        context.gl_code,
        context.client_code,
        context.cl_code,
        context.clcode,
        context.glcode_detail?.code,
        context.glcode_detail?.glcode,
        context._id,
        this.glcodeId,
      ]);

      const year = this.normalizeIdentifier([
        derivedContext.year?._id,
        derivedContext.year?.id,
        derivedContext.year,
        context.year_detail?._id,
        context.year,
        this.commentarycycledata?.year_detail?._id,
        this.commentarycycledata?.year,
        // SLData.year is set from buildSlContextPayload in RUDataTable
        // yearName in this app contains the year _id (e.g., "2023")
        this.SLData?.year,
        this.SLData?.yearName,
        this.SLData?.year_detail?._id,
        this.SLData?.selectedGLCommentary?.year_detail?._id,
        this.SLData?.selectedGLCommentary?.year,
        this.SLData?.selectedCommentaryCycle?.year_detail?._id,
        this.SLData?.selectedCommentaryCycle?.year,
        this.yearId,
        this.year,
        this.yearName,
      ]);

      const period = this.normalizeIdentifier([
        derivedContext.period?._id,
        derivedContext.period?.id,
        derivedContext.period,
        context.period_detail?._id,
        context.period,
        this.periodId,
        this.period,
        this.SLData?.period,
      ]);

      const reportingunit = this.normalizeIdentifier([
        derivedContext.reportingunit?._id,
        derivedContext.reportingunit?.id,
        derivedContext.reportingunit,
        context.reportingunit_detail?._id,
        context.reportingunit,
        this.reportingunit,
        this.SLData?.reportingunit,
        this.reportingunitId,
      ]);
      const rawCycleType = this.normalizeIdentifier([this.cycletype, derivedContext.cycletype]) || 'Actual';
      const cycleType = this.normalizeCycleType(rawCycleType) || 'Actual';

      // Convert year to number if it's a numeric string (API expects number)
      // Year IDs in this app are numeric values like 2023, 2024, 2025
      const yearValue = year && !isNaN(Number(year)) ? Number(year) : year;

      if ([glcode, yearValue, period, reportingunit, cycleType].some((value) => this.isMissingValue(value))) {
        console.warn('[GLBreakdown] trendlineFetchParams - missing required values');
        return { contextKey: '', filter: null };
      }

      // Normalize reporting type so PL vs BS are cached separately and filter is always explicit.
      const reportingTypeKey = (String(this.reportingType || 'pl').trim().toLowerCase() === 'bs') ? 'bs' : 'pl';

      const contextKey = `${glcode}__${yearValue}__${period}__${reportingunit}__${cycleType}__${reportingTypeKey}`;

      return {
        contextKey,
        filter: {
          cycletype: cycleType,
          glcode,
          year: yearValue,
          period,
          reportingunit,
          reporting_type: reportingTypeKey,
        },
      };
    },
    hasTrendlineDataset() {
      const { contextKey } = this.trendlineFetchParams;
      if (!contextKey) {
        return false;
      }
      const existing = this.trendlineDataByKey(contextKey);
      return Array.isArray(existing) && existing.length > 0;
    },
    selectedGLCommentary() {
      return this.SLData.selectedGLCommentary || {};
    },
    selectedCommentaryCycle() {
      return this.SLData.selectedCommentaryCycle || {};
    },
    selectedStoreCommentary() {
      return this.SLData.selectedCommentary || {};
    },
    // GL Code info for breadcrumbs
    glCodeInfo() {
      const source = this.selectedGLCommentary;
      if (!source || !Object.keys(source).length) return '';
      
      const glCode = source.glcode_detail?.code || source.glcode || source.gl_code || '';
      const description = source.glcode_detail?.name || source.description || source.gl_description || '';
      
      return glCode && description ? `${glCode} - ${description}` : (glCode || description || '');
    },
    /**
     * Build conversation control options for the Breadcrumbs header so SL Breakup can surface the dialog-level conversation entry point.
     */
    breadcrumbsConversationOptions() {
      const source = this.selectedGLCommentary;
      if (!source || !source._id) {
        return null;
      }

      const cycleId = source.cycle || this.selectedCommentaryCycle?._id || this.commentarycycledata?._id;
      if (!cycleId) {
        return null;
      }

      const basePath = ANALYSIS_API_BASE;
      const conversationEnabled = (this.workflowtext || '').length !== 8;

      return {
        enabled: conversationEnabled,
        tooltip: this.workflowsDisabledMessage || 'Workflows disabled for this GL.',
        closed: this.cyclestage === 1 || this.isviewonly,
        highlight: !source.conversation_read,
        notify: !source.conversation_read,
        getApi: `${basePath}/getconversation/${cycleId}/c/${source._id}`,
        sendApi: `${basePath}/addconversation/${cycleId}/c/${source._id}`,
        readApi: `${basePath}/markreadconversation/${cycleId}/c/${source._id}`,
      };
    },
    /**
     * Provide activity log configuration for the Breadcrumbs header to expose the GL level history surface.
     */
    breadcrumbsActivityLogOptions() {
      const source = this.selectedGLCommentary;
      if (!source || !source._id || !this.activitylogconfiggl) {
        return null;
      }

      const activityType = this.selectedCommentaryCycle?.type || this.commentarycycledata?.type;
      if (!activityType) {
        return null;
      }

      return {
        config: this.activitylogconfiggl,
        url: `${ANALYSIS_API_BASE}/getlogs/${source._id}/f/${activityType}`,
      };
    },
    /**
     * Provide request commentary options for the Breadcrumbs header.
     * Shows request commentary buttons based on user role and current stage.
     * Stages [3,4,7,8,9] are eligible for request commentary.
     */
    breadcrumbsRequestCommentaryOptions() {
      const source = this.selectedcommentary || this.selectedGLCommentary;
      if (!source || !source._id) {
        return null;
      }

      const stage = source.__stage;
      const isEligibleStage = REQUEST_COMMENTARY_ELIGIBLE_STAGES.includes(stage);

      if (!isEligibleStage) {
        return null;
      }

      // Local request: local approver can request commentary for eligible stages
      // when local workflows are enabled
      const showLocalRequest = this.isapprover && this.workflows.islocalenabled;

      // Regional request: regional approver can request commentary for eligible stages
      // when regional workflows are enabled
      const showRegionalRequest = this.isregionalapprover && this.workflows.isregionalenabled;

      if (!showLocalRequest && !showRegionalRequest) {
        return null;
      }

      return {
        showLocalRequest,
        showRegionalRequest,
        localEnabled: this.workflows.islocalenabled,
        regionalEnabled: this.workflows.isregionalenabled,
      };
    },
    // Cycle data list for RUDataTable - maps cycle IDs to cycle data objects
    commentarycycledatalist() {
      if (!this.commentarycycledata || !this.commentarycycledata._id) {
        return {};
      }
      // Return an object with cycle ID as key and cycle data as value
      return {
        [this.commentarycycledata._id]: this.commentarycycledata
      };
    },
  },

  methods: {
    isActualJVCommentaryValidForLocal(data) {
      return helpers.isActualJVCommentaryValidForLocal(data, this.workflows);
    },
    isForecastJVCommentaryValidForLocal(data) {
      return helpers.isForecastJVCommentaryValidForLocal(data, this.workflows);
    },
    /**
     * Helper to forward update events to data properties.
     * Used by CommentaryMainTab @update listeners in the template.
     */
    forward(eventName, value) {
      if (typeof eventName === 'string' && eventName.startsWith('update:')) {
        const propName = eventName.replace('update:', '');
        // Only update if the property exists on the instance (or is reactive)
        // We can check if it's undefined to avoid creating new properties, 
        // but Vue sets new properties on the root object as reactive sometimes,
        // though best practice is they should be pre-defined in data.
        // Given the grep search, these properties are in data().
        this[propName] = value;
      }
    },

    /**
     * Open the revenue drill-down dialog with the selected row details.
     */
    handleOpenRevenueDrilldown(row) {
      if (!row) {
        return;
      }
      this.revenueDrilldownRow = row;
      this.revenueDrilldownDialogVisible = true;
    },

    /**
     * Close the revenue drill-down dialog and clear its row context.
     */
    handleCloseRevenueDrilldown() {
      this.revenueDrilldownDialogVisible = false;
      this.revenueDrilldownRow = null;
    },
    ...mapActions('varianceanalysis', {
      fetchTrendlineDataAction: 'fetchTrendlineData',
      generateSlCommentaryAiAction: 'generateSlCommentaryAI',
      generateSlCommentarySummaryAction: 'generateSlCommentarySummary',
      approveSlCommentaryAction: 'approveSlCommentary',
      rejectSlCommentaryAction: 'rejectSlCommentary',
      saveSlCommentaryAction: 'saveSlCommentary',
      saveRegionalApprovalReasonAction: 'saveRegionalApprovalReason',
      addSlCommentaryAction: 'addSlCommentary',
      cacheSlContextAction: 'cacheSLData',
    }),
    hasValidSlContext(context) {
      if (!context) {
        return false;
      }
      const selectedCommentary = context.selectedGLCommentary || context.selectedCommentary;
      const selectedCycle = context.selectedCommentaryCycle || {};
      return Boolean(selectedCommentary && Object.keys(selectedCommentary).length && selectedCycle && Object.keys(selectedCycle).length);
    },
    restorePersistedSlContext() {
      if (typeof window === 'undefined' || !window.sessionStorage) {
        return null;
      }
      const persisted = window.sessionStorage.getItem(SL_CONTEXT_STORAGE_KEY);
      if (!persisted) {
        return null;
      }
      try {
        const parsed = JSON.parse(persisted);
        const routeCycleId = this.$route.params.cycleId;
        const storedCycleId = parsed?.selectedCommentaryCycle?._id || parsed?.selectedCommentaryCycle?.id || parsed?.selectedCommentaryCycle?.cycle_id;
        if (routeCycleId && storedCycleId && routeCycleId !== storedCycleId) {
          return null;
        }
        return parsed;
      } catch (error) {
        console.warn('[GLBreakdown] Failed to parse persisted SL context', error);
        return null;
      }
    },
    // Toggle the summary card accordion so the section can collapse or expand on demand
    toggleSummaryAccordion() {
      this.isSummaryExpanded = !this.isSummaryExpanded;
    },

    isMissingValue(value) {
      return value === null || value === undefined || value === '';
    },

    normalizeTabIndex(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }

      if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null;
      }

      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    },

    normalizeCycleType(value) {
      if (value === null || value === undefined) {
        return '';
      }

      const text = String(value).trim();
      if (!text) {
        return '';
      }

      const lowered = text.toLowerCase();
      if (lowered === 'actual') {
        return 'Actual';
      }
      if (lowered === 'forecast') {
        return 'Forecast';
      }
      if (lowered === 'proforma') {
        return 'Proforma';
      }

      return text;
    },

    normalizeIdentifier(value) {
      if (value === null || value === undefined) {
        return '';
      }

      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        return String(value).trim();
      }

      if (Array.isArray(value)) {
        for (const entry of value) {
          const normalized = this.normalizeIdentifier(entry);
          if (normalized) {
            return normalized;
          }
        }
        return '';
      }

      if (typeof value === 'object') {
        const candidates = [
          value._id,
          value.id,
          value.code,
          value.value,
          value.number,
          value.glcode,
          value.gl_code,
          value.period,
          value.reportingunit,
        ];
        for (const candidate of candidates) {
          const normalized = this.normalizeIdentifier(candidate);
          if (normalized) {
            return normalized;
          }
        }
        return '';
      }

      return '';
    },

    normalizeLookupKey(value) {
      const normalized = this.normalizeIdentifier(value);
      return normalized ? normalized.toUpperCase() : '';
    },

    async ensureTrendlineDataset(force = false) {
      if (this.normalizeTabIndex(this.slTab) !== 1) {
        return;
      }

      const { filter, contextKey } = this.trendlineFetchParams;
      if (!filter || !contextKey) {
        console.warn('[GLBreakdown]: Trendline fetch skipped due to incomplete context', { contextKey, filter });
        return;
      }

      const isLoadingForContext = this.trendlineLoadingFlag && this.trendlineActiveContextKey === contextKey;
      if (!force) {
        const existing = this.trendlineDataByKey(contextKey);
        if (Array.isArray(existing) && existing.length > 0) {
          return;
        }
        if (isLoadingForContext) {
          return;
        }
      }

      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        console.warn('[GLBreakdown]: Axios instance missing for trendline fetch');
        return;
      }

      try {
        await this.fetchTrendlineDataAction({
          axios: axiosInstance,
          filter,
          contextKey,
          successMessage: '',
        });
      } catch (error) {
        console.error('[GLBreakdown]: fetchTrendlineDataAction failed', error);
      }
    },

    async ensureDialogTrendlineDataset(force = false) {
      const { filter, contextKey } = this.trendlineFetchParams;
      if (!filter || !contextKey) {
        return;
      }

      const existing = this.trendlineDataByKey(contextKey);
      const isLoadingForContext = this.trendlineLoadingFlag && this.trendlineActiveContextKey === contextKey;
      if (!force) {
        if (Array.isArray(existing) && existing.length > 0) {
          return;
        }
        if (isLoadingForContext) {
          return;
        }
      }

      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        console.warn('[GLBreakdown]: Axios instance missing for dialog trendline fetch');
        return;
      }

      try {
        await this.fetchTrendlineDataAction({
          axios: axiosInstance,
          filter,
          contextKey,
          successMessage: '',
        });
      } catch (error) {
        console.error('[GLBreakdown]: ensureDialogTrendlineDataset failed', error);
      }
    },

    /**
     * Load GL Details - Lightweight API call on page load
     * Calls /v3/varianceanalysis/analysis/getgldetails/
     * Returns detailed GL information including amounts, variances, and commentary
     * @param {Boolean} showLoader - Whether to show loading shimmer (default: false for initial load, true for refresh after save)
     */
    async loadGLDetails(showLoader = false, suppressLoadingManagement = false) {
      const glcode = this.glcodeId || this.selectedcommentary?.glcode || this.selectedcommentary?.glcode_detail?._id;
      const reportingunit = this.reportingunitId;
      const period = this.periodId;
      const cycletype = this.cycletype;

      if (!glcode || !reportingunit || !period) {
        console.warn('[GLBreakdown] loadGLDetails - missing required params:', { glcode, reportingunit, period });
        return;
      }

      // Show loading shimmer if requested (e.g., after save/submit) and not suppressed
      if (showLoader && !suppressLoadingManagement) {
        this.isReportingUnitdataloading = true;
      }

      try {
        const response = await helpers.apiGet.call(this, '/v3/varianceanalysis/analysis/getgldetails/', {
            reportingunit,
            period,
            glcode,
            cycletype,
            reporting_type: this.reportingType || 'pl',
          });

        if (response.data.status === 'success' && response.data.data && response.data.data.length > 0) {
          const glDetails = response.data.data[0];
          this.commentaryBaselinesReady = false;
          
          // Check original emptiness before potentially populating with saved commentary
          // This allows the Save button to persist while typing
          const isEmpty = (val) => !val || !val.replace(/<[^>]*>/g, '').trim();
          const c1Empty = isEmpty(glDetails.commentary1);
          const c2Empty = isEmpty(glDetails.commentary2);
          glDetails.isOriginalEmpty = c1Empty && c2Empty;

          glDetails.__submittedCommentary1 = glDetails.commentary1;
          glDetails.__submittedCommentary2 = glDetails.commentary2;
          glDetails.__submittedRegionalCommentary1 = glDetails.regionalcommentary1;
          glDetails.__submittedRegionalCommentary2 = glDetails.regionalcommentary2;

          // Priority logic: display saved draft if submitted commentary is empty
          if (c1Empty && !isEmpty(glDetails.savedcommentary1)) {
            glDetails.commentary1 = glDetails.savedcommentary1;
          }
          if (c2Empty && !isEmpty(glDetails.savedcommentary2)) {
            glDetails.commentary2 = glDetails.savedcommentary2;
          }

          const rc1Empty = isEmpty(glDetails.regionalcommentary1);
          const rc2Empty = isEmpty(glDetails.regionalcommentary2);
          if (rc1Empty && !isEmpty(glDetails.savedregionalcommentary1)) {
            glDetails.regionalcommentary1 = glDetails.savedregionalcommentary1;
          }
          if (rc2Empty && !isEmpty(glDetails.savedregionalcommentary2)) {
            glDetails.regionalcommentary2 = glDetails.savedregionalcommentary2;
          }

          const reasonEmpty = isEmpty(glDetails.regionalapprovereason);
          if (reasonEmpty && !isEmpty(glDetails.savedregionalreason)) {
            glDetails.regionalapprovereason = glDetails.savedregionalreason;
          }

          const localReasonEmpty = isEmpty(glDetails.approvereason);
          if (localReasonEmpty && !isEmpty(glDetails.savedreason)) {
            glDetails.approvereason = glDetails.savedreason;
          }

          // Build the merged object first - don't include __stage/__myaction so they get recalculated
          const merged = {
            ...this.selectedcommentary,
            ...glDetails,
            // Preserve the _id from the original selectedcommentary if glDetails doesn't have it
            _id: glDetails._id || this.selectedcommentary._id,
          };
          
          // Delete old computed fields so getStageFromItem recalculates from stage_local/stage_regional
          delete merged.__stage;
          delete merged.__myaction;
          delete merged.stage; // Also delete 'stage' to force recalculation from stage_local/stage_regional
          
          // Calculate __stage from the merged data (stage_local/stage_regional from API response)
          merged.__stage = this.getStageFromItem(merged);
          
          // Calculate __myaction based on updated stage
          merged.__myaction = this.getActionFromItem(merged);
          
          
          // Assign the fully computed object to trigger Vue reactivity
          this.selectedcommentary = merged;
          
          // Update Vuex store's selectedGLCommentary to keep breadcrumbs in sync
          // This ensures the watcher doesn't overwrite our updated stage values
          this.$store.commit('varianceanalysis/updateSelectedGLCommentary', {
            stage_local: merged.stage_local,
            stage_regional: merged.stage_regional,
            __stage: merged.__stage,
            __myaction: merged.__myaction,
            // Keep reject/approve reasons on the store snapshot so later syncs do not drop them
            approvereason: merged.approvereason,
            rejectreason: merged.rejectreason,
            regionalapprovereason: merged.regionalapprovereason,
            regionalrejectreason: merged.regionalrejectreason,
          });
          
          // Ensure readable identifiers
          if (this.selectedcommentary && Object.keys(this.selectedcommentary).length) {
            this.ensureReadableIdentifiers(this.selectedcommentary);
          }
          
          // Apply summary state from the updated commentary
          this.applySummaryStateFromCommentary(this.selectedcommentary, true);
          
          // Initialize lastActionsOnGL from stage values for approval/rejection reason display
          // Stage is authoritative for current reject/approve; merge with logs when available.
          this.lastActionsOnGL = this.mergeLastActionsFromStageAndLogs(
            merged,
            this.trendlineLogs
          );
          
          // Pre-populate regional commentary fields when local has been approved
          // This runs after local approver approves/rejects and GL is now ready for regional
          if (merged.__myaction === 'regionaladd' || merged.__myaction === 'regionalapprove' || merged.__myaction === 'regionalvoluntary') {
            this.handleAddRegionalCommentaryDataSetup(merged);
          }

          this.scheduleCommentaryBaselineCapture();
        }
      } catch (error) {
        console.error('[GLBreakdown] loadGLDetails failed:', error);
        // Don't block page load if this fails - selectedcommentary already has data from store
      } finally {
        // Only clear loading if we're managing it ourselves (not suppressed by handleRefresh)
        if (!suppressLoadingManagement) {
          this.isReportingUnitdataloading = false;
        }
      }
    },

    // NOTE: SL data loading methods (loadSLData, processLoadedData, buildSLTreeData,
    // buildVirtualParentTreeData, buildTraditionalTreeData) have been moved to
    // SLBreakup.vue which handles all SL operations independently.

    cloneCommentaryItem(item) {
      if (!item || typeof item !== 'object') {
        return {};
      }
      try {
        return JSON.parse(JSON.stringify(item));
      } catch (error) {
        console.warn('[GLBreakdown] Failed to clone commentary item', error);
        return { ...item };
      }
    },
    getEmptyLastActions() {
      // Provide predictable structure when no log entries are available.
      return {
        localaction: { type: 'none', lastAction: '' },
        regionalaction: { type: 'none', lastAction: '' },
      };
    },

    /**
     * Merge stage-derived and log-derived last actions.
     * Stage wins for current reject/approve (-1 / 2); logs fill gaps when stage is neutral.
     */
    mergeLastActionsFromStageAndLogs(commentary, logs) {
      const fromStage = this.deriveLastActionsFromStage(commentary);
      const hasLogs = Array.isArray(logs) && logs.length > 0;
      if (!hasLogs) {
        return fromStage;
      }
      const fromLogs = this.deriveLastActionsFromLogs(logs);
      return {
        localaction: fromStage.localaction.lastAction
          ? fromStage.localaction
          : fromLogs.localaction,
        regionalaction: fromStage.regionalaction.lastAction
          ? fromStage.regionalaction
          : fromLogs.regionalaction,
      };
    },

    /**
     * Derive last actions from commentary stage values when trendline logs are not available.
     * This provides a fallback to show approval/rejection reasons based on stage_local and stage_regional.
     * @param {Object} commentary - The selected commentary object with stage_local and stage_regional
     * @returns {Object} Last actions object with localaction and regionalaction
     */
    deriveLastActionsFromStage(commentary) {
      const baseResult = this.getEmptyLastActions();
      
      if (!commentary) {
        return baseResult;
      }
      
      const stageLocal = Number(commentary.stage_local);
      const stageRegional = Number(commentary.stage_regional);
      
      // DB stage values (stage_local / stage_regional):
      // -1 = Rejected
      //  0 = Awaiting commentary
      //  1 = Submitted / pending approval
      //  2 = Approved
      //  3 = Nil value
      //  4 = Immaterial variance
      // UI __stage uses different numbers (e.g. -2 for regional rejected).
      
      // Local: only -1 (reject) and 2 (approve) imply a local approve/reject reason.
      // Stage 3/4 are nil/immaterial (localvoluntary) — do not treat as localapprove.
      if (stageLocal === -1) {
        baseResult.localaction = { type: 'reject', lastAction: 'localreject' };
      } else if (stageLocal === 2) {
        baseResult.localaction = { type: 'approve', lastAction: 'localapprove' };
      }
      
      // Regional: -1 = reject to local approver (always wins).
      // stage 2 = approved (wins over any stale regionalrejectreason).
      // RA→Local Preparer: stage_regional reset to 0, stage_local=-1, reason on regionalrejectreason.
      // stage 4 can still carry regionalapprovereason after regional review.
      if (stageRegional === -1) {
        baseResult.regionalaction = { type: 'reject', lastAction: 'regionalreject' };
      } else if (stageRegional === 2) {
        baseResult.regionalaction = { type: 'approve', lastAction: 'regionalapprove' };
      } else if (
        (stageLocal === -1 && stageRegional === 0 && !!commentary.regionalrejectreason) ||
        !!commentary.regionalrejectreason
      ) {
        baseResult.regionalaction = { type: 'reject', lastAction: 'regionalreject' };
      } else if (stageRegional === 4 && !!commentary.regionalapprovereason) {
        baseResult.regionalaction = { type: 'approve', lastAction: 'regionalapprove' };
      }
      
      return baseResult;
    },

    /**
     * Pre-populate regional commentary fields with local commentary + approval reason
     * Called after local approver approves/rejects and GL moves to regional stage
     * Mirrors the logic from helpers.js handleAddRegionalCommentaryDataSetup
     * @param {Object} selectedData - The selected commentary data
     */
    handleAddRegionalCommentaryDataSetup(selectedData) {
      try {
        const approvalstr = this.selectedcommentary.approvereason || '';
        const stageRegional = selectedData?.stage_regional ?? this.selectedcommentary.stage_regional ?? 0;

        // Helper to format JV commentary objects to strings
        const formatJvCommentary = (val) => {
          if (!val) return '';
          if (typeof val === 'string') return val;
          if (typeof val === 'object' && val !== null) {
            return Object.entries(val).map(([key, value]) => `${key}: ${value}`).join('\n');
          }
          return '';
        };

        // If local workflow is disabled, regional enabled, and JV commentary exists, show JV commentary in regional box
        // Valid stages: 0 (Awaiting), 3 (Nil Value), 4 (Immaterial Variance), 9 (Not In Scope) — matches helpers.js
        const validStagesForRegionalJV = [
          STAGES.COMMENTARY_AWAITING,
          STAGES.COMMENTARY_NIL_VALUE,
          STAGES.IMMATERIAL_VARIANCE,
          STAGES.COMMENTARY_NOT_IN_SCOPE
        ];
        if (!this.workflows.islocalenabled && this.workflows.isregionalenabled && validStagesForRegionalJV.includes(stageRegional)) {
          if (this.selectedcommentary.jv_commentary1) {
            this.selectedcommentary.regionalcommentary1 = formatJvCommentary(this.selectedcommentary.jv_commentary1);
          }
          if (this.selectedcommentary.jv_commentary2) {
            this.selectedcommentary.regionalcommentary2 = formatJvCommentary(this.selectedcommentary.jv_commentary2);
          }
        } else {
          // Otherwise, append local commentary and approval reason as before
          const isEmptyRegional = (value) => !this.normalizeCommentaryText(value);
          if (isEmptyRegional(this.selectedcommentary.regionalcommentary1)) {
            if (this.selectedcommentary.commentary1 && this.workflows.isregionalproformaenabled) {
              this.selectedcommentary.regionalcommentary1 = this.selectedcommentary.commentary1 + '. ' + approvalstr;
            } else if (this.workflows.isregionalproformaenabled) {
              this.selectedcommentary.regionalcommentary1 = approvalstr;
            } else {
              this.selectedcommentary.regionalcommentary1 = '';
            }
          }
          if (isEmptyRegional(this.selectedcommentary.regionalcommentary2)) {
            if (this.selectedcommentary.commentary2 && this.workflows.isregionalforecastenabled) {
              this.selectedcommentary.regionalcommentary2 = this.selectedcommentary.commentary2 + '. ' + approvalstr;
            } else if (this.workflows.isregionalforecastenabled) {
              this.selectedcommentary.regionalcommentary2 = approvalstr;
            } else {
              this.selectedcommentary.regionalcommentary2 = '';
            }
          }
          if (!this.workflows.isregionalproformaenabled) {
            this.selectedcommentary.regionalcommentary1 = '';
          }
          if (!this.workflows.isregionalforecastenabled) {
            this.selectedcommentary.regionalcommentary2 = '';
          }
          // Special case for commentary2 with no threshold crossed
          if (
            isEmptyRegional(this.selectedcommentary.regionalcommentary2) &&
            this.selectedcommentary.commentary2 &&
            !this.selectedcommentary.var2_cross_control &&
            !this.selectedcommentary.var2_cross_management &&
            !this.selectedcommentary.var2_cross_management_regional &&
            !this.selectedcommentary.var2_cross_control_regional
          ) {
            this.selectedcommentary.regionalcommentary2 = this.selectedcommentary.commentary2;
            if (typeof this.selectedcommentary.approvereason === 'string' && this.selectedcommentary.approvereason?.trim() !== '') {
              this.selectedcommentary.regionalcommentary2 += '  ' + this.selectedcommentary.approvereason;
            }
          }
        }
      } catch (error) {
        console.error('[GLBreakdown] Error in handleAddRegionalCommentaryDataSetup:', error);
      }
    },

    deriveLastActionsFromLogs(logs) {
      const entries = Array.isArray(logs) ? logs : [];
      const baseResult = this.getEmptyLastActions();

      if (!entries.length) {
        return baseResult;
      }

      const isActualCycle = (this.cycletype || 'Actual').toLowerCase() === 'actual';
      const actualConfig = {
        localTypes: ['a_localreject', 'a_localapprove', 'a_Localbulkreject', 'a_localbulkapprove', 'a_localfileapprove', 'a_localfilereject'],
        localMapping: {
          reject: ['a_localreject', 'a_Localbulkreject', 'a_localfilereject'],
          approve: ['a_localapprove', 'a_localbulkapprove', 'a_localfileapprove'],
          rejectLabel: 'localreject',
          approveLabel: 'localapprove',
        },
        regionalTypes: ['a_regionalreject', 'a_regionalapprove', 'a_Regionalbulkreject', 'a_regionalbulkapprove', 'a_regionalfileapprove', 'a_regionalfilereject'],
        regionalMapping: {
          reject: ['a_regionalreject', 'a_Regionalbulkreject', 'a_regionalfilereject'],
          approve: ['a_regionalapprove', 'a_regionalbulkapprove', 'a_regionalfileapprove'],
          rejectLabel: 'regionalreject',
          approveLabel: 'regionalapprove',
        },
      };

      const forecastConfig = {
        localTypes: ['f_localreject', 'f_localapprove', 'f_Localbulkreject', 'f_localbulkapprove', 'f_localfileapprove', 'f_localfilereject'],
        localMapping: {
          reject: ['f_localreject', 'f_Localbulkreject', 'f_localfilereject'],
          approve: ['f_localapprove', 'f_localbulkapprove', 'f_localfileapprove'],
          rejectLabel: 'localreject',
          approveLabel: 'localapprove',
        },
        regionalTypes: ['f_regionalreject', 'f_regionalapprove', 'f_Regionalbulkreject', 'f_regionalbulkapprove', 'f_regionalfileapprove', 'f_regionalfilereject'],
        regionalMapping: {
          reject: ['f_regionalreject', 'f_Regionalbulkreject', 'f_regionalfilereject'],
          approve: ['f_regionalapprove', 'f_regionalbulkapprove', 'f_regionalfileapprove'],
          rejectLabel: 'regionalreject',
          approveLabel: 'regionalapprove',
        },
      };

      const config = isActualCycle ? actualConfig : forecastConfig;

      const pickLatestByTypes = (types) => {
        let latest = null;
        for (const entry of entries) {
          if (!types.includes(entry.type)) {
            continue;
          }
          if (!latest || new Date(entry.created_at) > new Date(latest.created_at)) {
            latest = entry;
          }
        }
        return latest;
      };

      const annotate = (entry, mapping) => {
        if (!entry) {
          return { type: 'none', lastAction: '' };
        }
        const annotated = { ...entry };
        if (mapping.reject.includes(entry.type)) {
          annotated.lastAction = mapping.rejectLabel;
        } else if (mapping.approve.includes(entry.type)) {
          annotated.lastAction = mapping.approveLabel;
        } else {
          annotated.lastAction = '';
        }
        return annotated;
      };

      return {
        localaction: annotate(pickLatestByTypes(config.localTypes), config.localMapping),
        regionalaction: annotate(pickLatestByTypes(config.regionalTypes), config.regionalMapping),
      };
    },

    syncSelectedCommentary(force = false) {
      const storeItem = this.selectedGLCommentary;
      if (!storeItem || !Object.keys(storeItem).length) {
        if (force) {
          this.selectedcommentary = {};
          this.summaryAiProforma = '';
          this.summaryAiForecast = '';
          this.showSummaryTab = false;
        }
        return;
      }

      const storeKeys = this.extractCommentaryKeys(storeItem);
      const currentKeys = this.extractCommentaryKeys(this.selectedcommentary);
      const selectionChanged = force || (storeKeys.primary && storeKeys.primary !== currentKeys.primary);

      if (!force && storeKeys.primary && storeKeys.primary === currentKeys.primary) {
        return;
      }

      const lookupMaps = [
        this.commentarydatajsonById,
        this.commentarydatajson,
        this.commentarydatajsonByGLCode,
      ];

      const candidates = [
        storeKeys.primary,
        storeKeys.secondary,
        storeKeys.code,
        ...(storeKeys.aliases || []),
      ].filter(Boolean);

      let nextItem = null;
      for (const candidate of candidates) {
        const normalized = this.normalizeLookupKey(candidate);
        if (!normalized) {
          continue;
        }
        nextItem = lookupMaps.reduce((found, map) => found || map[normalized], null);
        if (nextItem) {
          break;
        }
      }

      if (!nextItem) {
        const fallbackKeys = [
          storeItem.glcode_detail?.code,
          storeItem.glcode_detail?.glcode,
          storeItem.glcode,
          storeItem.gl_code,
          storeItem.glcode_str,
          storeItem.clcode,
          storeItem.client_code,
          storeItem.client_glcode,
        ];
        for (const fallback of fallbackKeys) {
          const normalized = this.normalizeLookupKey(fallback);
          if (!normalized) {
            continue;
          }
          nextItem = this.commentarydatajsonByGLCode[normalized] || this.commentarydatajson[normalized];
          if (nextItem) {
            break;
          }
        }
      }

      if (!nextItem) {
        nextItem = storeItem;
      }

      this.selectedcommentary = this.mergeCommentaryData(nextItem, storeItem, this.selectedStoreCommentary);
      this.applySummaryStateFromCommentary(this.selectedcommentary, selectionChanged);
      if (selectionChanged) {
        this.scheduleCommentaryBaselineCapture();
      }
    },

    applySummaryStateFromCommentary(commentary, shouldHydrate = false) {
      if (!shouldHydrate) {
        return;
      }

      const fallbackProforma = typeof this.SLData?.summaryAiProforma === 'string' ? this.SLData.summaryAiProforma : '';
      const fallbackForecast = typeof this.SLData?.summaryAiForecast === 'string' ? this.SLData.summaryAiForecast : '';

      const summaryProforma = typeof commentary?.summarycommentary1 === 'string' ? commentary.summarycommentary1 : fallbackProforma;
      const summaryForecast = typeof commentary?.summarycommentary2 === 'string' ? commentary.summarycommentary2 : fallbackForecast;

      this.summaryAiProforma = summaryProforma || '';
      this.summaryAiForecast = summaryForecast || '';

      const hasSummary = Boolean(
        (this.summaryAiProforma && this.summaryAiProforma.trim()) ||
        (this.summaryAiForecast && this.summaryAiForecast.trim()),
      );
      const showSummaryPreference = typeof this.SLData?.showSummaryTab === 'boolean'
        ? this.SLData.showSummaryTab
        : undefined;
      this.showSummaryTab = showSummaryPreference !== undefined ? showSummaryPreference : hasSummary;

      if (commentary && commentary.isThresholdExceedJVSummarisation !== undefined) {
        this.isThresholdExceedJVSummarisation = Boolean(commentary.isThresholdExceedJVSummarisation);
      } else if (this.SLData?.isThresholdExceedJVSummarisation !== undefined) {
        this.isThresholdExceedJVSummarisation = Boolean(this.SLData.isThresholdExceedJVSummarisation);
      } else if (!hasSummary) {
        this.isThresholdExceedJVSummarisation = false;
      }
    },

    extractCommentaryKeys(item) {
      if (!item || typeof item !== 'object') {
        return { primary: '', secondary: '', code: '', aliases: [] };
      }

      const detail = item.glcode_detail || {};
      const register = (set, value, includeVariants = false) => {
        if (Array.isArray(value)) {
          value.forEach(entry => register(set, entry, includeVariants));
          return;
        }
        const normalized = this.normalizeLookupKey(value);
        if (!normalized) {
          return;
        }
        set.add(normalized);
        if (includeVariants) {
          const compact = normalized.replace(/[^A-Z0-9]/g, '');
          if (compact && compact !== normalized) {
            set.add(compact);
          }
        }
      };

      const primary = this.normalizeLookupKey([item._id, item.id]);

      const secondarySet = new Set();
      register(secondarySet, [item.glcode, item.gl_code, item.glcode_str, item.client_glcode]);
      register(secondarySet, [detail.code, detail.glcode, detail.client_code, detail.clcode]);
      register(secondarySet, [item.clcode, item.client_code, detail.path]);
      const secondary = secondarySet.size ? Array.from(secondarySet)[0] : '';

      const code = this.normalizeLookupKey([detail.code, detail.glcode, item.client_code, item.clcode]);

      const aliasSet = new Set();
      const aliasSources = [
        item.glcode_alias,
        item.glcode_aliases,
        item.alias,
        item.aliases,
        detail.alias,
        detail.aliases,
        detail.aliasList,
        detail.alias_codes,
        detail.alternate_codes,
        detail.alternateCodes,
        detail.legacy_codes,
        detail.legacyCodes,
        detail.alt_codes,
        detail.path,
      ];
      aliasSources.forEach(source => register(aliasSet, source, true));
      register(aliasSet, secondary, true);
      register(aliasSet, code, true);

      const aliases = Array.from(aliasSet).filter(value => value && value !== primary && value !== secondary && value !== code);

      return { primary, secondary, code, aliases };
    },

    // Merge processed SL dataset row with the GL snapshots from the store so inline tabs display GL numbers.
    mergeCommentaryData(datasetItem, ...storeItems) {
      const datasetClone = this.cloneCommentaryItem(datasetItem);
      const merged = { ...datasetClone, glcode_detail: { ...(datasetClone.glcode_detail || {}) } };

      const numericKeys = [
        'amount1', 'amount2', 'amount3',
        'varianceamount1', 'varianceamount2',
        'variancepercent1', 'variancepercent2',
        'crosscontrolthresholdvsproforma', 'crossmanagementthresholdvsproforma',
        'crosscontrolthresholdvsforecast', 'crossmanagementthresholdvsforecast',
      ];

      const commentaryKeys = [
        'commentary1', 'commentary2',
        'regionalcommentary1', 'regionalcommentary2',
        'savedcommentary1', 'savedcommentary2',
        'savedregionalcommentary1', 'savedregionalcommentary2',
        'savedreason', 'savedregionalreason',
        'approvereason', 'rejectreason',
        'regionalapprovereason', 'regionalrejectreason',
      ];

      // Filter out empty snapshots and process
      storeItems.filter(s => s && typeof s === 'object' && Object.keys(s).length).forEach(snapshot => {
        const snapshotClone = this.cloneCommentaryItem(snapshot);
        Object.assign(merged, snapshotClone);
        
        merged.glcode_detail = {
          ...merged.glcode_detail,
          ...snapshotClone.glcode_detail,
        };

        // Merge numeric and commentary keys with defined values only
        [...numericKeys, ...commentaryKeys].forEach(key => {
          const value = snapshotClone[key];
          if (value !== undefined && value !== null && value !== '') {
            merged[key] = value;
          }
        });
      });

      // Preserve stage and action from dataset if not in merged
      if (datasetClone.__stage !== undefined && merged.__stage === undefined) {
        merged.__stage = datasetClone.__stage;
      }
      if (datasetClone.__myaction !== undefined && merged.__myaction === undefined) {
        merged.__myaction = datasetClone.__myaction;
      }

      this.ensureReadableIdentifiers(merged);
      return merged;
    },

    ensureReadableIdentifiers(record) {
      if (!record || typeof record !== 'object') return;

      // Process GL identifiers
      const detail = record.glcode_detail || {};
      const readableGl = detail.code || detail.glcode || detail.client_code;
      
      if (readableGl) {
        const shouldUpdateGl = !record.glcode || this.isLikelyObjectId(record.glcode);
        if (shouldUpdateGl) record.glcode = readableGl;
        
        // Set all GL-related fields if missing
        ['client_glcode', 'clcode', 'client_code'].forEach(key => {
          if (!record[key]) record[key] = readableGl;
        });
      }

      // Process reporting unit identifier
      const ruDetail = record.reportingunit_detail || {};
      const ruCode = ruDetail.code;
      const ruId = ruDetail._id;
      
      if (!record.reportingunit && (ruId || ruCode)) {
        record.reportingunit = ruId || ruCode;
      }
      if (ruCode) {
        record.reportingunitReadable = ruCode;
      }

      // Process period identifier
      const periodId = record.period_detail?._id;
      if (periodId && (!record.period || this.isLikelyObjectId(record.period))) {
        record.period = periodId;
      }

      // Process year identifier
      const yearId = record.year_detail?._id;
      if (yearId && (!record.year || this.isLikelyObjectId(record.year))) {
        record.year = yearId;
      }
    },

    isLikelyObjectId(value) {
      return typeof value === 'string' && /^[a-f0-9]{24}$/i.test(value);
    },
    
    getRoleLabel(role){
      const mapping = ROLE_LABEL_MAPPING[role] || VIEW_ONLY;
      if (this.$nova && typeof this.$nova.labelsName === 'function') {
        return this.$nova.labelsName('cycle_page', mapping?.key, mapping?.default);
      }
      return mapping?.default;
    },

    applyRoleFlags(role) {
      // reset
      this.ispreparer = false;
      this.isapprover = false;
      this.isregionalapprover = false;
      this.ismanager = false;
      this.isviewonly = false;

      // set the chosen role
      if (role === ROLES.LOCAL_PREPARER) this.ispreparer = true;
      else if (role === ROLES.LOCAL_APPROVER) this.isapprover = true;
      else if (role === ROLES.REGIONAL_APPROVER) this.isregionalapprover = true;
      else if (role === ROLES.MANAGER) this.ismanager = true;
      else this.isviewonly = true;
    },

    /**
     * Reprocess item actions after role change
     * Updates __myaction for all commentary items based on current role flags
     */
    reprocessItemActions() {
      for (const item of this.commentarydata) {
        item.__myaction = this.getActionFromItem(item);
      }
      // Also clear multiselect when switching roles
      this.$nextTick(() => {
        this.multiselectdata = [];
      });
    },

    /**
     * Process commentary flags for each item and set up roles
     */
    processCommentaryFlag() {
      // 1. Setup Roles FIRST
      this.ispreparer = false;
      this.isapprover = false;
      this.isregionalapprover = false;
      this.ismanager = false;
      this.isviewonly = false;

      const userRoles = getAvailableRoles(this.commentaryrudata, this.userid).map((role) => {
        return {
          ...role,
          label: this.getRoleLabel(role.value)
        }
      });

      // If no recognized role → viewonly
      if (!userRoles?.length) {
        this.isviewonly = true;
        this.ruRoleOptions = [];
        this.selectedRuRole = null;
        // Even if viewonly, we should still process item flags, though actions will likely be 'view'
      } else {
        this.ruRoleOptions = userRoles;
        
        // Auto-select *lowest* priority role (first in list usually) or keep existing if valid
        let defaultRole = userRoles[0]?.value || '';
        
        // If we already have a selected role and it's still valid, keep it
        if (this.selectedRuRole && userRoles.some(r => r.value === this.selectedRuRole)) {
          defaultRole = this.selectedRuRole;
        }
        
        // When slEnabled is false (navigated as approver), override with approver role from SLData
        if (!this.slEnabled) {
          const storeData = this.SLData;
          if (storeData.isregionalapprover && userRoles.some(r => r.value === ROLES.REGIONAL_APPROVER)) {
            defaultRole = ROLES.REGIONAL_APPROVER;
          } else if (storeData.isapprover && userRoles.some(r => r.value === ROLES.LOCAL_APPROVER)) {
            defaultRole = ROLES.LOCAL_APPROVER;
          }
        }

        this.selectedRuRole = defaultRole;
        this.applyRoleFlags(defaultRole);
      }
      
      if ((this.commentaryrudata.submitter || []).length === 0 || (this.commentaryrudata.approver || []).length === 0 || (this.commentaryrudata.manager || []).length === 0 || (this.commentaryrudata.regional_approver || []).length === 0) {
        this.alluserassigned = false;
      } else {
        this.alluserassigned = true;
      }

      // 2. Process item flags SECOND (now that roles are set)
      for (const item of this.commentarydata) {
        // Set stage based on commentary status
        item.__stage = this.getStageFromItem(item);
        item.__myaction = this.getActionFromItem(item);
      }
    },
    setWorkflows() {
      // Check if local workflows are enabled
      this.workflows.islocalenabled = this.workflows.lcp || this.workflows.lmp || this.workflows.lcf || this.workflows.lmf;
      this.workflows.isregionalenabled = this.workflows.rcp || this.workflows.rmp || this.workflows.rcf || this.workflows.rmf;
      this.workflows.islocalproformaenabled = this.workflows.lcp || this.workflows.lmp;
      this.workflows.islocalforecastenabled = this.workflows.lcf || this.workflows.lmf;
      this.workflows.isregionalproformaenabled = this.workflows.rcp || this.workflows.rmp;
      this.workflows.isregionalforecastenabled = this.workflows.rcf || this.workflows.rmf;
      this.workflows.isworkflowsenabled = this.workflows.islocalenabled || this.workflows.isregionalenabled;
    },

    // ===== helpers.loadData compatibility implementations =====
    // helpers.loadData calls these on its host component. Delegating to the real helpers
    // implementations (rather than stubbing) ensures GLBreakdown stays in sync if helpers
    // behaviour ever changes and makes the dependency explicit.
    storeFilteredData(...args) {
      helpers.storeFilteredData.call(this, ...args);
    },
    computeMultiRoleUsers() {
      helpers.computeMultiRoleUsers.call(this);
    },
    

    
    /**
     * Get stage from item based on commentary status
     * This consolidates local and regional stages into a single __stage value
     */
    getStageFromItem(item) {
      // If item already has __stage, use it
      if (item.__stage !== undefined && item.__stage !== null) {
        return item.__stage;
      }
      
      // If item has a direct 'stage' field (common in SL data), use it
      if (item.stage !== undefined && item.stage !== null) {
        return item.stage;
      }
      
      // Match the exact logic from helpers.js using else-if chain
      // This ensures once a condition matches, subsequent conditions are skipped
      let stage = 0;
      if (item.stage_local === 0) stage = 0;
      else if (item.stage_local === -1) stage = -1;
      else if (item.stage_local === 1) stage = 1;
      else if (item.stage_regional === 0) stage = 5;
      else if (item.stage_regional === -1) stage = -2;
      else if (item.stage_regional === 1) stage = 6;
      else if (item.stage_regional === 2 || item.stage_local === 2) stage = 7; // Match helpers.js exactly
      else if (item.stage_local === 3) stage = 3;
      else if (item.stage_regional === 4) stage = 4;
      else if (item.stage_regional === 5 || item.stage_local === 5) stage = 9;
      else stage = 4;
      
      return stage;
    },
    
    /**
     * Get action from item based on user role and item status
     * This determines what action buttons are shown in RUDataTable
     * Matches the logic from helpers.js exactly
     */
    getActionFromItem(item) {
      // Default to view
      let action = 'view';
      
      // Skip action assignment if commentary is ignored
      if (item.ignorecommentary) {
        return action;
      }
      
      // Match helpers.js logic exactly
      if (this.ispreparer && [-1, 0, 1, 9].indexOf(item.__stage) > -1) {
        action = 'localadd';
      } else if (this.isapprover && item.__stage === 1) {
        action = 'localapprove';
      } else if (this.isapprover && [-2, 5, 6, 9].indexOf(item.__stage) > -1) {
        action = 'regionaladd';
      } else if (this.isregionalapprover && item.__stage === 6) {
        action = 'regionalapprove';
      } else if (this.ispreparer && [3, 4, 8, 9].indexOf(item.__stage) > -1 && this.workflows.islocalenabled) {
        action = 'localvoluntary';
      } else if (this.isapprover && [3, 8, 9].indexOf(item.__stage) > -1 && this.workflows.isregionalenabled) {
        action = 'regionalvoluntary';
      } else if (this.isapprover && [7, 9].indexOf(item.__stage) > -1 && this.workflows.islocalenabled) {
        action = 'localrequest';
      } else if (this.isregionalapprover && [7, 9].indexOf(item.__stage) > -1 && this.workflows.isregionalenabled) {
        action = 'regionalrequest';
      } else {
        action = 'view';
      }
      
      return action;
    },
    
    /**
     * Get filter flag for an item based on selectedfilter and customfilterstoggle
     * Returns [shouldIgnore, isDefaultFilter] tuple, matching helpers.js getFilterFlag
     * @param {Object} dt - The commentary data item
     * @param {Array} filters - The selected filter values (optional, defaults to this.selectedfilter)
     * @param {Boolean} customToggle - Custom filter toggle state (optional)
     * @param {Array} customList - Custom filter list (optional)
     * @returns {Array} [shouldIgnore: boolean, isDefaultFilter: boolean]
     */
    getFilterFlag(dt, filters, customToggle, customList) {
      const selectedFilters = filters !== undefined ? filters : this.selectedfilter;
      const isCustomToggle = customToggle !== undefined ? customToggle : this.customfilterstoggle;
      const customFilterList = customList !== undefined ? customList : this.customfilter;
      
      // If custom filter toggle is on and item's glcode is not in custom filter list, ignore it
      if (isCustomToggle && customFilterList && customFilterList.indexOf(dt.glcode) === -1) {
        return [true, true];
      }
      // If no filters are selected, ignore all items (show nothing)
      if (!selectedFilters || selectedFilters.length === 0) {
        return [true, true];
      }
      // If item's stage is not in selected filter array, ignore it
      if (selectedFilters.indexOf(dt?.__stage) === -1) {
        return [true, !(dt?.__stage === 3 || dt?.__stage === 9)];
      }
      return [false, true];
    },
    
    /**
     * Toggle between commentary view and list view
     */
    toggleViewFun() {
      this.isCommentaryView = !this.isCommentaryView;
      if (this.isCommentaryView) {
        this.toggletableview = 1;
      } else {
        this.toggletableview = 0;
      }
    },
    
    // ===== Fetch AI Features =====
    async fetchAiFeatures() {
      try {
        const features = await this.$store.dispatch('varianceanalysis/fetchAiFeatures', this.axios);

        if (!Array.isArray(features)) {
          console.warn('[GLBreakdown] features is not an array:', features);
          this.commentaryStatusData = null;
          this.commentaryGenAiBtntabValue = false;
          return;
        }

        // JV Summarisation (from Base.vue logic)
        const summaryStatus = features.find(feature => feature.name === 'jv_summarisation');
        this.showSummaryTab = summaryStatus?.platform_admin_enabled && summaryStatus?.super_admin_enabled;
        this.isThresholdExceedJVSummarisation = summaryStatus?.isExceed || false;

        // Local Commentary (from Base.vue logic)
        const localCommentaryStatus = features.find(feature => feature.name === 'local_commentary_summary');
        this.isThresholdExceedLocalCommentary = localCommentaryStatus?.isExceed || false;
        // this.localCommentaryGenAiBtntab = localCommentaryStatus?.platform_admin_enabled && localCommentaryStatus?.super_admin_enabled;

        const featureName = this.isRevenue ? 'revenue_commentary_summary' : 'netsales_commentary_summary';
        const commentaryStatus = features.find(feature => feature.name === featureName);
        this.commentaryStatusData = commentaryStatus;
        this.commentaryGenAiBtntabValue = commentaryStatus?.platform_admin_enabled && commentaryStatus?.super_admin_enabled;
      } catch (error) {
        console.error('Error fetching AI features:', error);
        this.commentaryGenAiBtntabValue = false;
      }
    },
    
    // ===== Commentary change tracking =====
    normalizeCommentaryText(value) {
      return String(value ?? '').trim();
    },

    isCommentaryTextDirty(current, saved, baseline) {
      if (!this.commentaryBaselinesReady) {
        return false;
      }
      const currentValue = this.normalizeCommentaryText(current);
      const baselineValue = this.normalizeCommentaryText(baseline);
      return currentValue !== baselineValue;
    },

    isSubmittedCommentaryField(field) {
      const submittedKey = field === 'commentary1' ? '__submittedCommentary1' : '__submittedCommentary2';
      if (!Object.prototype.hasOwnProperty.call(this.selectedcommentary || {}, submittedKey)) {
        return false;
      }
      return Boolean(this.normalizeCommentaryText(this.selectedcommentary[submittedKey]));
    },

    captureCommentaryBaselines() {
      const commentary = this.selectedcommentary || {};
      this.commentaryBaselines = {
        commentary1: this.normalizeCommentaryText(commentary.commentary1),
        commentary2: this.normalizeCommentaryText(commentary.commentary2),
        approvereason: this.normalizeCommentaryText(commentary.approvereason),
        regionalcommentary1: this.normalizeCommentaryText(commentary.regionalcommentary1),
        regionalcommentary2: this.normalizeCommentaryText(commentary.regionalcommentary2),
        regionalapprovereason: this.normalizeCommentaryText(commentary.regionalapprovereason),
      };
      this.commentaryBaselinesReady = true;
    },

    scheduleCommentaryBaselineCapture() {
      this.commentaryBaselinesReady = false;
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.captureCommentaryBaselines();
        });
      });
    },

    updateCommentaryBaseline(field, value) {
      if (!field || !Object.prototype.hasOwnProperty.call(this.commentaryBaselines, field)) {
        return;
      }
      this.$set(this.commentaryBaselines, field, this.normalizeCommentaryText(value));
    },

    // ===== Navigation =====
    handleBack() {
      if (this.hasUnsavedCommentaryChanges) {
        this.pendingNavigation = { type: 'back' };
        this.unsavedCommentaryDialog = true;
        return;
      }
      this.$store.commit('varianceanalysis/setSkipReloadOnBack', true);
      this.$router.back();
    },
    
    /**
     * Handles role change from Breadcrumbs dropdown.
     * Updates local state, applies role flags, and persists to Vuex for back navigation.
     * This follows the same logic as applyRoleFlags in helpers.js
     */
    handleRoleChange(roleValue) {
      if (this.isSodEnabled) {
        return;
      }

      this.selectedRuRole = roleValue;
      
      // Apply role flags based on selected role (same logic as helpers.js applyRoleFlags)
      this.applyRoleFlags(roleValue);
      this.refreshSelectedCommentaryActions();
      
      // Persist to Vuex so state is maintained on back navigation
      this.$store.commit('varianceanalysis/updateSlContextField', { 
        field: 'selectedRuRole', 
        value: roleValue 
      });
      
      // Also persist updated role flags to Vuex
      this.$store.commit('varianceanalysis/updateSlContextField', { field: 'ispreparer', value: this.ispreparer });
      this.$store.commit('varianceanalysis/updateSlContextField', { field: 'isapprover', value: this.isapprover });
      this.$store.commit('varianceanalysis/updateSlContextField', { field: 'isregionalapprover', value: this.isregionalapprover });
      this.$store.commit('varianceanalysis/updateSlContextField', { field: 'ismanager', value: this.ismanager });
      this.$store.commit('varianceanalysis/updateSlContextField', { field: 'isviewonly', value: this.isviewonly });
      
    },
    
    async handleRefresh() {
      const isOnDrilldown = this.currentTabKey === 'drilldown';
      // In Vue 2, refs inside v-for loops are registered as arrays.
      // <SLBreakup ref="slBreakupRef"> sits inside <v-tab-item v-for="...">,
      // so $refs.slBreakupRef is [instance] — resolve to the actual VM instance.
      const rawRef = this.$refs.slBreakupRef;
      const slBreakupRef = isOnDrilldown
        ? (Array.isArray(rawRef) ? rawRef[0] : rawRef) || null
        : null;

      // Show loading for the entire refresh — all APIs must finish before data shows
      this.isReportingUnitdataloading = true;
      try {
        const refreshTasks = [
          this.syncReportingUnitSodStatus({ showErrorOnFailure: true }),
          this.loadGLDetails(false, true), // suppress internal loading management
        ];
        // If drill-down tab is active, also refresh SL data in parallel
        if (isOnDrilldown && slBreakupRef) {
          refreshTasks.push(slBreakupRef.loadSLData(true));
        }
        await Promise.all(refreshTasks);
        this.refreshSelectedCommentaryActions();
      } finally {
        this.isReportingUnitdataloading = false;
      }
    },

    /**
     * Recompute action buttons for the active GL after role/SOD/workflow changes.
     */
    refreshSelectedCommentaryActions() {
      if (!this.selectedcommentary || !this.selectedcommentary._id) {
        return;
      }

      const newAction = this.getActionFromItem(this.selectedcommentary);
      this.selectedcommentary = {
        ...this.selectedcommentary,
        __myaction: newAction,
      };

      if (newAction === 'regionaladd' || newAction === 'regionalapprove' || newAction === 'regionalvoluntary') {
        this.handleAddRegionalCommentaryDataSetup(this.selectedcommentary);
      }
      this.scheduleCommentaryBaselineCapture();
    },

    /**
     * Apply reporting-unit settings used by GL breakdown (SOD, workflows, automation).
     */
    applyReportingUnitSettings(ruData) {
      if (!ruData || typeof ruData !== 'object') {
        return;
      }

      this.isSodEnabled = ruData.sod_enabled !== false;
      this.isRegionalCommentaryAutomationEnabled = ruData.auto_regional_commentary_submission_enabled || false;
      this.reportingUnitType = ruData.type || '';

      this.workflowtext = [];
      this.workflows = {
        ...this.workflows,
        lcp: true,
        lmp: true,
        rcp: true,
        rmp: true,
        lcf: true,
        lmf: true,
        rcf: true,
        rmf: true,
        islocalenabled: true,
        isregionalenabled: true,
        islocalproformaenabled: true,
        islocalforecastenabled: true,
        isregionalproformaenabled: true,
        isregionalforecastenabled: true,
        isworkflowsenabled: true,
      };

      const workflowChecks = [
        { key: 'localcontrol_proforma', flag: 'lcp', text: 'Local control proforma' },
        { key: 'localmanagement_proforma', flag: 'lmp', text: 'Local management proforma' },
        { key: 'regionalcontrol_proforma', flag: 'rcp', text: 'Regional control proforma' },
        { key: 'regionalmanagement_proforma', flag: 'rmp', text: 'Regional management proforma' },
        { key: 'localcontrol_forecast', flag: 'lcf', text: 'Local control forecast' },
        { key: 'localmanagement_forecast', flag: 'lmf', text: 'Local management forecast' },
        { key: 'regionalcontrol_forecast', flag: 'rcf', text: 'Regional control forecast' },
        { key: 'regionalmanagement_forecast', flag: 'rmf', text: 'Regional management forecast' },
      ];

      workflowChecks.forEach(({ key, flag, text }) => {
        if (!ruData[key]) {
          this.workflows[flag] = false;
          this.workflowtext.push(text);
        }
      });

      this.setWorkflows();
    },

    /**
     * Fetches reporting unit data to refresh SOD status, workflows, and role options.
     * Uses helpers.apiGet directly — helpers.loadData requires this.apiGet which GLBreakdown does not expose.
     */
    async syncReportingUnitSodStatus(options = {}) {
      const { showErrorOnFailure = false } = options;
      const reportingunit = this.reportingunitId;
      const period = this.periodId;

      if (!reportingunit || !period) {
        console.warn('[GLBreakdown] syncReportingUnitSodStatus - missing reportingunit or period');
        return;
      }

      try {
        const filter = {
          cycletype: this.cycletype,
          reportingunit,
          period,
          role: this.roleId || this.selectedRuRole || '',
          type: this.type || '',
        };
        if (this.reportingType) {
          filter.reporting_type = this.reportingType;
        }

        const response = await helpers.apiGet.call(
          this,
          '/v3/varianceanalysis/analysis/getreportingunitdata/',
          filter
        );

        if (response?.data?.status !== 'success') {
          throw new Error(response?.data?.message || 'Error fetching reporting unit data');
        }

        const fdt = response.data.data[0] || {};
        const ruData = fdt.reportingunit || {};
        this.commentaryrudata = { ...this.commentaryrudata, ...ruData };
        this.applyReportingUnitSettings(ruData);
        this.processCommentaryFlag();
        this.refreshSelectedCommentaryActions();

        this.$store.commit('varianceanalysis/updateSlContextField', {
          field: 'isSodEnabled',
          value: this.isSodEnabled,
        });
        this.$store.commit('varianceanalysis/updateSlContextField', {
          field: 'ruRoleOptions',
          value: this.ruRoleOptions,
        });
        this.$store.commit('varianceanalysis/updateSlContextField', {
          field: 'workflows',
          value: this.workflows,
        }); 
        this.$store.commit('varianceanalysis/updateSlContextField', {
          field: 'isRegionalCommentaryAutomationEnabled',
          value: this.isRegionalCommentaryAutomationEnabled,
        });
      } catch (error) {
        console.error('[GLBreakdown] syncReportingUnitSodStatus failed:', error);
        if (showErrorOnFailure) {
          this.$store.commit('sbError', error.message || 'Failed to refresh reporting unit settings.');
        }
      }
    },
    
    getStatusLabel(key, fallback) {
      if (this.$nova && typeof this.$nova.labelsName === 'function') {
        return this.$nova.labelsName('cycle_page', key, fallback);
      }
      return fallback;
    },
    
    // ===== Formatting =====
    formatCurrency(amount) {
      if (amount === null || amount === undefined || amount === '') {
        return '-';
      }
      if (this.$nova && typeof this.$nova.formatCurrency === 'function') {
        return this.$nova.formatCurrency(amount, '', false, true);
      }
      return Number(amount).toLocaleString();
    },
    
    formatPercent(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      const percent = Number(value);
      if (Number.isNaN(percent)) {
        return '-';
      }
      if (this.$nova && typeof this.$nova.formatCurrency === 'function') {
        const formatted = this.$nova.formatCurrency(percent, '', false, true);
        return `${formatted}${percent !== 0 ? ' %' : ''}`;
      }
      return `${percent.toFixed(1)}${percent !== 0 ? '%' : ''}`;
    },
    
    varianceClass(value) {
      if (value > 0) return 'success--text font-weight-bold';
      if (value < 0) return 'error--text font-weight-bold';
      return 'grey--text font-weight-bold';
    },
    
    // ===== Event Handlers =====
    handleFilterUpdate(value) {
      this.selectedfilter = value;
    },
    
    handleCustomFiltersToggle(value) {
      this.customfilterstoggle = value;
    },
    
    handleToggleView() {
      this.toggleViewFun();
    },
    
    handleToggleTableView(value) {
      this.toggletableview = value;
    },
    
    // Handle SL Grouped/Ungrouped view change (separate from toggletableview)
    handleSlGroupedViewChange(value) {
      this.slGroupedView = value;
      this.slViewMode = value === 0 ? 'grouped' : 'ungrouped';
    },
    
    // Handle SL group toggle for grouped view (parent-child expansion)
    handleToggleSLGroup(groupId) {
      const index = this.slExpandedGroups.indexOf(groupId);
      if (index > -1) {
        this.slExpandedGroups.splice(index, 1);
      } else {
        this.slExpandedGroups.push(groupId);
      }
    },
    
    handleToggleExpandAll() {
      this.isAllExpanded = !this.isAllExpanded;
      if (this.isAllExpanded) {
        // Expand all parent/header items
        this.expandedIds = new Set(
          this.commentarydata
            .filter(item => item.__type === 'header')
            .map(item => (item.__code ?? item.clcode ?? '')?.toString())
            .filter(Boolean)
        );
      } else {
        this.expandedIds = new Set();
      }
    },
    
    handleToggleExpand(item) {
      // Use __code for tree expansion (GL codes like "450000" for SL data)
      const code = item.__code || item.clcode || item.gl_code;
      if (!code) return;
      
      const codeStr = String(code);
      if (this.expandedIds.has(codeStr)) {
        this.expandedIds.delete(codeStr);
      } else {
        this.expandedIds.add(codeStr);
      }
      // Force reactivity
      this.expandedIds = new Set(this.expandedIds);
    },
    
    /**
     * Check if item has children (for showing expand icon)
     */
    hasChildren(item) {
      // Virtual headers always have children
      if (item.__isVirtualHeader) {
        return true;
      }
      return item.__type === 'header' && 
             item.glcode_detail?.children && 
             item.glcode_detail.children.length > 0;
    },
    
    /**
     * Check if item is expanded
     */
    isExpanded(item) {
      const code = item.__code || item.clcode;
      return code && this.expandedIds.has(code);
    },
    
    handleMarkConversationRead() {
      if (this.commentarycycledata) {
        this.commentarycycledata.conversation_read = true;
      }
      if (this.selectedGLCommentary && typeof this.selectedGLCommentary === 'object') {
        this.$set(this.selectedGLCommentary, 'conversation_read', true);
      }
    },

    /**
     * Handle request commentary from Breadcrumbs header.
     * Opens the request commentary dialog for the selected GL.
     */
    handleBreadcrumbsRequestCommentary() {
      const source = (this.selectedcommentary && this.selectedcommentary._id)
        ? this.selectedcommentary
        : this.selectedGLCommentary;

      if (!source || !source._id) {
        this.$store.commit('sbError', 'No GL selected for request commentary.');
        return;
      }

      // Ensure the dialog (and request API) has a valid selectedcommentary context
      this.selectedcommentary = { ...source };
      this.ensureReadableIdentifiers(this.selectedcommentary);

      // Reset request commentary flags
      this.requestcommentarylocalcontrolvsProforma = false;
      this.requestcommentarylocalmanagementvsProforma = false;
      this.requestcommentaryregionalcontrolvsProforma = false;
      this.requestcommentaryregionalmanagementvsProforma = false;
      this.requestcommentarylocalcontrolvsForecast = false;
      this.requestcommentarylocalmanagementvsForecast = false;
      this.requestcommentaryregionalcontrolvsForecast = false;
      this.requestcommentaryregionalmanagementvsForecast = false;

      // Set bulksubmit to false since this is for a single GL
      this.bulksubmit = false;

      // Open request commentary dialog
      this.requestcommentarydialog = true;
    },
    
    /**
     * Request commentary API call.
     * Called when user clicks the request button in RequestCommentaryDialog.
     * Mirrors the logic from helpers.js requestCommentary method.
     */
    requestCommentary() {
      let gls = [];
      let notInScopeGLs = [];

      if (this.bulksubmit) {
        gls = this.multiselectdata;
        gls.forEach((glid) => {
          const glItem = this.commentarydata.find((item) => item._id === glid);
          if (glItem && [9].indexOf(glItem.__stage) > -1) {
            notInScopeGLs.push(glid);
          }
        });
      } else {
        const selected = (this.selectedcommentary && this.selectedcommentary._id)
          ? this.selectedcommentary
          : this.selectedGLCommentary;

        if (!selected || !selected._id) {
          this.$store.commit('sbError', 'No GL selected for request commentary.');
          return;
        }

        // Ensure downstream refresh (getgldetails) has a valid selectedcommentary context
        if (!this.selectedcommentary || !this.selectedcommentary._id) {
          this.selectedcommentary = { ...selected };
          this.ensureReadableIdentifiers(this.selectedcommentary);
        }

        if ([9].indexOf(selected.__stage) > -1) {
          notInScopeGLs.push(selected._id);
        }
        gls = [selected._id];
      }

      this.requestcommentaryloading = true;
      let level = 'local';
      const fltr = {
        level: level,
        cycletype: this.cycletype,
        cycle: this.commentarycycledata._id,
        gls: gls,
        notinscopegls: notInScopeGLs,
        crosscontrollocalthresholdvsproforma: this.requestcommentarylocalcontrolvsProforma,
        crossmanagementlocalthresholdvsproforma: this.requestcommentarylocalmanagementvsProforma,
        crosscontrollocalthresholdvsforecast: this.requestcommentarylocalcontrolvsForecast,
        crossmanagementlocalthresholdvsforecast: this.requestcommentarylocalmanagementvsForecast
      };

      // Add reporting_type for Balance Sheet tab
      if (this.reportingType) {
        fltr.reporting_type = this.reportingType;
      }

      if (this.isregionalapprover) {
        level = 'regional';
        fltr.level = level;
        fltr.crosscontrolregionalthresholdvsproforma = this.requestcommentaryregionalcontrolvsProforma;
        fltr.crosscontrolregionalthresholdvsforecast = this.requestcommentaryregionalcontrolvsForecast;
        fltr.crossmanagementregionalthresholdvsproforma = this.requestcommentaryregionalmanagementvsProforma;
        fltr.crossmanagementregionalthresholdvsforecast = this.requestcommentaryregionalmanagementvsForecast;
      }

      // Validation: At least one checkbox must be selected
      if (
        (level === 'local' &&
          !(fltr.crosscontrollocalthresholdvsforecast ||
            fltr.crosscontrollocalthresholdvsproforma ||
            fltr.crossmanagementlocalthresholdvsproforma ||
            fltr.crossmanagementlocalthresholdvsforecast)) ||
        (level === 'regional' &&
          !(fltr.crosscontrolregionalthresholdvsproforma ||
            fltr.crosscontrolregionalthresholdvsforecast ||
            fltr.crossmanagementregionalthresholdvsproforma ||
            fltr.crossmanagementregionalthresholdvsforecast))
      ) {
        this.$store.commit('sbError', 'Reason for request for commentary is mandatory');
        this.requestcommentaryloading = false;
        return;
      }

      const url = '/v3/varianceanalysis/analysis/requestcommentary';
      this.axios
        .post(url, { filter: fltr })
        .then((dt) => {
          if (dt.data.status === 'success') {
            this.$store.commit(
              'sbSuccess',
              "Request Success. Commentary will be requested only for GL's are in 'Approved', 'Immaterial Variance', 'Not In Scope' and 'Nil Value'."
            );
            this.requestcommentarydialog = false;
            // Refresh the GL details (getgldetails)
            this.loadGLDetails(true);
          } else {
            throw new Error(dt.data.message || 'Error requesting commentary');
          }
        })
        .catch((err) => {
          this.$store.commit('sbError', err.message || err || 'Unknown error!');
          console.log('[GLBreakdown]: requestCommentary error', err);
        })
        .finally(() => {
          this.requestcommentaryloading = false;
        });
    },
    
    handleOpenUserListDialog() {
      this.userlistdialog = true;
    },
    
    handlePerformBulkTask(payload, action) {
      
      if (action === 'request') {
        if ((this.isapprover && this.workflows.islocalenabled) || (this.isregionalapprover && this.workflows.isregionalenabled)) {
          this.requestcommentarylocalcontrolvsProforma = false;
          this.requestcommentarylocalmanagementvsProforma = false;
          this.requestcommentaryregionalcontrolvsProforma = false;
          this.requestcommentaryregionalmanagementvsProforma = false;
          this.requestcommentarylocalcontrolvsForecast = false;
          this.requestcommentarylocalmanagementvsForecast = false;
          this.requestcommentaryregionalcontrolvsForecast = false;
          this.requestcommentaryregionalmanagementvsForecast = false;
          this.selectedcommentary = {};
          this.requestcommentarydialog = true;
        }
      } else if (action === 'addlocal') {
        if (this.ispreparer && this.workflows.islocalenabled) {
          this.requestcommentarylocalcontrolvsProforma = false;
          this.requestcommentarylocalmanagementvsProforma = false;
          this.requestcommentaryregionalcontrolvsProforma = false;
          this.requestcommentaryregionalmanagementvsProforma = false;
          this.requestcommentarylocalcontrolvsForecast = false;
          this.requestcommentarylocalmanagementvsForecast = false;
          this.requestcommentaryregionalcontrolvsForecast = false;
          this.requestcommentaryregionalmanagementvsForecast = false;
          this.bulkcommentall = false;
          this.bulkcommentreplace = false;
          this.isGlMandatoryRequestFlag = false;
          this.replaceExistingCommentFlag = false;
          this.selectedcommentary = {};
          
          // Check for existing commentary in selected items
          for (let id of this.multiselectdata) {
            let glItem = this.commentarydata.find((item) => item._id === id);
            if (glItem && ([3, 4].indexOf(glItem.__stage) > -1)) {
              this.isGlMandatoryRequestFlag = false;
            }
            if (glItem && ((glItem.commentary1 && glItem.commentary1.trim() !== '') || 
                (glItem.commentary2 && glItem.commentary2.trim() !== '') || 
                (glItem.regionalcommentary1 && glItem.regionalcommentary1.trim() !== '') || 
                (glItem.regionalcommentary2 && glItem.regionalcommentary2.trim() !== ''))) {
              this.replaceExistingCommentFlag = true;
            }
          }
          this.dialogCharttab = 0; // Reset dialog tabs
          this.commantorydialog = true;
        }
      } else if (action === 'approvelocal') {
        if (this.workflows.islocalenabled) {
          this.dialogCharttab = 0; // Reset dialog tabs
          this.commantorydialog = true;
          this.selectedcommentary = {};
        }
      } else if (action === 'addregional') {
        if (this.workflows.isregionalenabled) {
          this.requestcommentarylocalcontrolvsProforma = false;
          this.requestcommentarylocalmanagementvsProforma = false;
          this.requestcommentaryregionalcontrolvsProforma = false;
          this.requestcommentaryregionalmanagementvsProforma = false;
          this.requestcommentarylocalcontrolvsForecast = false;
          this.requestcommentarylocalmanagementvsForecast = false;
          this.requestcommentaryregionalcontrolvsForecast = false;
          this.requestcommentaryregionalmanagementvsForecast = false;
          this.bulkcommentall = false;
          this.bulkcommentreplace = false;
          this.selectedcommentary = {};
          this.dialogCharttab = 0; // Reset dialog tabs
          this.commantorydialog = true;
        }
      } else if (action === 'approveregional') {
        if (this.workflows.isregionalenabled) {
          this.dialogCharttab = 0; // Reset dialog tabs
          this.commantorydialog = true;
          this.selectedcommentary = {};
        }
      }
      
      this.bulksubmit = true;
      this.bulktype = action;
      this.commentarytype = action;
      this.commentarySubmitDialogueViewMode = false;
    },
    
    handlePreviewBulkCommentary() {
      this.$store.commit('sbInfo', `Submit Draft Commentary for ${this.multiselectdata.length} selected items`);
    },
    
    handleOpenSubmitDialog(payload) {
      const { row, mode, approver } = payload;
      console.log('Open submit dialog:', mode, 'Row:', row, 'Approver:', approver);
      
      this.bulksubmit = false;
      this.commentarytype = mode;
      this.selectedcommentary = { ...row };
      this.ensureReadableIdentifiers(this.selectedcommentary);
      this.ensureDialogTrendlineDataset(true);
      this.commentarySubmitDialogueViewMode = (mode === 'view');
      this.dialogCharttab = 0; // Reset dialog tabs to main tab
      
      if (mode === 'addregional' || mode === 'approveregional') {
        this.isLocalCommentaryCollapsed = true;
        this.isLocalCommentaryReasonCollapsed = true;
      } else {
        this.isLocalCommentaryCollapsed = false;
        this.isLocalCommentaryReasonCollapsed = false;
      }
      
      if (['view', 'addlocal', 'addregional', 'approvelocal', 'approveregional'].includes(mode)) {
        this.commantorydialog = true;
      } else if (['requestlocal', 'requestregional'].includes(mode)) {
        // Open request commentary dialog
        this.requestcommentarylocalcontrolvsProforma = false;
        this.requestcommentarylocalmanagementvsProforma = false;
        this.requestcommentaryregionalcontrolvsProforma = false;
        this.requestcommentaryregionalmanagementvsProforma = false;
        this.requestcommentarylocalcontrolvsForecast = false;
        this.requestcommentarylocalmanagementvsForecast = false;
        this.requestcommentaryregionalcontrolvsForecast = false;
        this.requestcommentaryregionalmanagementvsForecast = false;
        this.requestcommentarydialog = true;
      }
    },
    
    // ===== Previous Cycle Methods =====
   
   
    
    
    
    saveCustomFilter() {
      localStorage.setItem('commentary_custom_filter', this.customfilter.join(','));
      if (this.customfilter.length > 0) {
        this.customfilterstoggle = true;
      } else {
        this.customfilterstoggle = false;
      }
      localStorage.setItem('commentary_custom_filter_toggle', this.customfilterstoggle);
      this.customfiltersdialog = false;
    },
    
 
    
    // ===== Bulk Upload Dialog Methods =====
    downloadExcel() {
      this.$store.commit('sbInfo', 'Downloading Excel template...');
      this.downloadBulkTemplate();
    },
    
    downloadPdf() {
      if (!this.commentarycycledata?._id) {
        this.$store.commit('sbError', 'No cycle data available for PDF download');
        return;
      }
      // Open the PDF download dialog
      this.getpdfFun();
    },
    
   
    
   
    
   
    
    downloadBulkTemplate() {
      // Use styledxlsx to create and download bulk upload template - matching helpers.js downloadExcel
      return Promise.resolve().then(() => {
        this.bulksubmitloading = true;
        return // SLBreakup handles data refresh
      }).then(() => {
        const styledxlsx = require('sheetjs-style');
        const workbook = styledxlsx.utils.book_new();
        const primarycolor = 'd8e8f0';
        const heading1 = 'bfffbf';
        const heading2 = 'E8EEFF';
        const heading3 = 'F2E1F5';
        const body1 = 'E3FFE3';
        const body2 = 'E8EEFF';
        const body3 = 'F2E1F5';
        const scolor = '078f0e';
        const ecolor = 'd11b1b';
        const runame = this.commentaryrudata?.code || 'Report';
        
        // Get period and year info from cycle data or SLData passed from Base.vue
        const periodName = this.commentarycycledata?.period_detail?.name || 
                          this.selectedCommentaryCycle?.period_detail?.name || 
                          this.SLData?.periodName ||
                          '';
        const yearName = this.commentarycycledata?.year_detail?.name || 
                        this.selectedCommentaryCycle?.year_detail?.name || 
                        this.SLData?.yearName ||
                        this.commentarycycledata?.year || 
                        this.selectedCommentaryCycle?.year || 
                        '';
        
        // Build subtitle with period, year and reporting type info
        const reportingTypeLabel = this.reportingType === 'bs' ? 'Balance Sheet' : 'Profit & Loss';
        let subtitle = this.cycletype;
        if (periodName) subtitle += ` - ${periodName}`;
        subtitle += ` - ${reportingTypeLabel}`;
        
        // Use bulksubmitcolumns - remove last 2 columns for the template (Status columns)
        let excelColumns = [...this.bulksubmitcolumns];
        excelColumns.splice(-2, 2);
        
        const dt = [
          [''],
          ['', { v: this.commentaryrudata?.name || '', s: { font: { bold: true, sz: 20 } } }],
          ['', { v: subtitle, s: { font: { bold: true, sz: 14 } } }],
          [''],
          [
            '',
            { v: excelColumns[0], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[1], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[2], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[3], s: { font: { bold: true }, fill: { fgColor: { rgb: heading1 } } } },
            { v: excelColumns[4], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[5], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[6], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[7], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[8], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[9], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[10], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[11], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[12], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[13], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[14], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[15], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[16], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[17], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[18], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[19], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[20], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } }
          ]
        ];
        
        // Add data rows - matching helpers.js downloadExcel format
        for (const v of this.commentarydata) {
          if (v.cycle) {
            dt.push([
              '',
              v.glcode_detail?.code,
              v.glcode_detail?.name,
              { v: this.$nova.formatCurrency((v.amount1 || 0).toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body1 } } } },
              { v: this.$nova.formatCurrency((v.amount2 || 0).toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body2 } } } },
              { v: this.$nova.formatCurrency((v.varianceamount1 || 0).toFixed(1), '', false, true), s: { font: { color: { rgb: ((v.varianceamount1 || 0) > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body2 } } } },
              { v: this.$nova.formatCurrency(((v.variancepercent1 || 0)).toFixed(1), '', false, true) + (((v.variancepercent1 || 0) !== 0) ? '%' : ''), s: { font: { color: { rgb: ((v.varianceamount1 || 0) > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_control ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_management ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_control_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_management_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.commentary1 || '', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.regionalcommentary1 || '', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: this.$nova.formatCurrency((v.amount3 || 0).toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body3 } } } },
              { v: this.$nova.formatCurrency((v.varianceamount2 || 0).toFixed(1), '', false, true), s: { font: { color: { rgb: ((v.varianceamount2 || 0) > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body3 } } } },
              { v: this.$nova.formatCurrency(((v.variancepercent2 || 0)).toFixed(1), '', false, true) + (((v.variancepercent2 || 0) !== 0) ? '%' : ''), s: { font: { color: { rgb: ((v.varianceamount2 || 0) > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_control ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_management ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_control_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_management_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.commentary2 || '', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.regionalcommentary2 || '', s: { fill: { fgColor: { rgb: body3 } } } }
            ]);
          }
        }
        
        const worksheet = styledxlsx.utils.aoa_to_sheet(dt);
        styledxlsx.utils.book_append_sheet(workbook, worksheet, 'TOP SHEET');
        
        // Build filename with GL name, period, and year
        const glName = this.selectedGLCommentary?.glcode_detail?.name || 
                       this.selectedGLCommentary?.description || 
                       this.SLData?.glName || '';
        const glCode = this.selectedGLCommentary?.glcode_detail?.code || 
                       this.selectedGLCommentary?.glcode || '';
        const glPart = glCode ? `_${glCode}` : (glName ? `_${glName.replace(/[^a-zA-Z0-9]/g, '_')}` : '');
        const periodPart = periodName ? `_${periodName.replace(/[^a-zA-Z0-9]/g, '_')}` : '';
        const yearPart = yearName ? `_${yearName}` : '';
        const filename = `${runame}${glPart}${periodPart}${yearPart}_SL_Breakup.xlsx`;
        
        styledxlsx.writeFile(workbook, filename);
      }).catch(err => {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.error(err);
      }).finally(() => {
        this.bulksubmitloading = false;
      });
    },
    
    downloadBulkApproveTemplate() {
      // Download bulk approve template - uses same format as downloadBulkTemplate
      this.downloadBulkTemplate();
    },
    
    readBulkSubmit() {
    let file = this.bulksubmitfiledatafile;
    this.bulksubmitfiledataList = [];
    if ((file || {}).name && !this.bulksubmitloading) {
      this.bulksubmitfiledataerror = false;
      this.bulksubmitloading = true;
      let commentary1Index = 11;
      let commentary2Index = 20;
      let ext = ((file || {}).name || "").split(".").pop();
      Promise.resolve().then(() => {
        if (["xlsx", "xls", "xlsm", "xlsb"].indexOf(ext) === -1) throw new Error("Only xlsx,xls,xlsm,xlsb file extension supported");
        return this.$nova.readExcelFile(file, "TOP SHEET");
      }).then(dt => {
        let excelColumns = [...this.bulksubmitcolumns];
        excelColumns.splice(-2, 2);
        if (JSON.stringify(dt[4] || []) === JSON.stringify(["", ...excelColumns])) {
          let gllist = [];
          let uploaddata = {};
          let finaldata = {};
          let haserror = false;
          for (let i = 4; i < dt.length; i++) {
            if (i > 4) {
              const el = dt[i];
              let glcode = (el[1] || "").toString();
              let ndt = el;
              gllist.push(glcode);
              uploaddata[glcode] = ndt;
            }
          }
          for (const el of this.commentarydata) {
            let glcode = (el.glcode || "").toString();
            let code = (el.glcode_detail?.code || "").toString();
            if (gllist.includes(code)) {
              // Determine if threshold flags should be shown based on role and stage
              // Local Preparer: show flags only when stage_local === 4 or 3
              // Local Approver / Regional Preparer: show flags only when stage_regional === 4 or 3
              const showThresholdFlags = this.ispreparer 
                ? (el.stage_local === 4 || el.stage_local === 3) 
                : (this.isapprover && (el.stage_regional === 4 || el.stage_regional === 3));
              // Get threshold values from Excel upload (uploaddata) at indices 7, 8, 16, 17
              // If Excel data is different from DB, use the Excel (latest) values
              const excelCrossControlProforma = uploaddata[code][7]; // Index 7: Cross Control vs Proforma
              const excelCrossManagementProforma = uploaddata[code][8]; // Index 8: Cross Management vs Proforma
              const excelCrossControlForecast = uploaddata[code][16]; // Index 16: Cross Control vs Forecast
              const excelCrossManagementForecast = uploaddata[code][17]; // Index 17: Cross Management vs Forecast
              
              // Convert DB values to Yes/No for comparison
              const dbCrossControlProforma = el.var1_cross_control ? 'Yes' : 'No';
              const dbCrossManagementProforma = el.var1_cross_management ? 'Yes' : 'No';
              const dbCrossControlForecast = el.var2_cross_control ? 'Yes' : 'No';
              const dbCrossManagementForecast = el.var2_cross_management ? 'Yes' : 'No';
              
              // Use Excel values if different from DB, otherwise use DB values
              const finalCrossControlProforma = (excelCrossControlProforma && excelCrossControlProforma !== dbCrossControlProforma) 
                ? excelCrossControlProforma : dbCrossControlProforma;
              const finalCrossManagementProforma = (excelCrossManagementProforma && excelCrossManagementProforma !== dbCrossManagementProforma) 
                ? excelCrossManagementProforma : dbCrossManagementProforma;
              const finalCrossControlForecast = (excelCrossControlForecast && excelCrossControlForecast !== dbCrossControlForecast) 
                ? excelCrossControlForecast : dbCrossControlForecast;
              const finalCrossManagementForecast = (excelCrossManagementForecast && excelCrossManagementForecast !== dbCrossManagementForecast) 
                ? excelCrossManagementForecast : dbCrossManagementForecast;
              
              finaldata[code] = {
                _id : el._id,
                code: code,
                glcode: glcode,
                name: el.glcode_detail?.name,
                actual_amount: this.$nova.formatCurrency((el.amount1 || 0).toFixed(1), '', false, true),
                proforma_amount: this.$nova.formatCurrency((el.amount2 || 0).toFixed(1), '', false, true),
                variance_amount1: this.$nova.formatCurrency((el.varianceamount1 || 0).toFixed(1), '', false, true),
                variance_percent1: this.formatPercent(el.variancepercent1 || 0),
                forecast_amount: this.$nova.formatCurrency((el.amount3 || 0).toFixed(1), '', false, true),
                variance_amount2: this.$nova.formatCurrency((el.varianceamount2 || 0).toFixed(1), '', false, true),
                variance_percent2: this.formatPercent(el.variancepercent2 || 0),
                // Threshold cross values - use Excel values if different from DB, otherwise DB values
                // Only show when applicable stage based on role
                crosscontrolthresholdvsproforma: showThresholdFlags ? finalCrossControlProforma : '-',
                crossmanagementthresholdvsproforma: showThresholdFlags ? finalCrossManagementProforma : '-',
                crosscontrolthresholdvsforecast: showThresholdFlags ? finalCrossControlForecast : '-',
                crossmanagementthresholdvsforecast: showThresholdFlags ? finalCrossManagementForecast : '-',
                // Store showThresholdFlags to determine isBulk for upload
                showThresholdFlags: showThresholdFlags,
                ignore: false,
                message: '',
                __found: true
              };
              // Match helpers.js: Only set if different from DB AND not null/undefined
              if (el.commentary1 !== uploaddata[code][commentary1Index] && uploaddata[code][commentary1Index] !== "null" && uploaddata[code][commentary1Index] !== "undefined") {
                finaldata[code].commentary1 = uploaddata[code][commentary1Index];
              }
              if (el.commentary2 !== uploaddata[code][commentary2Index] && uploaddata[code][commentary2Index] !== "null" && uploaddata[code][commentary2Index] !== "undefined") {

                finaldata[code].commentary2 = uploaddata[code][commentary2Index];
              }
              finaldata[code].ignore = false;
              finaldata[code].message = "";
              let isValid = true;
              let isCommentary1Required = false;
              let isCommentary2Required = false;
              if (!(this.workflows.lcp || this.workflows.lmp)) {
                delete finaldata[code].commentary1
              }
              if (!(this.workflows.lcf || this.workflows.lmf)) {
                delete finaldata[code].commentary2
              }
              if ((this.ispreparer && (this.workflows.lcp || this.workflows.lmp) && (el.var1_cross_control || el.var1_cross_management || el.var1_cross_control_regional || el.var1_cross_management_regional))) {
                if (!finaldata[code].commentary1) {
                  finaldata[code].message = "Commentary1 required.";
                  isCommentary1Required = true;
                  finaldata[code].ignore = true;
                }
                else if (String(finaldata[code].commentary1).trim().length < 15) {
                  isCommentary1Required = true
                  finaldata[code].message = "Commentary1 minimum 15 characters required.";
                  finaldata[code].ignore = true;
                }
              }
              if ((this.ispreparer && (this.workflows.lcf || this.workflows.lmf) && (el.var2_cross_control || el.var2_cross_management)) || (this.isapprover && (this.workflows.rcf || this.workflows.rmf) && (el.var2_cross_control_regional || el.var2_cross_management_regional))) {
                if (!finaldata[code].commentary2) {
                  finaldata[code].message += "Commentary2 required.";
                  finaldata[code].ignore = true;
                  isCommentary2Required = true
                } else if (String(finaldata[code].commentary2).trim().length < 15) {
                  finaldata[code].message += "Commentary2 minimum 15 characters required.";
                  finaldata[code].ignore = true;
                  isCommentary2Required = true
                }
              }
              if (!isCommentary1Required && !isCommentary2Required) {
                finaldata[code].ignore = false;
                finaldata[code].message = "Ready to upload";
              }
              if (el.stage_local === 2) {
                finaldata[code].ignore = true;
                finaldata[code].message = "Ignored because local approve completed";
              } else if (el.stage_local === 3) {
                isValid = true;
              } else if (el.stage_local === 4) {
                isValid = true;
              } else if (el.__stage === 9 || el.stage_local === 5) {
                finaldata[code].ignore = true;
                finaldata[code].message = "Ignored because not in scope";
                isValid = false;
              } else if (el.__stage === 1 && finaldata[code].ignore === true) {
                finaldata[code].message = "Ignored because commentary already submitted";
              }
              finaldata[code].code = code;
              finaldata[code].glcode = glcode;
              finaldata[code].name = el.glcode_detail?.name;
              if (!code) {
                haserror = true;
                finaldata[code].error = "GL Code not found";
              } else {
                finaldata[code].__found = true;
              }
              if (!isValid) delete finaldata[code];
              
            }
          }
          this.bulksubmitfiledataerror = haserror;
          this.bulksubmitfiledata = finaldata;
          Object.keys(finaldata).forEach((key) => {
            this.bulksubmitfiledataList.push(finaldata[key]);
          })
        } else throw new Error("Columns 'GL Code','Commentary 1','Commentary 2' are required in the same order");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.bulksubmitfiledatafile = null;
        this.bulksubmitloading = false;
      });
    }
  },
  readBulkSubmitisApprover() {
    const file = this.approverBulkSubmitDataFile;
    this.approverBulkSubmitFileDataListis = [];

    if (!(file && file.name) || this.approverBulkSubmitLoading) return;

    this.bulksubmitfiledataerrorisApprover = false;
    this.approverBulkSubmitLoading = true;
    
    // Column indices for approver template (21 columns):
    // 1: Client Code, 2: Description, 3: Actual Amount, 4: Proforma Amount, 
    // 5: Variance Amt(Act vs Pro), 6: Variance %(Act vs Pro),
    // 7: Cross Local Ctrl, 8: Cross Local Mngt, 9: Cross Regional Ctrl, 10: Cross Regional Mngt,
    // 11: Local Act vs Pro Commentary, 12: Regional Act vs Pro Commentary,
    // 13: Forecast Amount, 14: Variance Amt(Act vs For), 15: Variance %(Act vs For),
    // 16: Cross Local Ctrl, 17: Cross Local Mngt, 18: Cross Regional Ctrl, 19: Cross Regional Mngt,
    // 20: Local Act vs For Commentary, 21: Regional Act vs For Commentary
    const regionalCommentary1Index = 12; // Regional Act vs Pro Commentary
    const regionalCommentary2Index = 21; // Regional Act vs For Commentary
    
    const ext = (file.name || "").split(".").pop();

    const isValidExtension = ["xlsx", "xls", "xlsm", "xlsb"].includes(ext);
    if (!isValidExtension) {
      this.$store.commit("sbError", "Only xlsx,xls,xlsm,xlsb file extension supported");
      this.approverBulkSubmitLoading = false;
      return;
    }

    this.$nova.readExcelFile(file, "TOP SHEET")
      .then(dt => {
        // Validate column structure.
        // Note: The current approver download template includes the Status columns,
        // but we also tolerate older templates that may omit them.
        const normalizeCell = (cell) => {
          if (cell === null || cell === undefined) return '';
          if (typeof cell === 'string') return cell.trim();
          return cell;
        };
        const trimTrailingEmpties = (arr) => {
          const out = (arr || []).map(normalizeCell);
          while (out.length && (out[out.length - 1] === '' || out[out.length - 1] === undefined)) {
            out.pop();
          }
          return out;
        };

        const excelHeaderRow = trimTrailingEmpties(dt[4] || []);
        const expectedHeaderRowFull = trimTrailingEmpties(["", ...this.bulksubmitcolumns]);
        const expectedHeaderRowWithoutStatus = trimTrailingEmpties([
          "",
          ...this.bulksubmitcolumns.slice(0, Math.max(0, this.bulksubmitcolumns.length - 2)),
        ]);

        const matchesFull = JSON.stringify(excelHeaderRow) === JSON.stringify(expectedHeaderRowFull);
        const matchesWithoutStatus = JSON.stringify(excelHeaderRow) === JSON.stringify(expectedHeaderRowWithoutStatus);

        if (!matchesFull && !matchesWithoutStatus) {
          throw new Error("Columns structure mismatch. Please use the correct template.");
        }

        const gllist = [];
        const uploaddata = {};
        const finaldata = {};

        // Build GL list and upload data map
        for (let i = 5; i < dt.length; i++) {
          const el = dt[i];
          const glcode = (el[1] || "").toString();
          gllist.push(glcode);
          uploaddata[glcode] = el;
        }

        // Helper for commentary validation
        const isCommentaryValid = c => c && typeof c === "string" && c.trim().length >= 15;

        // Process commentary data
        for (const el of this.commentarydata) {
          const glcode = (el.glcode || "").toString();
          const code = (el.glcode_detail?.code || "").toString();

          if (!gllist.includes(code)) continue;

          const uploadRow = uploaddata[code];          
          // Determine if threshold flags should be shown based on role and stage
          // Approver: show flags only when stage_regional === 4 or 3
          const showThresholdFlags = this.isapprover && (el.stage_regional === 4 || el.stage_regional === 3);
          
          // Get threshold values from Excel upload at correct indices
          // Local threshold indices: 7, 8 for proforma; 16, 17 for forecast
          // Regional threshold indices: 9, 10 for proforma; 18, 19 for forecast
          const excelCrossLocalCtrlProforma = uploadRow[7];
          const excelCrossLocalMngtProforma = uploadRow[8];
          const excelCrossRegionalCtrlProforma = uploadRow[9];
          const excelCrossRegionalMngtProforma = uploadRow[10];
          const excelCrossLocalCtrlForecast = uploadRow[16];
          const excelCrossLocalMngtForecast = uploadRow[17];
          const excelCrossRegionalCtrlForecast = uploadRow[18];
          const excelCrossRegionalMngtForecast = uploadRow[19];
          
          // Convert DB values to Yes/No for comparison
          const dbCrossLocalCtrlProforma = el.var1_cross_control ? 'Yes' : 'No';
          const dbCrossLocalMngtProforma = el.var1_cross_management ? 'Yes' : 'No';
          const dbCrossRegionalCtrlProforma = el.var1_cross_control_regional ? 'Yes' : 'No';
          const dbCrossRegionalMngtProforma = el.var1_cross_management_regional ? 'Yes' : 'No';
          const dbCrossLocalCtrlForecast = el.var2_cross_control ? 'Yes' : 'No';
          const dbCrossLocalMngtForecast = el.var2_cross_management ? 'Yes' : 'No';
          const dbCrossRegionalCtrlForecast = el.var2_cross_control_regional ? 'Yes' : 'No';
          const dbCrossRegionalMngtForecast = el.var2_cross_management_regional ? 'Yes' : 'No';
          
          // Use Excel values if different from DB, otherwise use DB values
          const finalCrossLocalCtrlProforma = (excelCrossLocalCtrlProforma && excelCrossLocalCtrlProforma !== dbCrossLocalCtrlProforma) 
            ? excelCrossLocalCtrlProforma : dbCrossLocalCtrlProforma;
          const finalCrossLocalMngtProforma = (excelCrossLocalMngtProforma && excelCrossLocalMngtProforma !== dbCrossLocalMngtProforma) 
            ? excelCrossLocalMngtProforma : dbCrossLocalMngtProforma;
          const finalCrossRegionalCtrlProforma = (excelCrossRegionalCtrlProforma && excelCrossRegionalCtrlProforma !== dbCrossRegionalCtrlProforma) 
            ? excelCrossRegionalCtrlProforma : dbCrossRegionalCtrlProforma;
          const finalCrossRegionalMngtProforma = (excelCrossRegionalMngtProforma && excelCrossRegionalMngtProforma !== dbCrossRegionalMngtProforma) 
            ? excelCrossRegionalMngtProforma : dbCrossRegionalMngtProforma;
          const finalCrossLocalCtrlForecast = (excelCrossLocalCtrlForecast && excelCrossLocalCtrlForecast !== dbCrossLocalCtrlForecast) 
            ? excelCrossLocalCtrlForecast : dbCrossLocalCtrlForecast;
          const finalCrossLocalMngtForecast = (excelCrossLocalMngtForecast && excelCrossLocalMngtForecast !== dbCrossLocalMngtForecast) 
            ? excelCrossLocalMngtForecast : dbCrossLocalMngtForecast;
          const finalCrossRegionalCtrlForecast = (excelCrossRegionalCtrlForecast && excelCrossRegionalCtrlForecast !== dbCrossRegionalCtrlForecast) 
            ? excelCrossRegionalCtrlForecast : dbCrossRegionalCtrlForecast;
          const finalCrossRegionalMngtForecast = (excelCrossRegionalMngtForecast && excelCrossRegionalMngtForecast !== dbCrossRegionalMngtForecast) 
            ? excelCrossRegionalMngtForecast : dbCrossRegionalMngtForecast;
          
          // Build finaldata with all fields matching readBulkSubmit structure
          finaldata[code] = {
            _id: el._id,
            code: code,
            glcode: glcode,
            name: el.glcode_detail?.name,
            // Amount and variance fields with formatting
            actual_amount: this.$nova.formatCurrency((el.amount1 || 0).toFixed(1), '', false, true),
            proforma_amount: this.$nova.formatCurrency((el.amount2 || 0).toFixed(1), '', false, true),
            variance_amount1: this.$nova.formatCurrency((el.varianceamount1 || 0).toFixed(1), '', false, true),
            variance_percent1: this.formatPercent(el.variancepercent1 || 0),
            forecast_amount: this.$nova.formatCurrency((el.amount3 || 0).toFixed(1), '', false, true),
            variance_amount2: this.$nova.formatCurrency((el.varianceamount2 || 0).toFixed(1), '', false, true),
            variance_percent2: this.formatPercent(el.variancepercent2 || 0),
            // Threshold cross values - Local thresholds
            crosslocalctrlvsproforma: showThresholdFlags ? finalCrossLocalCtrlProforma : '-',
            crosslocalmngtvsproforma: showThresholdFlags ? finalCrossLocalMngtProforma : '-',
            crosslocalctrlvsforecast: showThresholdFlags ? finalCrossLocalCtrlForecast : '-',
            crosslocalmngtvsforecast: showThresholdFlags ? finalCrossLocalMngtForecast : '-',
            // Threshold cross values - Regional thresholds
            crossregionalctrlvsproforma: showThresholdFlags ? finalCrossRegionalCtrlProforma : '-',
            crossregionalmngtvsproforma: showThresholdFlags ? finalCrossRegionalMngtProforma : '-',
            crossregionalctrlvsforecast: showThresholdFlags ? finalCrossRegionalCtrlForecast : '-',
            crossregionalmngtvsforecast: showThresholdFlags ? finalCrossRegionalMngtForecast : '-',
            // Store showThresholdFlags to determine isBulk for upload
            showThresholdFlags: showThresholdFlags,
            ignore: false,
            message: '',
            __found: true
          };

          
          // Regional Commentary 1 - use regionalcommentary1 (no underscore) to match DB field name
          if (
            el.regionalcommentary1 !== uploadRow[regionalCommentary1Index] &&
            uploadRow[regionalCommentary1Index] &&
            uploadRow[regionalCommentary1Index] !== "null" &&
            uploadRow[regionalCommentary1Index] !== "undefined"
          ) {
            finaldata[code].regionalcommentary1 = uploadRow[regionalCommentary1Index];
          }

          // Regional Commentary 2 - use regionalcommentary2 (no underscore) to match DB field name
          if (
            el.regionalcommentary2 !== uploadRow[regionalCommentary2Index] &&
            uploadRow[regionalCommentary2Index] &&
            uploadRow[regionalCommentary2Index] !== "null" &&
            uploadRow[regionalCommentary2Index] !== "undefined"
          ) {
            finaldata[code].regionalcommentary2 = uploadRow[regionalCommentary2Index];
          }

          // Remove regional commentary fields if not required by workflow
          if (!(this.workflows.rcp || this.workflows.rmp)) delete finaldata[code].regionalcommentary1;
          if (!(this.workflows.rcf || this.workflows.rmf)) delete finaldata[code].regionalcommentary2;

          let isRegionalCommentary1Required = false;
          let isRegionalCommentary2Required = false;
          
          // Validation for regionalcommentary1 (Act vs Pro)
          if (
            this.isapprover &&
            (this.workflows.rcp || this.workflows.rmp) &&
            (el.var1_cross_control_regional || el.var1_cross_management_regional)
          ) {
            if (!finaldata[code].regionalcommentary1) {
              finaldata[code].message = "Regional Commentary 1 required.";
              finaldata[code].ignore = true;
              isRegionalCommentary1Required = true;
            } else if (!isCommentaryValid(finaldata[code].regionalcommentary1)) {
              finaldata[code].message = "Regional Commentary 1 minimum 15 characters required.";
              finaldata[code].ignore = true;
              isRegionalCommentary1Required = true;
            }
          }

          // Validation for regionalcommentary2 (Act vs For)
          if (
            this.isapprover &&
            (this.workflows.rcf || this.workflows.rmf) &&
            (el.var2_cross_control_regional || el.var2_cross_management_regional)
          ) {
            if (!finaldata[code].regionalcommentary2) {
              finaldata[code].message += "Regional Commentary 2 required.";
              finaldata[code].ignore = true;
              isRegionalCommentary2Required = true;
            } else if (!isCommentaryValid(finaldata[code].regionalcommentary2)) {
              finaldata[code].message += "Regional Commentary 2 minimum 15 characters required.";
              finaldata[code].ignore = true;
              isRegionalCommentary2Required = true;
            }
          }

          // Set ready message if valid
          if (!isRegionalCommentary1Required && !isRegionalCommentary2Required) {
            finaldata[code].ignore = false;
            finaldata[code].error = false;
            finaldata[code].message = "Ready to upload";
          }

          // Ignore based on stage - use stage_regional for approver
          let isValid = true;
          if (el.stage_regional === 2) {
            finaldata[code].ignore = true;
            finaldata[code].message = "Ignored because regional approve completed";
          } else if (el.stage_regional === 3) {
            // Allow submission for immaterial variance (voluntary)
            isValid = true;
          } else if (el.stage_regional === 4) {
            // Allow submission for no variance (voluntary)
            isValid = true;
          } else if (el.__stage === 9 || el.stage_regional === 5) {
            finaldata[code].ignore = true;
            finaldata[code].message = "Ignored because not in scope";
            isValid = false;
          } else if (el.__stage === 1 && finaldata[code].ignore === true) {
            finaldata[code].message = "Ignored because commentary already submitted";
          }

          if (!isValid) delete finaldata[code];
        }

        // Check for errors
        let haserrorshow = false;
        for (const code in finaldata) {
          if (finaldata[code].error) {
            haserrorshow = true;
            break;
          }
        }
        
        this.bulksubmitfiledataerrorisApprover = haserrorshow;
        this.approverBulkSubmitData = finaldata;
        this.approverBulkSubmitFileDataListis = Object.values(finaldata);
      })
      .catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      })
      .finally(() => {
        this.approverBulkSubmitDataFile = null;
        this.approverBulkSubmitLoading = false;
      });
  },
    /**
     * Parse a number from a string or formatted value
     * @param {*} value - The value to parse
     * @returns {Number} Parsed number or 0
     */
    parseNumber(value) {
      if (value === null || value === undefined || value === '') return 0;
      if (typeof value === 'number') return value;
      // Remove currency symbols, commas, and other formatting
      const cleaned = String(value).replace(/[^0-9.-]/g, '');
      const parsed = parseFloat(cleaned);
      return isNaN(parsed) ? 0 : parsed;
    },
    
    /**
     * Bulk upload commentary by GL code
     * @param {Boolean} isBulk - When true, includes threshold cross values for voluntary submissions
     */
  
    
    readBulkApproveLocal() {
      const file = this.bulkapprovelocalfiledatafile;
      if (!file?.name || this.bulkapprovelocalloading) {
        return;
      }
      
      this.bulkapprovelocalfiledataerror = false;
      this.bulkapprovelocalloading = true;
      
      Promise.resolve().then(() => {
        const ext = ((file || {}).name || '').split('.').pop();
        if (['xlsx', 'xls', 'xlsm', 'xlsb'].indexOf(ext) === -1) {
          throw new Error('Only xlsx,xls,xlsm,xlsb file extension supported');
        }
        return this.$nova.readExcelFile(file, 'TOP SHEET');
      }).then(excelData => {
        const sllist = [];
        const uploaddata = {};
        const finaldata = {};
        let haserror = false;
        
        // Build SL list from Excel
        for (let i = 5; i < excelData.length; i++) {
          const el = excelData[i];
          const slcode = (el[1] || '').toString();
          sllist.push(slcode);
          uploaddata[slcode] = el;
        }
        
        // Process each SL
        for (const el of this.commentarydata) {
          const code = (el.glcode_detail?.code || '').toString();
          
          if (sllist.includes(code)) {
            const uploadRow = uploaddata[code];
            finaldata[code] = {
              code: code,
              glcode: el.glcode,
              name: el.glcode_detail?.name,
              commentary1: el.commentary1 || '',
              commentary2: el.commentary2 || '',
              stage_local: el.stage_local,
              stage_regional: el.stage_regional,
              approvereason: uploadRow[10] || '', // Approve reason column
              ignore: false,
              message: 'Ready to process',
              __found: true
            };
            
            // Validation based on stage
            const hasValidStatus = 
              (this.isapprover && el.stage_local === 1) || 
              (this.isregionalapprover && el.stage_regional === 1);
            
            if (!hasValidStatus) {
              finaldata[code].ignore = true;
              finaldata[code].message = 'Not in awaiting approval status';
              finaldata[code].hasWarning = true;
              finaldata[code].warning = 'Not in awaiting approval status';
            }
            
            // Check threshold requirements for approval reason
            const requiresReason = 
              (this.isapprover && (el.var1_cross_control || el.var2_cross_control)) || 
              (this.isregionalapprover && (el.var1_cross_control_regional || el.var2_cross_control_regional));
            
            if (requiresReason && !finaldata[code].approvereason && hasValidStatus) {
              finaldata[code].ignore = true;
              finaldata[code].error = 'Approval reason required for threshold crossed items';
              finaldata[code].message = 'Approval reason required';
              haserror = true;
            }
          }
        }
        
        // Add missing SL entries
        for (const sl of sllist) {
          if (!finaldata[sl]) {
            finaldata[sl] = {
              code: sl,
              glcode: sl,
              __found: false,
              ignore: true,
              message: 'Client Code not found',
              error: true
            };
            haserror = true;
          }
        }
        
        this.bulkapprovelocalfiledataerror = haserror;
        this.bulkapprovelocalfiledata = finaldata;
      }).catch(err => {
        this.$store.commit('sbError', err?.message || err || 'Unknown error!');
      }).finally(() => {
        this.bulkapprovelocalfiledatafile = null;
        this.bulkapprovelocalloading = false;
      });
    },
    
    
    
    downloadExcelisApprover() {
      // Download Excel template for approver - matches helpers.js format with full column structure
      return Promise.resolve().then(() => {
        this.bulksubmitloading = true;
      }).then(() => {
        const styledxlsx = require('sheetjs-style');
        const workbook = styledxlsx.utils.book_new();
        const primarycolor = 'd8e8f0';
        const heading1 = 'bfffbf';
        const heading2 = 'E8EEFF';
        const heading3 = 'F2E1F5';
        const body1 = 'E3FFE3';
        const body2 = 'E8EEFF';
        const body3 = 'F2E1F5';
        const scolor = '078f0e';
        const ecolor = 'd11b1b';
        const runame = this.commentaryrudata?.code || 'Report';
        
        // Get period and year info from cycle data or SLData passed from Base.vue
        const periodName = this.commentarycycledata?.period_detail?.name || 
                          this.selectedCommentaryCycle?.period_detail?.name || 
                          this.SLData?.periodName ||
                          '';
        const yearName = this.commentarycycledata?.year_detail?.name || 
                        this.selectedCommentaryCycle?.year_detail?.name || 
                        this.SLData?.yearName ||
                        this.commentarycycledata?.year || 
                        this.selectedCommentaryCycle?.year || 
                        '';
        
        // Build subtitle with period, year and reporting type info
        const reportingTypeLabel = this.reportingType === 'bs' ? 'Balance Sheet' : 'Profit & Loss';
        let subtitle = this.cycletype;
        if (periodName) subtitle += ` - ${periodName}`;
        subtitle += ` - ${reportingTypeLabel} - Approver`;
        
        // Use bulksubmitcolumns set by openBulkCommentaryDialogLocal for consistent column structure
        // Columns: Client Code, Description, Actual Amount, Proforma Amount, Variance Amt, Variance %,
        // Cross Local Ctrl, Cross Local Mngt, Cross Regional Ctrl, Cross Regional Mngt,
        // Local Commentary 1, Regional Commentary 1, Forecast Amount, Variance Amt, Variance %,
        // Cross Local Ctrl, Cross Local Mngt, Cross Regional Ctrl, Cross Regional Mngt,
        // Local Commentary 2, Regional Commentary 2, Status Local, Status Regional
        
        const dt = [
          [''],
          ['', { v: this.commentaryrudata?.name || '', s: { font: { bold: true, sz: 20 } } }],
          ['', { v: subtitle, s: { font: { bold: true, sz: 14 } } }],
          [''],
          [
            '',
            { v: this.bulksubmitcolumns[0], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: this.bulksubmitcolumns[1], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: this.bulksubmitcolumns[2], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: this.bulksubmitcolumns[3], s: { font: { bold: true }, fill: { fgColor: { rgb: heading1 } } } },
            { v: this.bulksubmitcolumns[4], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: this.bulksubmitcolumns[5], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: this.bulksubmitcolumns[6], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: this.bulksubmitcolumns[7], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: this.bulksubmitcolumns[8], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: this.bulksubmitcolumns[9], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: this.bulksubmitcolumns[10], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: this.bulksubmitcolumns[11], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: this.bulksubmitcolumns[12], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: this.bulksubmitcolumns[13], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: this.bulksubmitcolumns[14], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: this.bulksubmitcolumns[15], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: this.bulksubmitcolumns[16], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: this.bulksubmitcolumns[17], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: this.bulksubmitcolumns[18], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: this.bulksubmitcolumns[19], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: this.bulksubmitcolumns[20], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: this.bulksubmitcolumns[21], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: this.bulksubmitcolumns[22], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } }
          ]
        ];
        
        // Always use all items (ungrouped view) for template regardless of current view
        for (const v of this.commentarydata) {
          if ((v.__stage === 5 || v.__stage === -2) && v.cycle) {
            const stageLocal = (v.stage_local === -1) ? 'No' : ((v.stage_local === 2) ? 'Yes' : '');
            const stageRegional = (v.stage_regional === -1) ? 'No' : ((v.stage_regional === 2) ? 'Yes' : '');
            
            dt.push([
              '',
              v.glcode_detail?.code,
              v.glcode_detail?.name,
              { v: this.$nova.formatCurrency((v.amount1 || 0).toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body1 } } } },
              { v: this.$nova.formatCurrency((v.amount2 || 0).toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body2 } } } },
              { v: this.$nova.formatCurrency((v.varianceamount1 || 0).toFixed(1), '', false, true), s: { font: { color: { rgb: (v.varianceamount1 > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body2 } } } },
              { v: this.$nova.formatCurrency((v.variancepercent1 || 0).toFixed(1), '', false, true) + ((v.variancepercent1 !== 0) ? '%' : ''), s: { font: { color: { rgb: (v.varianceamount1 > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_control ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_management ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_control_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_management_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.commentary1 || '', s: { fill: { fgColor: { rgb: body2 } } } },
              v.regionalcommentary1 || '',
              { v: this.$nova.formatCurrency((v.amount3 || 0).toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body3 } } } },
              { v: this.$nova.formatCurrency((v.varianceamount2 || 0).toFixed(1), '', false, true), s: { font: { color: { rgb: (v.varianceamount2 > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body3 } } } },
              { v: this.$nova.formatCurrency((v.variancepercent2 || 0).toFixed(1), '', false, true) + ((v.variancepercent2 !== 0) ? '%' : ''), s: { font: { color: { rgb: (v.varianceamount2 > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_control ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_management ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_control_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_management_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.commentary2 || '', s: { fill: { fgColor: { rgb: body3 } } } },
              v.regionalcommentary2 || '',
              this.getStageText ? this.getStageText(v.stage_local) : stageLocal,
              this.getStageText ? this.getStageText(v.stage_regional) : stageRegional
            ]);
          }
        }
        
        const worksheet = styledxlsx.utils.aoa_to_sheet(dt);
        styledxlsx.utils.book_append_sheet(workbook, worksheet, 'TOP SHEET');
        
        // Build filename with GL name, period, and year
        const glName = this.selectedGLCommentary?.glcode_detail?.name || 
                       this.selectedGLCommentary?.description || 
                       this.SLData?.glName || '';
        const glCode = this.selectedGLCommentary?.glcode_detail?.code || 
                       this.selectedGLCommentary?.glcode || '';
        const glPart = glCode ? `_${glCode}` : (glName ? `_${glName.replace(/[^a-zA-Z0-9]/g, '_')}` : '');
        const periodPart = periodName ? `_${periodName.replace(/[^a-zA-Z0-9]/g, '_')}` : '';
        const yearPart = yearName ? `_${yearName}` : '';
        const filename = `${runame}${glPart}${periodPart}${yearPart}_SL_Breakup_Approver.xlsx`;
        
        styledxlsx.writeFile(workbook, filename);
      }).catch(err => {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.error(err);
      }).finally(() => {
        this.bulksubmitloading = false;
      });
    },
    
   
    
    openBulkCommentaryDialogLocal() {
      if (this.workflows.islocalenabled) {
        this.bulksubmitdialog = true;
        this.bulksubmitfiledata = {};
        this.bulksubmitfiledataList = [];
        this.bulksubmitfiledataerror = false;
        this.bulksubmitfiledatafile = null;
        // Set bulksubmitcolumns based on cycletype - matching helpers.js but with Client Code instead of GL Code
        if (this.cycletype === 'Actual') {
          this.bulksubmitcolumns = [
            'Client Code', 'Description', 'Actual Amount', 'Proforma Amount',
            'Variance Amt(Act vs Pro)', 'Variance %(Act vs Pro)',
            'Cross Local Ctrl', 'Cross Local Mngt', 'Cross Regional Ctrl', 'Cross Regional Mngt',
            'Local Act vs Pro Commentary', 'Regional Act vs Pro Commentary',
            'Forecast Amount', 'Variance Amt(Act vs For)', 'Variance %(Act vs For)',
            'Cross Local Ctrl', 'Cross Local Mngt', 'Cross Regional Ctrl', 'Cross Regional Mngt',
            'Local Act vs For Commentary', 'Regional Act vs For Commentary',
            'Status Local', 'Status Regional'
          ];
        } else if (this.cycletype === 'Forecast') {
          this.bulksubmitcolumns = [
            'Client Code', 'Description', 'Forecast Amount', 'Proforma Amount',
            'Variance Amt(For vs Pro)', 'Variance %(For vs Pro)',
            'Cross Local Ctrl', 'Cross Local Mngt', 'Cross Regional Ctrl', 'Cross Regional Mngt',
            'Local For vs Pro Commentary', 'Regional For vs Pro Commentary',
            'Previous Forecast Amount', 'Variance Amt(For vs Prev For)', 'Variance %(For vs Prev For)',
            'Cross Local Ctrl', 'Cross Local Mngt', 'Cross Regional Ctrl', 'Cross Regional Mngt',
            'Local For vs Prev For Commentary', 'Regional For vs Prev For Commentary',
            'Status Local', 'Status Regional'
          ];
        }
      }
    },
    
    openBulkCommentaryDialogApprover() {
      if (this.workflows.isregionalenabled || this.workflows.islocalenabled) {
        this.approverBulkSubmitPop = true;
        this.approverBulkSubmitData = {};
        this.bulksubmitfiledataerrorisApprover = false;
        this.approverBulkSubmitFileDataListis = [];
        
        // Set bulksubmitcolumns for approver - same structure as preparer
        if (this.cycletype === 'Actual') {
          this.bulksubmitcolumns = [
            'Client Code', 'Description', 'Actual Amount', 'Proforma Amount',
            'Variance Amt(Act vs Pro)', 'Variance %(Act vs Pro)',
            'Cross Local Ctrl', 'Cross Local Mngt', 'Cross Regional Ctrl', 'Cross Regional Mngt',
            'Local Act vs Pro Commentary', 'Regional Act vs Pro Commentary',
            'Forecast Amount', 'Variance Amt(Act vs For)', 'Variance %(Act vs For)',
            'Cross Local Ctrl', 'Cross Local Mngt', 'Cross Regional Ctrl', 'Cross Regional Mngt',
            'Local Act vs For Commentary', 'Regional Act vs For Commentary',
            'Status Local', 'Status Regional'
          ];
        } else if (this.cycletype === 'Forecast') {
          this.bulksubmitcolumns = [
            'Client Code', 'Description', 'Forecast Amount', 'Proforma Amount',
            'Variance Amt(For vs Pro)', 'Variance %(For vs Pro)',
            'Cross Local Ctrl', 'Cross Local Mngt', 'Cross Regional Ctrl', 'Cross Regional Mngt',
            'Local For vs Pro Commentary', 'Regional For vs Pro Commentary',
            'Previous Forecast Amount', 'Variance Amt(For vs Prev For)', 'Variance %(For vs Prev For)',
            'Cross Local Ctrl', 'Cross Local Mngt', 'Cross Regional Ctrl', 'Cross Regional Mngt',
            'Local For vs Prev For Commentary', 'Regional For vs Prev For Commentary',
            'Status Local', 'Status Regional'
          ];
        }
      }
    },
    
    openBulkApproveDialog() {
      if ((this.isapprover && this.workflows.islocalenabled) || (this.isregionalapprover && this.workflows.isregionalenabled)) {
        this.bulkapprovelocaldialog = true;
        this.bulkapprovelocalfiledata = {};
      }
    },
    
    getNetSalesData() {
      this.$store.commit('sbInfo', 'Net sales data view is available in the main analysis page');
    },
    
    getRevenueData() {
      this.$store.commit('sbInfo', 'Revenue data view is available in the main analysis page');
    },
    
    // ===== Commentary Dialog Handlers =====
    toggleLocalCommentaryCollapse() {
      this.isLocalCommentaryCollapsed = !this.isLocalCommentaryCollapsed;
    },
    
    toggleLocalCommentaryReasonCollapse() {
      this.isLocalCommentaryReasonCollapsed = !this.isLocalCommentaryReasonCollapsed;
    },
    
    async handleGenerateAI({ commentary, slot, mode }) {
      const normalizedVariant = (slot || '').toLowerCase() === 'forecast' ? 'forecast' : 'proforma';
      try {
        await this.generateAI({
          variant: normalizedVariant,
          commentaryOverride: commentary || null,
          requestType: mode || '',
        });
      } catch (error) {
        console.error('[GLBreakdown]: handleGenerateAI failed', error);
      }
    },
    
    async handleGenerateAISummary({ commentary, slot, mode }) {
      const normalizedVariant = (slot || '').toLowerCase() === 'forecast' ? 'forecast' : 'proforma';
      try {
        await this.generateAISummary({
          variant: normalizedVariant,
          commentaryOverride: commentary || null,
          requestType: mode || '',
        });
      } catch (error) {
        console.error('[GLBreakdown]: handleGenerateAISummary failed', error);
      }
    },
    
    handleAttachmentChange(file) {
      this.attachmentfile = file;
    },

    /**
     * Handle reject with target selection for regional approvers
     * @param {string} targetId - The rejection target ('local_approver' or 'local_preparer')
     */
    handleRejectWithTarget(targetId) {
      this.rejectCommentaryMenu = false;
      this.rejectCommentary(targetId);
    },

    /**
     * Upload attachment file for the selected commentary
     * @param {string} id - The commentary ID to attach the file to
     */
    uploadAttachmentFile(id) {
      if (this.attachmentfileloading === false && this.attachmentfile) {
        this.attachmentfileloading = true;
        this.attachmentfilepercentage = 0;
        let file = this.attachmentfile || {};
        let fileUpDetil = {};
        const axiosInstance = this.axios || this.$axios || this.$http;
        
        this.$nova.uploadFile(axiosInstance, file, {
          progressfunction: (e) => {
            let p = (e.loaded * 100) / e.total;
            this.attachmentfilepercentage = p.toFixed(0);
          },
        })
          .then((dt) => {
            if (dt.data.status === 'success') {
              fileUpDetil = dt.data.data;
              // Build filter with optional reporting_type for Balance Sheet
              const attachFilter = { cycletype: this.cycletype };
              if (this.reportingType) {
                attachFilter.reporting_type = this.reportingType;
              }
              return axiosInstance.post('/v3/varianceanalysis/analysis/attachfiles/' + id, { 
                data: { uploads: fileUpDetil._id }, 
                filter: attachFilter 
              });
            } else {
              throw new Error('Unable to upload file');
            }
          })
          .then((dt) => {
            if (dt.data.status === 'success') {
              this.selectedcommentary.upload = fileUpDetil._id;
              this.$store.commit('sbSuccess', 'File Uploaded');
            } else {
              throw new Error(dt.data.message || 'Error storing file');
            }
          })
          .catch((err) => {
            this.$store.commit('sbError', err.message || err || 'Unknown error!');
          })
          .finally(() => {
            this.attachmentfile = null;
            this.attachmentfileloading = false;
          });
      }
    },

    /**
     * Handle successful evidence file upload from Evidence component
     * Refreshes GL details to get updated upload_details from API
     * @param {Array<string>} uploadIds - Array of uploaded file IDs
     */
    async handleEvidenceUploadSuccess(uploadIds) {
      
      // Optimistically update uploads array
      if (!this.selectedcommentary.uploads) {
        this.selectedcommentary.uploads = [];
      }
      this.selectedcommentary.uploads = [...this.selectedcommentary.uploads, ...uploadIds];
      
      // Preserve unsaved commentary text before refreshing from API
      // loadGLDetails overwrites selectedcommentary with server data, losing unsaved edits
      const unsavedFields = {
        commentary1: this.selectedcommentary.commentary1,
        commentary2: this.selectedcommentary.commentary2,
        approvereason: this.selectedcommentary.approvereason,
        savedreason: this.selectedcommentary.savedreason,
        regionalcommentary1: this.selectedcommentary.regionalcommentary1,
        regionalcommentary2: this.selectedcommentary.regionalcommentary2,
        regionalapprovereason: this.selectedcommentary.regionalapprovereason,
        savedregionalreason: this.selectedcommentary.savedregionalreason,
      };
      
      // Refresh GL details to get updated upload_details from API
      await this.loadGLDetails(false);
      
      // Restore unsaved commentary fields that were overwritten by the API refresh
      for (const [key, value] of Object.entries(unsavedFields)) {
        if (value !== undefined && value !== null) {
          this.$set(this.selectedcommentary, key, value);
        }
      }
    },
    
    handleGenerateAISection(type, apltype) {
      const fallbackVariant = type === 'Two' ? 'forecast' : 'proforma';
      const normalizedVariant = (apltype || '').toLowerCase() || fallbackVariant;
      this.generateAI({ variant: normalizedVariant });
    },
    
    async generateAI({ variant, commentaryOverride = null, requestType = '' } = {}) {
      const normalizedVariant = String(variant || '').toLowerCase();
      if (!normalizedVariant) {
        this.$store.commit('sbInfo', 'Select a commentary type to generate.');
        return;
      }

      if (this.isThresholdExceedCommentary) {
        this.$store.commit('sbError', 'Threshold exceeded. Gen AI summarisation is disabled.');
        return;
      }

      const select = commentaryOverride || this.activeCommentary;
      if (!select || !select.glcode_detail) {
        this.$store.commit('sbError', 'No SL code selected for AI generation.');
        return;
      }

      const cycleId = this.commentarycycledata._id || this.cycleId;
      const glcodeId = select.glcode_detail?._id;
      if (!cycleId || !glcodeId) {
        this.$store.commit('sbError', 'No cycle context available for AI generation.');
        return;
      }

      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for AI generation.');
        return;
      }

      if (this.typingFrame) {
        cancelAnimationFrame(this.typingFrame);
        this.typingFrame = null;
      }
      this.shouldStop = true;

      if (normalizedVariant === 'proforma') {
        this.aiProforma = '';
      } else if (normalizedVariant === 'forecast') {
        this.aiForecast = '';
      }

      try {
        await this.generateSlCommentaryAiAction({
          axios: axiosInstance,
          cycleId,
          glcodeId,
          variant: normalizedVariant,
          featureName: this.commentaryStatusData?.name || '',
          requestType,
          resource: this.isRevenue ? 'revenue' : 'netsales',
        });
      } catch (error) {
        console.error('[GLBreakdown]: generateAI failed', error);
      } finally {
        this.shouldStop = false;
      }
    },

    async generateAISummary({ variant, commentaryOverride = null, requestType = '' } = {}) {
      const normalizedVariant = String(variant || '').toLowerCase();
      if (!normalizedVariant) {
        this.$store.commit('sbInfo', 'Select a commentary type to generate.');
        return;
      }

      if (this.isThresholdExceedJVSummarisation) {
        this.$store.commit('sbError', 'Threshold exceeded. Gen AI summarisation is disabled.');
        return;
      }

      const select = commentaryOverride || this.activeCommentary;
      if (!select || !select.glcode_detail) {
        this.$store.commit('sbError', 'No SL code selected for AI generation.');
        return;
      }

      const cycleId = this.commentarycycledata._id || this.cycleId;
      const glcodeId = select.glcode_detail?._id;
      if (!cycleId || !glcodeId) {
        this.$store.commit('sbError', 'No cycle context available for AI generation.');
        return;
      }

      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for AI generation.');
        return;
      }

      if (normalizedVariant === 'proforma') {
        this.summaryAiProforma = '';
      } else if (normalizedVariant === 'forecast') {
        this.summaryAiForecast = '';
      }

      try {
        await this.generateSlCommentarySummaryAction({
          axios: axiosInstance,
          cycleId,
          glcodeId,
          variant: normalizedVariant,
          featureName: this.commentaryStatusData?.name || '',
          requestType,
        });
      } catch (error) {
        console.error('[GLBreakdown]: generateAISummary failed', error);
      }
    },
    
    typeEffect(type) {
      if (this.shouldStop || this.index >= this.aiResponseText.length) {
        this.isTyping = false;
        return;
      }

      if (type === 'One') {
        this.aiProforma += this.aiResponseText[this.index];
      } else {
        this.aiForecast += this.aiResponseText[this.index];
      }
      this.index++;

      this.typingFrame = requestAnimationFrame(() => {
        setTimeout(() => this.typeEffect(type), this.speed);
      });
    },
    
    // ===== Commentary CRUD Operations =====
    async approveCommentary() {
      this.commentaryloading = true;
      this.approveLoading = true;
      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for approval.');
        this.commentaryloading = false;
        this.approveLoading = false;
        return;
      }

      try {
        const isBulk = this.bulksubmit;
        const payload = isBulk ? this.multiselectdata : this.selectedcommentary?._id;
        if (!payload) {
          throw new Error('No commentary selected for approval');
        }

        // Determine if this is a local or regional approval based on commentarytype or __myaction
        const isLocalApproval = isBulk 
          ? this.bulktype === 'approvelocal'
          : (this.commentarytype === 'approvelocal' || 
             this.commentarytype === 'localapprove' ||
             this.selectedcommentary.__myaction === 'localapprove');
        
        // Validate approval reason for Local Approver
        if (isLocalApproval && (!this.selectedcommentary?.approvereason || !this.selectedcommentary?.approvereason.trim())) {
          this.$store.commit('sbError', 'Approval reason is required.');
          this.validationErrorField = 'local_approval_reason';
          setTimeout(() => { this.validationErrorField = ''; }, 2000);
          this.commentaryloading = false;
          this.approveLoading = false;
          return;
        }

        // Validate approval reason for Regional Approver (NEW)
        if (!isLocalApproval && (!this.selectedcommentary?.regionalapprovereason || !this.selectedcommentary?.regionalapprovereason.trim())) {
          this.$store.commit('sbError', 'Regional Approval reason is required.');
          this.validationErrorField = 'regional_approval_reason';
          setTimeout(() => { this.validationErrorField = ''; }, 2000);
          this.commentaryloading = false;
          this.approveLoading = false;
          return;
        }

        // Determine role based on approval type
        const role = isLocalApproval ? 'approver' : 'regionalapprover';
        
        // Build approval reason data - exactly like helpers.js
        let data = {};
        if (isLocalApproval) {
          data = { approvereason: this.selectedcommentary?.approvereason || '' };
        } else {
          // Regional approval
          data = { regionalapprovereason: this.selectedcommentary?.regionalapprovereason || '' };
        }
        
        const filter = {
          cycletype: this.cycletype,
          level: isLocalApproval ? 'local' : 'regional',
          reportingunit: this.reportingunitId,
          period: this.periodId,
          type: this.type,
          glcode: this.glcodeId,
          reporting_type: this.reportingType || 'pl',
        };

        const success = await this.approveSlCommentaryAction({
          axios: axiosInstance,
          payload,
          isBulk,
          role,
          filter,
          data,
        });

        if (success) {
          this.commantorydialog = false;
          // Refresh GL details to update the Commentary tab (with loader)
          await this.loadGLDetails(true);
          // SLBreakup handles drilldown data refresh independently
        }
      } catch (error) {
        console.error('[GLBreakdown]: approveCommentary failed', error);
      } finally {
        this.commentaryloading = false;
        this.approveLoading = false;
      }
    },
    
    async rejectCommentary(rejectTarget) {
      this.commentaryloading = true;
      this.rejectLoading = true;
      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for rejection.');
        this.commentaryloading = false;
        this.rejectLoading = false;
        return;
      }

      try {
        const isBulk = this.bulksubmit;
        const payload = isBulk ? this.multiselectdata : this.selectedcommentary?._id;
        if (!payload) {
          throw new Error('No commentary selected for rejection');
        }

        // Note: __myaction uses 'localapprove' not 'approvelocal'
        const isLocalRejection = 
          this.bulktype === 'approvelocal' || 
          this.commentarytype === 'approvelocal' ||
          this.selectedcommentary?.__myaction === 'localapprove';
          
        // Validate rejection reason for Local Approver
        if (isLocalRejection && (!this.selectedcommentary?.approvereason || !this.selectedcommentary?.approvereason.trim())) {
          this.$store.commit('sbError', 'Rejection reason is required.');
          this.validationErrorField = 'local_approval_reason';
          setTimeout(() => { this.validationErrorField = ''; }, 2000);
          this.commentaryloading = false;
          this.rejectLoading = false;
          return;
        }

        // Validate rejection reason for Regional Approver (NEW)
        // Note: Regional approver uses 'regionalapprovereason' for both approve and reject logic in UI
        if (!isLocalRejection && (!this.selectedcommentary?.regionalapprovereason || !this.selectedcommentary?.regionalapprovereason.trim())) {
          this.$store.commit('sbError', 'Regional Rejection reason is required.');
          this.validationErrorField = 'regional_approval_reason';
          setTimeout(() => { this.validationErrorField = ''; }, 2000);
          this.commentaryloading = false;
          this.rejectLoading = false;
          return;
        }
        
        // Set role based on actual rejection level, not just user's overall role
        const role = isLocalRejection ? 'approver' : 'regionalapprover';


        // Build reject data - exactly like helpers.js rejectCommentary
        // For regional approvers, include rejection_target to specify where to reject to
        let data = {};
        if (isBulk) {
          if (this.bulktype === 'approvelocal') {
            data = { rejectreason: this.selectedcommentary?.approvereason || '' };
          } else {
            // Regional rejection (bulk) - include rejection_target
            data = { 
              rejectreason: this.selectedcommentary?.regionalapprovereason || '',
              rejection_target: rejectTarget
            };
          }
        } else {
          if (isLocalRejection) {
            data = { rejectreason: this.selectedcommentary?.approvereason || '' };
          } else {
            // Regional rejection (single) - include rejection_target
            data = { 
              rejectreason: this.selectedcommentary?.regionalapprovereason || '',
              rejection_target: rejectTarget
            };
          }
        }

        const filter = {
          cycletype: this.cycletype,
          level: isLocalRejection ? 'local' : 'regional',
          reportingunit: this.reportingunitId,
          period: this.periodId,
          type: this.type,
          glcode: this.glcodeId,
          reporting_type: this.reportingType || 'pl',
        };

        const success = await this.rejectSlCommentaryAction({
          axios: axiosInstance,
          payload,
          isBulk,
          role,
          filter,
          data,
        });

        if (success) {
          // Optimistic UI update for RA→LP / RA→LA so reason shows before getgldetails returns
          if (!isLocalRejection && this.selectedcommentary) {
            const reason = (data.rejectreason || '').trim();
            this.$set(this.selectedcommentary, 'regionalrejectreason', reason);
            this.$set(this.selectedcommentary, 'regionalapprovereason', '');
            if (rejectTarget === 'local_preparer') {
              this.$set(this.selectedcommentary, 'stage_local', -1);
              this.$set(this.selectedcommentary, 'stage_regional', 0);
            } else if (rejectTarget === 'local_approver') {
              this.$set(this.selectedcommentary, 'stage_regional', -1);
            }
            this.lastActionsOnGL = this.mergeLastActionsFromStageAndLogs(
              this.selectedcommentary,
              this.trendlineLogs
            );
          }
          this.commantorydialog = false;
          // Refresh GL details to update the Commentary tab (with loader)
          await this.loadGLDetails(true);
          // SLBreakup handles drilldown data refresh independently
        }
      } catch (error) {
        console.error('[GLBreakdown]: rejectCommentary failed', error);
      } finally {
        this.commentaryloading = false;
        this.rejectLoading = false;
      }
    },
    
    async saveCommentary(field) {
      this.commentaryloading = true;
      this.saveLoading = true;
      this.saveLocalCommentaryField = field || '';
      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for saving commentary.');
        this.commentaryloading = false;
        this.saveLoading = false;
        this.saveLocalCommentaryField = '';
        return;
      }

      try {
        const isBulk = this.bulksubmit;
        const targetId = isBulk ? this.multiselectdata : this.selectedcommentary?._id;
        if (!targetId) {
          throw new Error('No commentary selected for save');
        }

        const baseUrl = isBulk
          ? '/v3/varianceanalysis/analysis/addbulkcommentary'
          : `/v3/varianceanalysis/analysis/addcommentary/${targetId}`;

        const isShortOnly = (text) => text && text.trim().length > 0 && text.trim().length < 15;

        if (this.ispreparer && (!field || field === 'proforma') && isShortOnly(this.selectedcommentary?.commentary1)) {
           this.$store.commit('sbError', `${this.proformaLabel} commentary too short (min 15 chars).`);
           this.validationErrorField = 'local_proforma';
           setTimeout(() => { this.validationErrorField = ''; }, 2000);
           this.commentaryloading = false;
           this.saveLoading = false;
           this.saveLocalCommentaryField = '';
           return;
        }
        if (this.ispreparer && (!field || field === 'forecast') && isShortOnly(this.selectedcommentary?.commentary2)) {
           this.$store.commit('sbError', `${this.forecastLabel} commentary too short (min 15 chars).`);
           this.validationErrorField = 'local_forecast';
           setTimeout(() => { this.validationErrorField = ''; }, 2000);
           this.commentaryloading = false;
           this.saveLoading = false;
           this.saveLocalCommentaryField = '';
           return;
        }

        const thresholdcross = this.ispreparer ? {
          crosscontrolthresholdvsproforma: this.requestcommentarylocalcontrolvsProforma,
          crosscontrolthresholdvsforecast: this.requestcommentarylocalcontrolvsForecast,
          crossmanagementthresholdvsproforma: this.requestcommentarylocalmanagementvsProforma,
          crossmanagementthresholdvsforecast: this.requestcommentarylocalmanagementvsForecast,
        } : {};

        const filter = {
          save: true,
          cycletype: this.cycletype,
          all: this.bulkcommentall,
          replace: this.bulkcommentreplace,
          reportingunit: this.reportingunitId,
          type: this.type,
          glcode: this.glcodeId,
          reporting_type: this.reportingType || 'pl',
        };
        if (field === 'proforma' || field === 'forecast') {
          filter.commentaryField = field;
        }

        const data = {
          commentary1: String(this.selectedcommentary?.commentary1 ?? '').trim(),
          commentary2: String(this.selectedcommentary?.commentary2 ?? '').trim(),
          summarycommentary1: String(this.summaryAiProforma ?? '').trim(),
          summarycommentary2: String(this.summaryAiForecast ?? '').trim(),
        };

        const body = {
          id: targetId,
          filter: {
            ...filter,
            ...thresholdcross,
          },
          data: {
            ...data,
          },
        };

        const success = await this.saveSlCommentaryAction({
          axios: axiosInstance,
          url: baseUrl,
          body,
        });

        if (success && this.selectedcommentary) {
          if (field === 'proforma' || field === 'forecast') {
            const savedValue1 = (this.selectedcommentary.commentary1 || '').trim();
            const savedValue2 = (this.selectedcommentary.commentary2 || '').trim();
            this.selectedcommentary.savedcommentary1 = savedValue1;
            this.selectedcommentary.savedcommentary2 = savedValue2;
            this.updateCommentaryBaseline('commentary1', savedValue1);
            this.updateCommentaryBaseline('commentary2', savedValue2);
          } else {
            await this.loadGLDetails(true);
            this.selectedcommentary.savedcommentary1 = (this.selectedcommentary.commentary1 || '').trim();
            this.selectedcommentary.savedcommentary2 = (this.selectedcommentary.commentary2 || '').trim();
            this.captureCommentaryBaselines();
          }
        }
      } catch (error) {
        console.error('[GLBreakdown]: saveCommentary failed', error);
      } finally {
        this.commentaryloading = false;
        this.saveLoading = false;
        this.saveLocalCommentaryField = '';
      }
    },

    async saveRegionalCommentary(field) {
      this.commentaryloading = true;
      this.saveLoading = true;
      this.saveRegionalCommentaryField = field || '';
      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for saving regional commentary.');
        this.commentaryloading = false;
        this.saveLoading = false;
        this.saveRegionalCommentaryField = '';
        return;
      }

      try {
        const targetId = this.selectedcommentary?._id;
        if (!targetId) {
          throw new Error('No commentary selected for regional save');
        }

        const baseUrl = `/v3/varianceanalysis/analysis/addcommentary/${targetId}`;

        const isShortOnly = (text) => text && text.trim().length > 0 && text.trim().length < 15;

        if ((!field || field === 'proforma') && isShortOnly(this.selectedcommentary?.regionalcommentary1)) {
           this.$store.commit('sbError', `${this.proformaLabel} regional commentary too short (min 15 chars).`);
           this.validationErrorField = 'regional_proforma';
           setTimeout(() => { this.validationErrorField = ''; }, 2000);
           this.commentaryloading = false;
           this.saveLoading = false;
           this.saveRegionalCommentaryField = '';
           return;
        }
        if ((!field || field === 'forecast') && isShortOnly(this.selectedcommentary?.regionalcommentary2)) {
           this.$store.commit('sbError', `${this.forecastLabel} regional commentary too short (min 15 chars).`);
           this.validationErrorField = 'regional_forecast';
           setTimeout(() => { this.validationErrorField = ''; }, 2000);
           this.commentaryloading = false;
           this.saveLoading = false;
           this.saveRegionalCommentaryField = '';
           return;
        }

        const filter = {
          save: true,
          saveType: 'regional_commentary',
          commentaryField: field, // 'proforma' or 'forecast'
          cycletype: this.cycletype,
          reportingunit: this.reportingunitId,
          type: this.type,
          glcode: this.glcodeId,
          reporting_type: this.reportingType || 'pl',
        };

        const data = {};
        
        // Only send the field being saved
        if (field === 'proforma') {
          data.regionalcommentary1 = String(this.selectedcommentary?.regionalcommentary1 ?? '').trim();
        } else if (field === 'forecast') {
          data.regionalcommentary2 = String(this.selectedcommentary?.regionalcommentary2 ?? '').trim();
        }

        const body = {
          id: targetId,
          filter: {
            ...filter,
          },
          data: {
            ...data,
          },
        };

        const success = await this.saveSlCommentaryAction({
          axios: axiosInstance,
          url: baseUrl,
          body,
        });

        if (success && this.selectedcommentary) {
          if (field === 'proforma') {
            const savedValue = (this.selectedcommentary.regionalcommentary1 || '').trim();
            this.selectedcommentary.savedregionalcommentary1 = savedValue;
            this.updateCommentaryBaseline('regionalcommentary1', savedValue);
          } else if (field === 'forecast') {
            const savedValue = (this.selectedcommentary.regionalcommentary2 || '').trim();
            this.selectedcommentary.savedregionalcommentary2 = savedValue;
            this.updateCommentaryBaseline('regionalcommentary2', savedValue);
          }
        }
      } catch (error) {
        console.error('[GLBreakdown]: saveRegionalCommentary failed', error);
      } finally {
        this.commentaryloading = false;
        this.saveLoading = false;
        this.saveRegionalCommentaryField = '';
      }
    },

    async saveRegionalApprovalReason() {
      const reason = (this.selectedcommentary?.regionalapprovereason || '').trim();
      if (!reason) {
        this.$store.commit('sbError', SL_COMMENTARY.MESSAGES.SAVE_REASON_VALIDATION);
        return;
      }

      const targetId = this.selectedcommentary?._id;
      if (!targetId) {
        this.$store.commit('sbError', SL_COMMENTARY.MESSAGES.SAVE_REASON_ERROR);
        return;
      }

      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', SL_COMMENTARY.MESSAGES.SAVE_REASON_ERROR);
        return;
      }

      this.saveRegionalReasonLoading = true;
      try {
        const body = {
          id: targetId,
          filter: {
            saveType: 'regional_reason',
            cycletype: this.cycletype,
            reportingunit: this.reportingunitId,
            type: this.type,
            glcode: this.glcodeId,
            reporting_type: this.reportingType || 'pl',
          },
          data: [{
            regionalapprovereason: reason,
          }],
        };

        const success = await this.saveRegionalApprovalReasonAction({
          axios: axiosInstance,
          url: `${SL_COMMENTARY.ENDPOINTS.SAVE_APPROVAL_REASON}/${targetId}`,
          body,
        });

        if (success) {
          this.selectedcommentary.savedregionalreason = reason;
          this.updateCommentaryBaseline('regionalapprovereason', reason);
          this.$store.commit('varianceanalysis/updateSelectedGLCommentary', {
            ...this.selectedcommentary,
            savedregionalreason: reason,
          });
        }
      } catch (error) {
        console.error('[GLBreakdown]: saveRegionalApprovalReason failed', error);
      } finally {
        this.saveRegionalReasonLoading = false;
      }
    },

    async saveLocalApprovalReason() {
      const reason = (this.selectedcommentary?.approvereason || '').trim();
      if (!reason) {
        this.$store.commit('sbError', SL_COMMENTARY.MESSAGES.SAVE_REASON_VALIDATION);
        return;
      }

      const targetId = this.selectedcommentary?._id;
      if (!targetId) {
        this.$store.commit('sbError', SL_COMMENTARY.MESSAGES.SAVE_REASON_ERROR);
        return;
      }

      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', SL_COMMENTARY.MESSAGES.SAVE_REASON_ERROR);
        return;
      }

      this.saveLocalReasonLoading = true;
      try {
        const body = {
          id: targetId,
          filter: {
            saveType: 'local_reason',
            cycletype: this.cycletype,
            reportingunit: this.reportingunitId,
            type: this.type,
            glcode: this.glcodeId,
            reporting_type: this.reportingType || 'pl',
          },
          data: [{
            approvereason: reason,
          }],
        };

        const success = await this.saveRegionalApprovalReasonAction({
          axios: axiosInstance,
          url: `${SL_COMMENTARY.ENDPOINTS.SAVE_APPROVAL_REASON}/${targetId}`,
          body,
        });

        if (success) {
          this.selectedcommentary.savedreason = reason;
          this.updateCommentaryBaseline('approvereason', reason);
          this.$store.commit('varianceanalysis/updateSelectedGLCommentary', {
            ...this.selectedcommentary,
            savedreason: reason,
          });
        }
      } catch (error) {
        console.error('[GLBreakdown]: saveLocalApprovalReason failed', error);
      } finally {
        this.saveLocalReasonLoading = false;
      }
    },

    confirmUnsavedCommentaryNavigation() {
      this.unsavedCommentaryDialog = false;
      const pending = this.pendingNavigation;
      this.pendingNavigation = null;
      this.skipUnsavedNavigationCheck = true;

      // Set flag to allow navigation through the beforeRouteLeave guard
      this.allowRouteLeave = true;

      if (pending?.type === 'back') {
        this.$store.commit('varianceanalysis/setSkipReloadOnBack', true);
        this.$router.back();
        return;
      }

      if (pending?.fullPath) {
        this.$router.push(pending);
      }
    },

    cancelUnsavedCommentaryNavigation() {
      this.unsavedCommentaryDialog = false;
      this.pendingNavigation = null;
      this.allowRouteLeave = false; // Ensure flag is reset when user cancels navigation
    },
    
    async addCommentary() {
      this.commentaryloading = true;
      this.submitLoading = true;
      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for adding commentary.');
        this.commentaryloading = false;
        this.submitLoading = false;
        return;
      }
      try {
        const isBulk = this.bulksubmit;
        const regionalSubmitActions = ['regionaladd', 'regionalvoluntary'];
        const isRegionalSubmit = regionalSubmitActions.includes(this.selectedcommentary?.__myaction);

        if (isRegionalSubmit && !this.isRegionalPreparer) {
          this.$store.commit('sbError', 'Only the local approver can submit regional commentary.');
          this.commentaryloading = false;
          this.submitLoading = false;
          return;
        }

        const url = isBulk
          ? '/v3/varianceanalysis/analysis/addbulkcommentary'
          : `/v3/varianceanalysis/analysis/addcommentary/${this.selectedcommentary._id}`;
        
        const id = isBulk ? this.multiselectdata : this.selectedcommentary._id;
        
        // Validation helpers
        const isShortOnly = (text) => text && text.trim().length > 0 && text.trim().length < 15;
        const isShortOrEmpty = (text) => !text || text.trim().length < 15;

        // Build threshold cross data
        const thresholdcross = (this.ispreparer || this.isapprover) ? {
          crosscontrolthresholdvsproforma: this.requestcommentarylocalcontrolvsProforma,
          crosscontrolthresholdvsforecast: this.requestcommentarylocalcontrolvsForecast,
          crossmanagementthresholdvsproforma: this.requestcommentarylocalmanagementvsProforma,
          crossmanagementthresholdvsforecast: this.requestcommentarylocalmanagementvsForecast
        } : {};
        
        // Validation helpers
        const hasThreshold = () => Object.values(thresholdcross).some(Boolean);
        const hasItemThreshold = () => {
          const item = this.selectedcommentary;
          return item.var1_cross_control || item.var1_cross_management ||
                 item.var2_cross_control || item.var2_cross_management;
        };
        
        // Local preparer checks commentary1/commentary2 only.
        // Regional commentary is checked only for the local approver (isRegionalPreparer).
        const isProformaMandatory = isBulk || this.selectedcommentary.var1_cross_control || this.selectedcommentary.var1_cross_management;
        const preparerProformaInvalid = this.ispreparer && (
          isProformaMandatory
            ? isShortOrEmpty(this.selectedcommentary?.commentary1)
            : isShortOnly(this.selectedcommentary?.commentary1)
        );
        
        const isForecastMandatory = isBulk || this.selectedcommentary.var2_cross_control || this.selectedcommentary.var2_cross_management;
        const preparerForecastInvalid = this.ispreparer && (
          isForecastMandatory
            ? isShortOrEmpty(this.selectedcommentary?.commentary2)
            : isShortOnly(this.selectedcommentary?.commentary2)
        );
        
        const isRegionalProformaMandatory = isBulk || this.selectedcommentary.var1_cross_management_regional || this.selectedcommentary.var1_cross_control_regional;
        const approverProformaInvalid = this.isRegionalPreparer && (
          isRegionalProformaMandatory
            ? isShortOrEmpty(this.selectedcommentary?.regionalcommentary1)
            : isShortOnly(this.selectedcommentary?.regionalcommentary1)
        );
        
        const isRegionalForecastMandatory = isBulk || this.selectedcommentary.var2_cross_management_regional || this.selectedcommentary.var2_cross_control_regional;
        const approverForecastInvalid = this.isRegionalPreparer && (
          isRegionalForecastMandatory
            ? isShortOrEmpty(this.selectedcommentary?.regionalcommentary2)
            : isShortOnly(this.selectedcommentary?.regionalcommentary2)
        );
        
        // Validation for voluntary submissions
        const isVoluntary = this.selectedcommentary.stage_local === 3 || this.selectedcommentary.stage_local === 4;
        if (this.ispreparer && !hasThreshold() && !isBulk && !hasItemThreshold() && isVoluntary) {
          this.$store.commit('sbError', 'Voluntary commentary submission reason is required.');
          this.commentaryloading = false;
          this.submitLoading = false;
          return;
        }
        
        if (preparerProformaInvalid || approverProformaInvalid) {
          this.$store.commit('sbError', `${this.proformaLabel} commentary is required (min 15 chars).`);
          this.validationErrorField = preparerProformaInvalid ? 'local_proforma' : 'regional_proforma';
          // Clear after animation creates effect
          setTimeout(() => { this.validationErrorField = ''; }, 2000);
          this.commentaryloading = false;
          this.submitLoading = false;
          return;
        }
        
        if (preparerForecastInvalid || approverForecastInvalid) {
          this.$store.commit('sbError', `${this.forecastLabel} commentary is required (min 15 chars).`);
          this.validationErrorField = preparerForecastInvalid ? 'local_forecast' : 'regional_forecast';
          setTimeout(() => { this.validationErrorField = ''; }, 2000);
          this.commentaryloading = false;
          this.submitLoading = false;
          return;
        }
        
        // Calculate voluntary submit flag matched with helpers.js
        let isVolunterySubmit = false;
        if (this.ispreparer && !isBulk) {
          if ([3, 4, 5].indexOf(this.selectedcommentary?.stage_local) > -1) {
            isVolunterySubmit = true;
          }
        }

        // Build data payload
        const dta = this.isRegionalPreparer && isRegionalSubmit ? {
          regionalcommentary1: this.selectedcommentary?.regionalcommentary1?.trim() || '',
          regionalcommentary2: this.selectedcommentary?.regionalcommentary2?.trim() || ''
        } : this.ispreparer ? {
          commentary1: this.selectedcommentary?.commentary1?.trim() || '',
          commentary2: this.selectedcommentary?.commentary2?.trim() || '',
          isvolunterysubmit: isVolunterySubmit
        } : {};
        
        const body = {
          id,
          filter: {
            regional: Boolean(this.isRegionalPreparer && isRegionalSubmit),
            cycletype: this.cycletype,
            all: this.bulkcommentall,
            replace: this.bulkcommentreplace,
            ...thresholdcross,
            reportingunit: this.reportingunitId,
            type: this.type,
            glcode: this.glcodeId,
            reporting_type: this.reportingType || 'pl',
          },
          data: dta,
        };

        const success = await this.addSlCommentaryAction({
          axios: axiosInstance,
          url,
          body,
        });

        if (success) {
          this.commantorydialog = false;
          // Refresh GL details to update the Commentary tab (with loader)
          await this.loadGLDetails(true);
          // SLBreakup handles drilldown data refresh independently
        }
      } catch (error) {
        console.error('[GLBreakdown]: addCommentary failed', error);
      } finally {
        this.commentaryloading = false;
        this.submitLoading = false;
      }
    },
  },
  
  beforeDestroy() {
    if (this.typingFrame) {
      cancelAnimationFrame(this.typingFrame);
    }
    this.shouldStop = true;
    this.isSummaryExpanded = true;
    
    // Reset cycle data to prevent stale state
    this.commentarycycledata = {};
  },
  beforeRouteLeave(to, from, next) {
    // Allow navigation if user confirmed they want to leave despite unsaved changes
    if (this.allowRouteLeave) {
      this.allowRouteLeave = false; // Reset flag for next navigation
      next();
      return;
    }

    // Check if we should skip the unsaved changes check
    if (this.skipUnsavedNavigationCheck) {
      this.skipUnsavedNavigationCheck = false;
      next();
      return;
    }

    // Check for unsaved commentary changes
    if (this.hasUnsavedCommentaryChanges) {
      this.pendingNavigation = to;
      this.unsavedCommentaryDialog = true;
      next(false);
      return;
    }

    // Only skip reload when navigating back to Analysis (Actual/Forecast) pages.
    // If the user navigates to Reports or any other page, do NOT keep this flag,
    // otherwise Filter.vue will restore the old Base filters and never reset.
    const toPath = (to && to.path) ? String(to.path) : '';
    const isGoingToAnalysis =
      toPath.indexOf('/varianceanalysis/actualanalysis') === 0 ||
      toPath.indexOf('/varianceanalysis/forecastanalysis') === 0;

    this.$store.commit('varianceanalysis/setSkipReloadOnBack', isGoingToAnalysis);

    // If leaving the Analysis flow entirely, clear the cached Base page state.
    if (!isGoingToAnalysis) {
      this.$store.commit('varianceanalysis/clearBasePageState');
    }
    next();
  },
};
</script>

<style scoped lang="scss">
/* Commentary Actions Border */
.border-top {
  border-top: 1px solid #e0e0e0;
}

/* Summary card styles */
.summary-card {
  background: #ffffff;
  padding: 16px;
  border-radius: var(--Space-sm, 12px);
  border: 1px solid var(--Background-default, #F7F7F7);
  box-shadow: 4px 4px 20px 0 rgba(0, 0, 0, 0.08);
}

.summary-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.summary-card__header:focus {
  outline: none;
}

.summary-card__header:focus-visible {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.4);
  border-radius: 8px;
}

.summary-card__body {
  width: 100%;
}

/* Card wrapper for GLActionToolbar and RUDataTable */
.sl-data-card {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

.sl-toolbar-shimmer {
  background: #fafafa;
  margin: -16px;
  margin-bottom: 0;
  padding: 0;
}

.sl-table-shimmer {
  min-height: 500px;
  margin: -16px;
  margin-top: 0;
}

.sl-table-header-shimmer {
  border-bottom: 2px solid #e5e7eb;
}

.sl-table-row-shimmer {
  border-bottom: 1px solid #f3f4f6;
}

.sl-table-row-shimmer:last-child {
  border-bottom: none;
}

/* Gap utility class for flexbox */
.gap-2 {
  gap: 8px;
}

.gap-3 {
  gap: 12px;
}

.revenue-breakup-page,
.netsales-breakup-page {
  width: 100%;
  height: 100%;
  padding: 0;
}

.parent-row {
  cursor: pointer;
  font-weight: 500;
  background-color: #f5f5f5;
  
  &:hover {
    background-color: #eeeeee;
  }
}

.child-row {
  background-color: #fafafa;
}

.toggle-btn {
  width: 24px;
  height: 24px;
}

.table-wrapper,
.table-wrapper-ungrouped {
  width: 100%;
  overflow-x: auto;
}

.skeleton-textarea {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 12px;
}

.noTransform {
  text-transform: none;
}

.font-size-md {
  font-size: 16px;
  font-weight: 500;
}

.revenue-summary__header,
.netsales-summary__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 16px;
}

.summary-code {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.summary-description {
  color: #6b7280;
  font-size: 14px;
  margin-top: 4px;
}

.summary-chip {
  display: flex;
  align-items: center;
}

.revenue-summary__grid,
.netsales-summary__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
}

.summary-panel__title {
  font-weight: 600;
}

.summary-panel__metrics {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sl-commentary-card {
  background: #ffffff;
  border-radius: 12px;
}

.sl-commentary-status {
  gap: 16px;
}

.summary-metric {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
}

.summary-metric__label {
  font-size: 14px;
  color: var(--color-status-card-text);
  font-weight: 600;
}

.summary-metric__value {
  font-size: 14px;
  font-weight: 600;
  color: #404047;
}

.summary-metric__separator {
  margin: 0 8px;
  color: #9ca3af;
}

.summary-commentary {
  background: #ffffff;
  border-radius: 10px;
  padding: 16px;
  border: 1px solid #e5e7eb;
}

.summary-commentary__label {
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.summary-commentary__text {
  font-size: 14px;
  color: #1f2937;
  line-height: 1.6;
  white-space: pre-line;
}

.summary-commentary__text--empty {
  color: #9ca3af;
  font-style: italic;
}

.gl-breakdown__tabs .v-tab{
  font-size: var(--font-size-sm, 16px);
  font-weight: 400;
  color: var(--color-tabs-header);
  padding: var(--space-2) var(--space-8);
  letter-spacing: normal;
}
.gl-breakdown__tabs .v-tab--active{
  font-weight: 600;
  color: var(--color-tabs-header-active);
}
.gl-breakdown-card {
  padding: var(--space-9) var(--space-6);
}

/* Rejection target item styles */
.rejection-target-item {
  transition: background-color 0.2s ease;
}

.rejection-target-item:hover {
  background-color: rgba(244, 67, 54, 0.08);
}
</style>